import React, { useState, useMemo, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, doc, getDoc, getDocs, addDoc, setDoc, deleteDoc, serverTimestamp, query, orderBy, limit as fsLimit } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, auth, functions, VIDEOS_COLLECTION, VIDEOS_DOC_ID, TEXTS_COLLECTION, TEXTS_DOC_ID, DEFAULT_TAB_TEXTS } from "../firebase";

// Extrae el ID de YouTube desde URL completa o desde un ID puro.
const extractYoutubeId = (input) => {
  if (!input) return null;
  const s = String(input).trim();
  if (!s) return null;
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  const m = s.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
};

function MultiCurrencyNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const seen = localStorage.getItem("finanzas_currency_notice_v1");
      if (!seen) setShow(true);
    } catch (e) { /* localStorage no disponible */ }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem("finanzas_currency_notice_v1", "1"); } catch (e) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: "20px",
      backdropFilter: "blur(2px)",
    }}>
      <div style={{
        background: "#fff", maxWidth: "460px", width: "100%",
        borderRadius: "16px", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
      }}>
        <div style={{
          background: "linear-gradient(135deg, #8a5d4a, #b5836d)", color: "#fff",
          padding: "20px 24px", textAlign: "center",
        }}>
          <div style={{ fontSize: "36px", marginBottom: "4px" }}>🌎</div>
          <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 700, fontFamily: "'Libre Baskerville','Georgia',serif" }}>
            Esta herramienta es multimoneda
          </h2>
        </div>
        <div style={{ padding: "20px 24px", fontFamily: "'DM Sans',sans-serif", fontSize: "13px", color: "#2d2a26", lineHeight: 1.6 }}>
          <p style={{ margin: "0 0 12px 0" }}>
            Vas a ver el símbolo <strong>$</strong> en toda la app, pero <strong>no representa una moneda específica</strong>. Es solo un placeholder visual.
          </p>
          <p style={{ margin: "0 0 12px 0" }}>
            <strong>La moneda la definen los valores que ingresás vos</strong>:
          </p>
          <ul style={{ margin: "0 0 12px 0", paddingLeft: "22px" }}>
            <li style={{ marginBottom: "4px" }}>Pesos chilenos (CLP) → ej: $1.500.000</li>
            <li style={{ marginBottom: "4px" }}>Pesos mexicanos (MXN) → ej: $50.000</li>
            <li style={{ marginBottom: "4px" }}>Pesos colombianos (COP) → ej: $5.000.000</li>
            <li style={{ marginBottom: "4px" }}>Dólares (USD) o Euros (EUR) → ej: $1.500</li>
            <li style={{ marginBottom: "4px" }}>Pesos argentinos (ARS), reales (BRL), etc.</li>
          </ul>
          <p style={{ margin: "0 0 12px 0" }}>
            La <strong>regla clave</strong>: usá <strong>la misma moneda en TODOS los campos</strong> de cada herramienta. Las fórmulas funcionan igual para cualquier divisa.
          </p>
          <div style={{ padding: "10px 12px", background: "#faf8f6", borderRadius: "8px", fontSize: "12px", color: "#7a756e", marginBottom: "12px" }}>
            💡 No mezcles: si pusiste tus gastos fijos en CLP, tu food cost también va en CLP.
          </div>
          <div style={{ padding: "10px 12px", background: "#b5836d11", borderRadius: "8px", fontSize: "12px", color: "#2d2a26", marginBottom: "16px", border: "1px solid #b5836d33" }}>
            <strong>💱 Selector de moneda:</strong> en el menú lateral podés elegir entre CLP, MXN, COP, ARS, PEN, USD, EUR, BRL. Cambia el símbolo y el formato de números en toda la app y en los Excel que exportes.
          </div>
          <button onClick={dismiss} style={{
            width: "100%", padding: "12px", border: "none", borderRadius: "10px", cursor: "pointer",
            background: "linear-gradient(135deg, #b5836d, #8a5d4a)", color: "#fff",
            fontFamily: "'DM Sans',sans-serif", fontSize: "14px", fontWeight: 700,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}>Entendido, empezar</button>
        </div>
      </div>
    </div>
  );
}

function TabDescription({ text }) {
  const [open, setOpen] = useState(true);
  if (!text || !text.trim()) return null;
  // Heurística: si el texto contiene tags HTML, renderizalo como HTML.
  // Si no, preservamos saltos de línea con white-space: pre-wrap.
  const looksLikeHtml = /<\/?(p|br|ul|ol|li|strong|em|a|h[1-6]|div|span)\b/i.test(text);
  return (
    <div style={{ marginBottom: "14px", borderRadius: "12px", overflow: "hidden", border: `1.5px solid #b5836d33`, background: "#b5836d08" }}>
      <button onClick={() => setOpen(!open)} style={{
        width: "100%", padding: "10px 14px", border: "none", background: "transparent",
        cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center",
        justifyContent: "space-between", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: "#8a5d4a",
      }}>
        <span>📖 Sobre esta sección</span>
        <span style={{ fontSize: "11px" }}>{open ? "▼" : "▶"}</span>
      </button>
      {open && (
        looksLikeHtml ? (
          <div
            className="tab-description-html"
            style={{
              padding: "0 16px 14px 16px",
              fontFamily: "'DM Sans',sans-serif", fontSize: "13px", color: "#2d2a26",
              lineHeight: 1.55,
            }}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ) : (
          <div style={{
            padding: "0 16px 14px 16px",
            fontFamily: "'DM Sans',sans-serif", fontSize: "13px", color: "#2d2a26",
            lineHeight: 1.55, whiteSpace: "pre-wrap",
          }}>
            {text}
          </div>
        )
      )}
    </div>
  );
}

function TutorialVideo({ videoIdOrUrl, label }) {
  const [open, setOpen] = useState(false);
  const id = extractYoutubeId(videoIdOrUrl);
  if (!id) return null;
  return (
    <div style={{ marginBottom: "14px", borderRadius: "12px", overflow: "hidden", border: `1.5px solid #b5836d33`, background: "#b5836d0a" }}>
      <button onClick={() => setOpen(!open)} style={{
        width: "100%", padding: "12px 16px", border: "none", background: "transparent",
        cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center",
        justifyContent: "space-between", fontFamily: "'DM Sans',sans-serif", fontSize: "13px", fontWeight: 700, color: "#8a5d4a",
      }}>
        <span>🎥 Ver video explicativo{label ? ` — ${label}` : ""}</span>
        <span style={{ fontSize: "11px" }}>{open ? "▼" : "▶"}</span>
      </button>
      {open && (
        <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden", background: "#000" }}>
          <iframe
            src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`}
            title={label || "Video explicativo"}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }}
          />
        </div>
      )}
    </div>
  );
}

const RECIPE_LIMIT = 15;
const EMPTY_RECIPE = () => ({
  name: "Nueva receta",
  portions: 12,
  pv: 1990,
  ingredients: [
    { name: "", qty: 0, unit: "g", pkgSize: 1000, pkgPrice: 0 },
    { name: "", qty: 0, unit: "g", pkgSize: 1000, pkgPrice: 0 },
    { name: "", qty: 0, unit: "g", pkgSize: 1000, pkgPrice: 0 },
  ],
});

/* ═══════════════════════════════════════════
   SHARED DESIGN SYSTEM
   ═══════════════════════════════════════════ */
const C = {
  copper: "#b5836d", copperLight: "#d4a88e", copperDark: "#8a5d4a",
  dark: "#2d2a26", muted: "#7a756e", bg: "#faf8f6", card: "#ffffff", line: "#ebe5df",
  green: "#4a9c6d", greenBg: "#edf7f0", red: "#c0392b", redBg: "#fdf0ee",
  amber: "#d4910a", amberBg: "#fef9ed", blue: "#2e86c1", blueBg: "#eaf2fa",
};

// === MULTIMONEDA ===
// Cambia el símbolo + locale (formato de miles/decimales) según la elección del usuario.
// Los valores que el usuario ingresa son los que definen la moneda — el sistema solo
// formatea correctamente y muestra el símbolo apropiado.
// El campo `scale` ajusta automáticamente el rango y step de los sliders/inputs
// según la denominación típica de la moneda. Los valores nominales por defecto del
// código están pensados para CLP (scale = 1). Para monedas de menor denominación
// el scale es más chico → el slider se mueve en pasos más finos.
const CURRENCIES = {
  CLP: { code: "CLP", symbol: "$",  locale: "es-CL", flag: "🇨🇱", name: "Peso chileno",     scale: 1,     decimals: 0 },
  MXN: { code: "MXN", symbol: "$",  locale: "es-MX", flag: "🇲🇽", name: "Peso mexicano",    scale: 0.05,  decimals: 2 },
  COP: { code: "COP", symbol: "$",  locale: "es-CO", flag: "🇨🇴", name: "Peso colombiano",  scale: 1,     decimals: 0 },
  ARS: { code: "ARS", symbol: "$",  locale: "es-AR", flag: "🇦🇷", name: "Peso argentino",   scale: 1,     decimals: 0 },
  PEN: { code: "PEN", symbol: "S/", locale: "es-PE", flag: "🇵🇪", name: "Sol peruano",      scale: 0.005, decimals: 2 },
  USD: { code: "USD", symbol: "$",  locale: "en-US", flag: "🇺🇸", name: "Dólar EE.UU.",     scale: 0.001, decimals: 2 },
  EUR: { code: "EUR", symbol: "€",  locale: "es-ES", flag: "🇪🇺", name: "Euro",             scale: 0.001, decimals: 2 },
  BRL: { code: "BRL", symbol: "R$", locale: "pt-BR", flag: "🇧🇷", name: "Real brasileño",   scale: 0.005, decimals: 2 },
};
// Vars mutables que las funciones de formato leen en cada llamada.
// Se actualizan ANTES de que React re-renderice cuando el usuario cambia moneda.
let CURRENT_LOCALE = "es-CL";
let CURRENT_SYMBOL = "$";
let CURRENT_SCALE = 1;
let CURRENT_DECIMALS = 0;
function loadInitialCurrency() {
  try {
    const code = localStorage.getItem("finanzas_currency");
    if (code && CURRENCIES[code]) return CURRENCIES[code];
  } catch (e) { /* localStorage no disponible */ }
  return CURRENCIES.CLP;
}
// Aplicar la moneda guardada al cargar el módulo (antes del primer render).
(() => {
  const c = loadInitialCurrency();
  CURRENT_LOCALE = c.locale;
  CURRENT_SYMBOL = c.symbol;
  CURRENT_SCALE = c.scale || 1;
  CURRENT_DECIMALS = c.decimals ?? 0;
})();
// Ajusta un step nominal (pensado en CLP) al rango de la moneda actual.
const scaleStep = (s) => Math.max(0.01, s * CURRENT_SCALE);
const scaleMin = (m) => m * CURRENT_SCALE;
const scaleMax = (m) => m * CURRENT_SCALE;

const fmt = (n) => {
  if (n == null || isNaN(n)) return `${CURRENT_SYMBOL}0`;
  // Decimals 0 (CLP/COP/ARS) → redondeo a entero. Otherwise mantenemos los decimales.
  const v = CURRENT_DECIMALS === 0 ? Math.round(n) : n;
  const a = Math.abs(v);
  const s = a.toLocaleString(CURRENT_LOCALE, {
    minimumFractionDigits: CURRENT_DECIMALS,
    maximumFractionDigits: CURRENT_DECIMALS,
  });
  return v < 0 ? `(${CURRENT_SYMBOL}${s})` : `${CURRENT_SYMBOL}${s}`;
};
const pct = (n, t) => (t === 0 ? "—" : `${((n / t) * 100).toFixed(1)}%`);

function NumInput({ value, onChange, prefix = CURRENT_SYMBOL, min = 0, max = 99999999, step = 1000, small }) {
  // Ajustar step a la denominación de la moneda actual (sliders pensados en CLP)
  const sStep = scaleStep(step);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
      {prefix && <span style={{ fontSize: "12px", color: C.muted, fontWeight: 600 }}>{prefix}</span>}
      <input type="number" value={value} min={min} max={max} step={sStep}
        onChange={(e) => onChange(Math.max(min, Number(e.target.value)))}
        style={{
          width: "100%", padding: small ? "5px 6px" : "7px 8px", border: `1.5px solid ${C.line}`, borderRadius: "6px",
          fontSize: small ? "12px" : "14px", fontWeight: 600, color: C.dark, background: "#fdfcfb",
          fontFamily: "'DM Sans',sans-serif", outline: "none", textAlign: "right",
        }}
        onFocus={e => e.target.style.borderColor = C.copper}
        onBlur={e => e.target.style.borderColor = C.line}
      />
    </div>
  );
}

function Card({ children, title, style: s }) {
  return (
    <div style={{ background: C.card, borderRadius: "14px", padding: "20px", boxShadow: "0 2px 16px rgba(0,0,0,0.05)", border: `1px solid ${C.line}`, marginBottom: "14px", ...s }}>
      {title && <div style={{ fontSize: "12px", fontWeight: 700, color: C.copper, textTransform: "uppercase", letterSpacing: "0.1em", fontFamily: "'DM Sans',sans-serif", marginBottom: "12px" }}>{title}</div>}
      {children}
    </div>
  );
}

function StatCard({ label, value, sub, color, bgColor, icon }) {
  return (
    <div style={{ padding: "12px 10px", borderRadius: "12px", background: bgColor, border: `1.5px solid ${color}22`, textAlign: "center", flex: 1, minWidth: "110px" }}>
      <div style={{ fontSize: "18px", marginBottom: "3px" }}>{icon}</div>
      <div style={{ fontSize: "10px", fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.06em", fontFamily: "'DM Sans',sans-serif", marginBottom: "3px" }}>{label}</div>
      <div style={{ fontSize: "17px", fontWeight: 700, color, fontFamily: "'DM Sans',sans-serif" }}>{value}</div>
      {sub && <div style={{ fontSize: "11px", color, fontWeight: 600, opacity: 0.7, fontFamily: "'DM Sans',sans-serif" }}>{sub}</div>}
    </div>
  );
}

function Slider({ value, onChange, min, max, step, label, prefix = CURRENT_SYMBOL, suffix = "", color = C.copper, unscaled = false }) {
  // Si el prefix es el símbolo de moneda, asumimos que min/max/step están pensados en CLP
  // y los escalamos a la denominación de la moneda actual.
  // unscaled=true desactiva esto (ej. para valores ilustrativos de oferta/demanda).
  const isMoney = !unscaled && (prefix === CURRENT_SYMBOL || prefix === "$");
  const sMin = isMoney ? scaleMin(min) : min;
  const sMax = isMoney ? scaleMax(max) : max;
  const sStep = isMoney ? scaleStep(step) : step;
  const safeMax = Math.max(sMax, value);  // si value > sMax, agrandar para que entre
  const pctW = sMax > sMin ? ((value - sMin) / (safeMax - sMin)) * 100 : 0;
  return (
    <div style={{ marginBottom: "14px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "4px" }}>
        <label style={{ fontSize: "12px", fontWeight: 600, color: C.dark, letterSpacing: "0.03em", textTransform: "uppercase", fontFamily: "'DM Sans',sans-serif" }}>{label}</label>
        <span style={{ fontSize: "18px", fontWeight: 700, color, fontFamily: "'Georgia',serif" }}>{prefix}{value.toLocaleString(CURRENT_LOCALE)}{suffix}</span>
      </div>
      <input type="range" min={sMin} max={safeMax} step={sStep} value={value} onChange={e => onChange(Number(e.target.value))}
        style={{ width: "100%", height: "6px", borderRadius: "3px", appearance: "none", outline: "none", cursor: "pointer",
          background: `linear-gradient(90deg, ${color} ${pctW}%, #e0d6cf ${pctW}%)` }} />
    </div>
  );
}


/* ═══════════════════════════════════════════
   TOOL 1: FOOD COST & MARGEN
   ═══════════════════════════════════════════ */
const DEFAULT_ING = [
  { name: "Harina", qty: 554, unit: "g", pkgSize: 1000, pkgPrice: 1300 },
  { name: "Azúcar", qty: 272, unit: "g", pkgSize: 1000, pkgPrice: 1000 },
  { name: "Huevos", qty: 133, unit: "g", pkgSize: 2400, pkgPrice: 6850 },
  { name: "Mantequilla", qty: 75, unit: "g", pkgSize: 250, pkgPrice: 2490 },
  { name: "Arándanos", qty: 129, unit: "g", pkgSize: 454, pkgPrice: 2750 },
  { name: "Yogur", qty: 337, unit: "g", pkgSize: 155, pkgPrice: 400 },
  { name: "Vainilla", qty: 24, unit: "ml", pkgSize: 17, pkgPrice: 1239 },
  { name: "Polvo hornear", qty: 33, unit: "g", pkgSize: 100, pkgPrice: 789 },
];

function ToolFoodCost({ user }) {
  const [tab, setTab] = useState("simple");
  const [pv, setPv] = useState(1990);
  const [fc, setFc] = useState(453);
  const [units, setUnits] = useState(12);
  const [ings, setIngs] = useState(DEFAULT_ING);
  const [recipeName, setRecipeName] = useState("Muffins de Arándano");

  // Recetas guardadas en Firestore
  const [savedRecipes, setSavedRecipes] = useState([]);
  const [activeRecipeId, setActiveRecipeId] = useState(null);
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);
  const [feedback, setFeedback] = useState(null); // { kind: 'ok'|'err', msg }
  const skipDirty = useRef(false);

  const showFeedback = (kind, msg) => {
    setFeedback({ kind, msg });
    setTimeout(() => setFeedback(null), 3000);
  };

  // Cargar recetas del usuario al montar — sin orderBy para no perder docs sin updatedAt
  useEffect(() => {
    const uid = user?.uid || auth.currentUser?.uid;
    if (!uid) return;
    (async () => {
      try {
        const q = query(collection(db, "users", uid, "recipes"), fsLimit(100));
        const snap = await getDocs(q);
        const ms = (t) => t?.toMillis?.() ?? (t?.seconds ? t.seconds * 1000 : 0);
        const recipes = snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .sort((a, b) => (ms(b.updatedAt) || ms(b.createdAt)) - (ms(a.updatedAt) || ms(a.createdAt)));
        console.log(`[Recetas] cargadas ${recipes.length} de Firestore`, recipes.map(r => r.name));
        setSavedRecipes(recipes);
      } catch (e) {
        console.error("Cargar recetas:", e, "uid:", uid, "authCurrent:", auth.currentUser?.uid);
      }
    })();
  }, [user?.uid]);

  // Marcar dirty cuando cambian campos relevantes (también para recetas nuevas sin id)
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) { isFirstRender.current = false; return; }
    if (skipDirty.current) { skipDirty.current = false; return; }
    setDirty(true);
  }, [recipeName, units, pv, ings, activeRecipeId]);

  const recipeCost = ings.reduce((s, i) => s + (i.pkgSize > 0 ? (i.qty / i.pkgSize) * i.pkgPrice : 0), 0);
  const costUnit = tab === "receta" ? (units > 0 ? recipeCost / units : 0) : fc;
  const margin = pv - costUnit;
  const fcPct = pv > 0 ? (costUnit / pv) * 100 : 0;
  const mPct = pv > 0 ? (margin / pv) * 100 : 0;
  const statusColor = fcPct < 25 ? C.green : fcPct < 35 ? C.amber : C.red;
  const statusText = fcPct < 25 ? "Excelente" : fcPct < 35 ? "Aceptable" : "Peligroso";
  const statusEmoji = fcPct < 25 ? "🟢" : fcPct < 35 ? "🟡" : "🔴";

  const upIng = (i, patch) => { const n = [...ings]; n[i] = { ...n[i], ...patch }; setIngs(n); };
  const removeIng = (i) => { if (ings.length > 1) setIngs(ings.filter((_, idx) => idx !== i)); };
  const addIng = () => setIngs([...ings, { name: "Nuevo ingrediente", qty: 0, unit: "g", pkgSize: 1000, pkgPrice: 0 }]);

  // Aplica una receta al estado local sin marcar dirty
  const loadRecipeIntoState = (r) => {
    skipDirty.current = true;
    setRecipeName(r.name || "Sin nombre");
    setUnits(r.portions || 1);
    setPv(r.pv || 0);
    setIngs((r.ingredients && r.ingredients.length > 0) ? r.ingredients : EMPTY_RECIPE().ingredients);
    setActiveRecipeId(r.id || null);
    setDirty(false);
  };

  const handleSelectRecipe = (id) => {
    if (!id) return;
    const r = savedRecipes.find(x => x.id === id);
    if (!r) return;
    if (dirty && !window.confirm("Tenés cambios sin guardar. ¿Cargar otra receta y descartarlos?")) return;
    loadRecipeIntoState(r);
  };

  const handleNew = () => {
    if (dirty && !window.confirm("Tenés cambios sin guardar. ¿Crear una nueva y descartarlos?")) return;
    const e = EMPTY_RECIPE();
    skipDirty.current = true;
    setRecipeName(e.name);
    setUnits(e.portions);
    setPv(e.pv);
    setIngs(e.ingredients);
    setActiveRecipeId(null);
    setDirty(false);
  };

  const getUid = () => user?.uid || auth.currentUser?.uid;

  const handleSave = async () => {
    const uid = getUid();
    if (!uid) { showFeedback("err", "Tenés que estar logueado para guardar."); return; }
    setBusy(true);
    try {
      const payload = {
        name: recipeName || "Sin nombre",
        portions: units,
        pv,
        ingredients: ings,
        updatedAt: serverTimestamp(),
      };
      if (activeRecipeId) {
        await setDoc(doc(db, "users", uid, "recipes", activeRecipeId), payload, { merge: true });
        setSavedRecipes(prev => prev.map(r => r.id === activeRecipeId ? { ...r, ...payload, updatedAt: new Date() } : r));
        showFeedback("ok", "Receta actualizada ✓");
      } else {
        if (savedRecipes.length >= RECIPE_LIMIT) { showFeedback("err", `Llegaste al límite de ${RECIPE_LIMIT} recetas. Eliminá alguna primero.`); setBusy(false); return; }
        const ref = await addDoc(collection(db, "users", uid, "recipes"), { ...payload, createdAt: serverTimestamp() });
        setActiveRecipeId(ref.id);
        setSavedRecipes(prev => [{ id: ref.id, ...payload, updatedAt: new Date() }, ...prev]);
        showFeedback("ok", "Receta guardada ✓");
      }
      setDirty(false);
    } catch (e) {
      console.error("Guardar:", e, "uid:", uid); showFeedback("err", `Error al guardar: ${e.code || e.message}`);
    } finally { setBusy(false); }
  };

  const handleSaveAs = async () => {
    const uid = getUid();
    if (!uid) { showFeedback("err", "Tenés que estar logueado para guardar."); return; }
    if (savedRecipes.length >= RECIPE_LIMIT) { showFeedback("err", `Llegaste al límite de ${RECIPE_LIMIT} recetas.`); return; }
    const newName = window.prompt("Nombre de la nueva receta:", recipeName + " (copia)");
    if (!newName) return;
    setBusy(true);
    try {
      const payload = {
        name: newName, portions: units, pv, ingredients: ings,
        createdAt: serverTimestamp(), updatedAt: serverTimestamp(),
      };
      const ref = await addDoc(collection(db, "users", uid, "recipes"), payload);
      setActiveRecipeId(ref.id);
      setRecipeName(newName);
      setSavedRecipes(prev => [{ id: ref.id, ...payload, updatedAt: new Date() }, ...prev]);
      setDirty(false);
      showFeedback("ok", "Receta duplicada ✓");
    } catch (e) {
      console.error("Guardar como:", e); showFeedback("err", `Error al guardar: ${e.code || e.message}`);
    } finally { setBusy(false); }
  };

  const handleDelete = async () => {
    const uid = getUid();
    if (!activeRecipeId || !uid) return;
    if (!window.confirm(`¿Eliminar la receta "${recipeName}"? No se puede deshacer.`)) return;
    setBusy(true);
    try {
      await deleteDoc(doc(db, "users", uid, "recipes", activeRecipeId));
      setSavedRecipes(prev => prev.filter(r => r.id !== activeRecipeId));
      handleNew();
      showFeedback("ok", "Receta eliminada");
    } catch (e) {
      console.error("Eliminar:", e); showFeedback("err", `Error al eliminar: ${e.code || e.message}`);
    } finally { setBusy(false); }
  };

  const handleRename = async () => {
    const uid = getUid();
    if (!activeRecipeId || !uid) return;
    const newName = window.prompt("Nuevo nombre:", recipeName);
    if (!newName || newName === recipeName) return;
    setBusy(true);
    try {
      await setDoc(doc(db, "users", uid, "recipes", activeRecipeId), { name: newName, updatedAt: serverTimestamp() }, { merge: true });
      setRecipeName(newName);
      setSavedRecipes(prev => prev.map(r => r.id === activeRecipeId ? { ...r, name: newName } : r));
      showFeedback("ok", "Renombrada ✓");
    } catch (e) {
      console.error("Renombrar:", e); showFeedback("err", `Error al renombrar: ${e.code || e.message}`);
    } finally { setBusy(false); }
  };

  // Helper: agrega una hoja "Receta" al workbook con todas las fórmulas/formato
  const addRecipeSheet = (wb, { name, ingredients, portions, pv: pvValue }) => {
    const argb = (hex) => "FF" + hex.replace("#", "").toUpperCase();
    const COPPER = argb(C.copper);
    const fmtCurrency = `"${CURRENT_SYMBOL}"#,##0;[Red]("${CURRENT_SYMBOL}"#,##0)`;
    const fmtNumber = '#,##0';
    const fmtPct = '0.0%';

    // Sheet name: máx 31 chars, sin caracteres prohibidos
    const sheetName = (name || "Receta").replace(/[/\\?*:[\]]/g, "").slice(0, 31) || "Receta";
    let finalName = sheetName;
    let suffix = 2;
    while (wb.getWorksheet(finalName)) { finalName = `${sheetName.slice(0, 28)}_${suffix++}`; }
    const ws = wb.addWorksheet(finalName);
    ws.columns = [
      { width: 28 }, { width: 12 }, { width: 10 }, { width: 14 }, { width: 14 }, { width: 14 },
    ];
    ws.views = [{ state: "frozen", ySplit: 4 }];

    // Title
    ws.mergeCells("A1:F1");
    const t = ws.getCell("A1");
    t.value = `Costeo de receta — ${name || "Receta"}`;
    t.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
    t.fill = { type: "pattern", pattern: "solid", fgColor: { argb: COPPER } };
    t.alignment = { horizontal: "center", vertical: "middle" };
    ws.getRow(1).height = 28;

    // Porciones
    ws.getCell("A2").value = "Porciones que rinde:";
    ws.getCell("B2").value = portions;
    ws.getCell("B2").numFmt = fmtNumber;
    ws.getCell("A2").font = { bold: true };
    ws.getCell("B2").font = { bold: true, color: { argb: COPPER } };
    const portionsCell = "B2";

    // Header
    const headers = ["Ingrediente", "Cantidad", "Unidad", "Tamaño envase", "Precio envase", "Costo"];
    headers.forEach((h, i) => {
      const cell = ws.getCell(`${String.fromCharCode(65 + i)}4`);
      cell.value = h;
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: argb(C.copperDark) } };
      cell.alignment = { horizontal: i === 0 ? "left" : "center" };
      cell.border = { bottom: { style: "thin" } };
    });

    let row = 5;
    const firstItemRow = row;
    (ingredients || []).forEach(ing => {
      ws.getCell(`A${row}`).value = ing.name;
      ws.getCell(`B${row}`).value = ing.qty;
      ws.getCell(`B${row}`).numFmt = fmtNumber;
      ws.getCell(`C${row}`).value = ing.unit || "";
      ws.getCell(`C${row}`).alignment = { horizontal: "center" };
      ws.getCell(`D${row}`).value = ing.pkgSize;
      ws.getCell(`D${row}`).numFmt = fmtNumber;
      ws.getCell(`E${row}`).value = ing.pkgPrice;
      ws.getCell(`E${row}`).numFmt = fmtCurrency;
      ws.getCell(`F${row}`).value = { formula: `IF(D${row}=0,0,B${row}/D${row}*E${row})` };
      ws.getCell(`F${row}`).numFmt = fmtCurrency;
      ws.getCell(`F${row}`).font = { bold: true, color: { argb: argb(C.copperDark) } };
      if ((row - firstItemRow) % 2 === 1) {
        ["A", "B", "C", "D", "E", "F"].forEach(col => {
          ws.getCell(`${col}${row}`).fill = { type: "pattern", pattern: "solid", fgColor: { argb: argb("#fdfcfb") } };
        });
      }
      row++;
    });
    const lastItemRow = row - 1;

    const totalRow = row;
    ws.getCell(`A${row}`).value = "TOTAL RECETA";
    ws.getCell(`F${row}`).value = { formula: `SUM(F${firstItemRow}:F${lastItemRow})` };
    ws.getCell(`F${row}`).numFmt = fmtCurrency;
    ["A", "B", "C", "D", "E", "F"].forEach(col => {
      const cell = ws.getCell(`${col}${row}`);
      cell.font = { bold: true, size: 12, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: COPPER } };
      cell.border = { top: { style: "double" } };
    });
    ws.getRow(row).height = 22;
    row++;

    ws.getCell(`A${row}`).value = "Costo por porción";
    ws.getCell(`F${row}`).value = { formula: `IF(${portionsCell}=0,0,F${totalRow}/${portionsCell})` };
    ws.getCell(`F${row}`).numFmt = fmtCurrency;
    ws.getCell(`A${row}`).font = { bold: true, color: { argb: argb(C.copperDark) } };
    ws.getCell(`F${row}`).font = { bold: true, size: 12, color: { argb: argb(C.copperDark) } };
    const costPorcionCell = `F${row}`;
    row += 2;

    // Análisis de precio
    ws.getCell(`A${row}`).value = "ANÁLISIS DE PRECIO";
    ws.mergeCells(`A${row}:F${row}`);
    const acell = ws.getCell(`A${row}`);
    acell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    acell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: argb(C.copperDark) } };
    acell.alignment = { horizontal: "center" };
    row++;

    ws.getCell(`A${row}`).value = "Precio de venta sugerido";
    ws.getCell(`F${row}`).value = pvValue;
    ws.getCell(`F${row}`).numFmt = fmtCurrency;
    ws.getCell(`A${row}`).font = { bold: true };
    const pvRow = row; row++;

    ws.getCell(`A${row}`).value = "Margen bruto por porción";
    ws.getCell(`F${row}`).value = { formula: `F${pvRow}-${costPorcionCell}` };
    ws.getCell(`F${row}`).numFmt = fmtCurrency;
    ws.getCell(`F${row}`).font = { bold: true, color: { argb: argb(C.green) } };
    row++;

    ws.getCell(`A${row}`).value = "Food Cost %";
    ws.getCell(`F${row}`).value = { formula: `IF(F${pvRow}=0,0,${costPorcionCell}/F${pvRow})` };
    ws.getCell(`F${row}`).numFmt = fmtPct;
    ws.getCell(`F${row}`).font = { bold: true, color: { argb: argb(C.red) } };
    row++;

    ws.getCell(`A${row}`).value = "Margen %";
    ws.getCell(`F${row}`).value = { formula: `IF(F${pvRow}=0,0,(F${pvRow}-${costPorcionCell})/F${pvRow})` };
    ws.getCell(`F${row}`).numFmt = fmtPct;
    ws.getCell(`F${row}`).font = { bold: true, color: { argb: argb(C.green) } };

    return { ws, totalRow, costPorcionRow: totalRow + 1, pvRow, sheetName: finalName };
  };

  const addGuideSheet = (wb) => {
    const argb = (hex) => "FF" + hex.replace("#", "").toUpperCase();
    const COPPER = argb(C.copper);
    const ws2 = wb.addWorksheet("Cómo usar");
    ws2.columns = [{ width: 28 }, { width: 70 }];
    const guide = [
      ["Concepto", "Explicación"],
      ["Cantidad", "Cuánto del ingrediente entra en TODA la receta (no por porción)"],
      ["Unidad", "g, ml, un, kg, l, taza, etc. La misma unidad debe usarse para Cantidad y Tamaño envase"],
      ["Tamaño envase", "Cuánto trae el envase que comprás (ej: 1.000 g de harina)"],
      ["Precio envase", "Cuánto cuesta el envase entero"],
      ["Costo (fórmula)", "= Cantidad ÷ Tamaño envase × Precio envase"],
      ["Total receta", "Suma de costos de todos los ingredientes"],
      ["Costo por porción", "Total receta ÷ Porciones"],
      ["Margen bruto", "Precio de venta − Costo por porción"],
      ["Food Cost %", "Costo por porción ÷ Precio de venta. Ideal < 25-30%"],
      ["Margen %", "Margen bruto ÷ Precio de venta. Lo que queda para gastos fijos y ganancia"],
      ["Tip", "Las celdas con fórmulas se actualizan solas. Cambiá Cantidad o Precio envase y todo recalcula."],
    ];
    guide.forEach((r, i) => {
      ws2.getCell(`A${i + 1}`).value = r[0];
      ws2.getCell(`B${i + 1}`).value = r[1];
      if (i === 0) {
        ws2.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
        ws2.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: COPPER } };
      } else {
        ws2.getCell(`A${i + 1}`).font = { bold: true };
        ws2.getCell(`B${i + 1}`).alignment = { wrapText: true, vertical: "top" };
      }
    });
  };

  const downloadXlsx = async (wb, fname) => {
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fname;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExportReceta = async () => {
    const ExcelJS = (await import("exceljs")).default;
    const wb = new ExcelJS.Workbook();
    wb.creator = "Finanzas Tools";
    wb.created = new Date();
    addRecipeSheet(wb, { name: recipeName, ingredients: ings, portions: units, pv });
    addGuideSheet(wb);
    await downloadXlsx(wb, `Receta_${(recipeName || "receta").replace(/[^a-z0-9]/gi, "_")}.xlsx`);
  };

  const handleExportAll = async () => {
    if (savedRecipes.length === 0) { showFeedback("err", "No tenés recetas guardadas para exportar."); return; }
    setBusy(true);
    try {
      const ExcelJS = (await import("exceljs")).default;
      const wb = new ExcelJS.Workbook();
      wb.creator = "Finanzas Tools";
      wb.created = new Date();
      const argb = (hex) => "FF" + hex.replace("#", "").toUpperCase();
      const COPPER = argb(C.copper);
      const fmtCurrency = `"${CURRENT_SYMBOL}"#,##0;[Red]("${CURRENT_SYMBOL}"#,##0)`;
      const fmtPct = '0.0%';

      // Hoja Resumen primero
      const summary = wb.addWorksheet("Resumen");
      summary.columns = [{ width: 30 }, { width: 12 }, { width: 16 }, { width: 16 }, { width: 16 }, { width: 12 }];
      summary.mergeCells("A1:F1");
      const t = summary.getCell("A1");
      t.value = "Mis Recetas — Resumen";
      t.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
      t.fill = { type: "pattern", pattern: "solid", fgColor: { argb: COPPER } };
      t.alignment = { horizontal: "center", vertical: "middle" };
      summary.getRow(1).height = 28;
      const sumHeaders = ["Receta", "Porciones", "Costo total", "Costo / porción", "Precio venta", "Food Cost %"];
      sumHeaders.forEach((h, i) => {
        const cell = summary.getCell(`${String.fromCharCode(65 + i)}3`);
        cell.value = h;
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: argb(C.copperDark) } };
        cell.alignment = { horizontal: i === 0 ? "left" : "center" };
      });

      // Una hoja por receta + fila en resumen
      let sumRow = 4;
      savedRecipes.forEach(r => {
        const meta = addRecipeSheet(wb, { name: r.name, ingredients: r.ingredients || [], portions: r.portions || 1, pv: r.pv || 0 });
        const sn = meta.sheetName;
        // Hyperlink al nombre
        summary.getCell(`A${sumRow}`).value = { text: r.name, hyperlink: `#'${sn}'!A1` };
        summary.getCell(`A${sumRow}`).font = { color: { argb: argb(C.copperDark) }, underline: true };
        summary.getCell(`B${sumRow}`).value = { formula: `'${sn}'!B2` };
        summary.getCell(`B${sumRow}`).numFmt = '#,##0';
        summary.getCell(`C${sumRow}`).value = { formula: `'${sn}'!F${meta.totalRow}` };
        summary.getCell(`C${sumRow}`).numFmt = fmtCurrency;
        summary.getCell(`D${sumRow}`).value = { formula: `'${sn}'!F${meta.costPorcionRow}` };
        summary.getCell(`D${sumRow}`).numFmt = fmtCurrency;
        summary.getCell(`E${sumRow}`).value = { formula: `'${sn}'!F${meta.pvRow}` };
        summary.getCell(`E${sumRow}`).numFmt = fmtCurrency;
        summary.getCell(`F${sumRow}`).value = { formula: `IF('${sn}'!F${meta.pvRow}=0,0,'${sn}'!F${meta.costPorcionRow}/'${sn}'!F${meta.pvRow})` };
        summary.getCell(`F${sumRow}`).numFmt = fmtPct;
        sumRow++;
      });

      addGuideSheet(wb);
      await downloadXlsx(wb, `Mis_Recetas_${new Date().toISOString().slice(0, 10)}.xlsx`);
      showFeedback("ok", `${savedRecipes.length} recetas exportadas ✓`);
    } catch (e) {
      console.error(e); showFeedback("err", "Error al exportar.");
    } finally { setBusy(false); }
  };

  return (
    <div>
      {/* Sub-tabs */}
      <div style={{ display: "flex", gap: "4px", marginBottom: "12px" }}>
        {[{ k: "simple", l: "Modo Simple" }, { k: "receta", l: "Modo Receta" }].map(t => (
          <button key={t.k} onClick={() => setTab(t.k)} style={{
            padding: "8px 18px", border: "none", borderRadius: "8px", cursor: "pointer",
            fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600,
            background: tab === t.k ? C.copper : "#f0ebe6", color: tab === t.k ? "#fff" : C.muted, transition: "all 0.3s" }}>
            {t.l}
          </button>
        ))}
      </div>

      <Card>
        {tab === "simple" ? (
          <>
            <Slider label="Precio de Venta" value={pv} onChange={setPv} min={500} max={15000} step={10} />
            <Slider label="Food Cost / unidad" value={fc} onChange={setFc} min={50} max={12000} step={10} color={C.copperDark} />
          </>
        ) : (
          <>
            {/* Panel Mis Recetas */}
            <div style={{ padding: "10px 12px", marginBottom: "12px", borderRadius: "10px", background: `${C.copper}08`, border: `1.5px solid ${C.copper}33` }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", flexWrap: "wrap" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, minWidth: "240px" }}>
                  <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", fontWeight: 700, color: C.copper, textTransform: "uppercase", letterSpacing: "0.06em", whiteSpace: "nowrap" }}>📒 Mis recetas</span>
                  <select
                    value={activeRecipeId || ""}
                    onChange={e => handleSelectRecipe(e.target.value)}
                    style={{ flex: 1, padding: "6px 8px", border: `1.5px solid ${C.line}`, borderRadius: "6px", background: "#fff", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, outline: "none" }}
                  >
                    <option value="">{savedRecipes.length === 0 ? "— Aún no hay recetas guardadas —" : `— Elegí una (${savedRecipes.length}/${RECIPE_LIMIT}) —`}</option>
                    {savedRecipes.map(r => (
                      <option key={r.id} value={r.id}>{r.name}</option>
                    ))}
                  </select>
                  {dirty && <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.amber, fontWeight: 700 }}>● sin guardar</span>}
                </div>
                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                  <button onClick={handleNew} disabled={busy} title="Nueva receta en blanco"
                    style={{ padding: "6px 10px", border: `1.5px solid ${C.line}`, borderRadius: "6px", background: "#fff", color: C.dark, cursor: busy ? "wait" : "pointer", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600 }}>
                    + Nueva
                  </button>
                  <button onClick={handleSave} disabled={busy || !user}
                    title={activeRecipeId ? "Actualiza la receta activa" : "Crea una nueva receta"}
                    style={{ padding: "6px 10px", border: "none", borderRadius: "6px", background: C.copper, color: "#fff", cursor: busy ? "wait" : "pointer", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700 }}>
                    💾 {activeRecipeId ? "Guardar cambios" : "Guardar nueva"}
                  </button>
                  <button onClick={handleSaveAs} disabled={busy || !user} title="Guardar como una receta nueva"
                    style={{ padding: "6px 10px", border: `1.5px solid ${C.copper}66`, borderRadius: "6px", background: "#fff", color: C.copper, cursor: busy ? "wait" : "pointer", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600 }}>
                    Guardar como…
                  </button>
                  <button onClick={handleRename} disabled={busy || !activeRecipeId}
                    style={{ padding: "6px 10px", border: `1.5px solid ${C.line}`, borderRadius: "6px", background: "#fff", color: activeRecipeId ? C.dark : C.muted, cursor: activeRecipeId && !busy ? "pointer" : "not-allowed", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600, opacity: activeRecipeId ? 1 : 0.5 }}>
                    Renombrar
                  </button>
                  <button onClick={handleDelete} disabled={busy || !activeRecipeId}
                    style={{ padding: "6px 10px", border: `1.5px solid ${C.red}33`, borderRadius: "6px", background: C.redBg, color: C.red, cursor: activeRecipeId && !busy ? "pointer" : "not-allowed", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600, opacity: activeRecipeId ? 1 : 0.5 }}>
                    Eliminar
                  </button>
                </div>
              </div>
              {feedback && (
                <div style={{ marginTop: "8px", padding: "6px 10px", borderRadius: "6px", background: feedback.kind === "ok" ? C.greenBg : C.redBg, color: feedback.kind === "ok" ? C.green : C.red, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600 }}>
                  {feedback.msg}
                </div>
              )}
              {!user && (
                <div style={{ marginTop: "8px", padding: "6px 10px", borderRadius: "6px", background: C.amberBg, color: C.amber, fontFamily: "'DM Sans',sans-serif", fontSize: "12px" }}>
                  Iniciá sesión para guardar tus recetas en la nube.
                </div>
              )}
            </div>

            {/* Botones export */}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginBottom: "10px", flexWrap: "wrap" }}>
              <button onClick={handleExportAll} disabled={busy || savedRecipes.length === 0} title={savedRecipes.length === 0 ? "Guardá al menos una receta" : `Exportar las ${savedRecipes.length} recetas`}
                style={{ padding: "8px 14px", background: savedRecipes.length === 0 ? `${C.copper}55` : C.copper, color: "#fff", border: "none", borderRadius: "8px",
                  fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "12px", cursor: savedRecipes.length === 0 || busy ? "not-allowed" : "pointer",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
                📚 Exportar TODAS ({savedRecipes.length})
              </button>
              <button onClick={handleExportReceta}
                style={{ padding: "8px 14px", background: C.green, color: "#fff", border: "none", borderRadius: "8px",
                  fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "12px", cursor: "pointer",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
                📥 Exportar esta receta
              </button>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: "10px", marginBottom: "12px" }}>
              <div>
                <label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif", textTransform: "uppercase", letterSpacing: "0.04em" }}>Nombre de la receta</label>
                <input value={recipeName} onChange={e => setRecipeName(e.target.value)}
                  style={{ width: "100%", padding: "7px 8px", border: `1.5px solid ${C.line}`, borderRadius: "6px", fontSize: "13px", fontWeight: 600, color: C.dark, background: "#fdfcfb", fontFamily: "'DM Sans',sans-serif", outline: "none" }} />
              </div>
              <div>
                <label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif", textTransform: "uppercase", letterSpacing: "0.04em" }}>Porciones</label>
                <NumInput value={units} onChange={setUnits} prefix="" min={1} step={1} />
              </div>
              <div>
                <label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif", textTransform: "uppercase", letterSpacing: "0.04em" }}>Precio de venta</label>
                <NumInput value={pv} onChange={setPv} step={10} />
              </div>
            </div>

            {/* Tabla editable */}
            <div style={{ display: "grid", gridTemplateColumns: "1.4fr 70px 60px 70px 90px 70px 24px", gap: "4px", fontSize: "10px", fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.06em", fontFamily: "'DM Sans',sans-serif", padding: "0 4px", marginBottom: "4px" }}>
              <span>Ingrediente</span>
              <span style={{ textAlign: "center" }}>Cantidad</span>
              <span style={{ textAlign: "center" }}>Unidad</span>
              <span style={{ textAlign: "center" }}>Envase</span>
              <span style={{ textAlign: "right" }}>$ Envase</span>
              <span style={{ textAlign: "right" }}>Costo</span>
              <span></span>
            </div>
            <div style={{ maxHeight: "320px", overflowY: "auto", paddingRight: "4px" }}>
              {ings.map((ing, i) => {
                const cost = ing.pkgSize > 0 ? (ing.qty / ing.pkgSize) * ing.pkgPrice : 0;
                const inputStyle = { width: "100%", padding: "5px 6px", border: `1px solid ${C.line}`, borderRadius: "5px", fontSize: "12px", fontFamily: "'DM Sans',sans-serif", background: "#fff", outline: "none", color: C.dark };
                return (
                  <div key={i} style={{ display: "grid", gridTemplateColumns: "1.4fr 70px 60px 70px 90px 70px 24px", gap: "4px", alignItems: "center", padding: "4px", background: i % 2 === 0 ? "#fdfcfb" : "#fff", borderRadius: "6px", marginBottom: "2px" }}>
                    <input type="text" value={ing.name} onChange={e => upIng(i, { name: e.target.value })}
                      style={{ ...inputStyle, fontWeight: 600 }} />
                    <input type="number" value={ing.qty} min={0} onChange={e => upIng(i, { qty: Math.max(0, Number(e.target.value)) })}
                      style={{ ...inputStyle, textAlign: "right" }} />
                    <input type="text" value={ing.unit || ""} onChange={e => upIng(i, { unit: e.target.value })} placeholder="g"
                      style={{ ...inputStyle, textAlign: "center", fontSize: "12px", color: C.muted }} />
                    <input type="number" value={ing.pkgSize} min={0} onChange={e => upIng(i, { pkgSize: Math.max(0, Number(e.target.value)) })}
                      style={{ ...inputStyle, textAlign: "right" }} />
                    <input type="number" value={ing.pkgPrice} min={0} step={10} onChange={e => upIng(i, { pkgPrice: Math.max(0, Number(e.target.value)) })}
                      style={{ ...inputStyle, textAlign: "right" }} />
                    <span style={{ fontWeight: 700, color: C.copperDark, textAlign: "right", fontSize: "12px", fontFamily: "'DM Sans',sans-serif", padding: "0 4px" }}>
                      {fmt(cost)}
                    </span>
                    <button onClick={() => removeIng(i)} disabled={ings.length <= 1} title={ings.length <= 1 ? "Necesitás al menos 1 ingrediente" : "Eliminar"}
                      style={{ background: "transparent", border: "none", cursor: ings.length > 1 ? "pointer" : "not-allowed", color: C.muted, fontSize: "16px", padding: 0, opacity: ings.length > 1 ? 1 : 0.3 }}>×</button>
                  </div>
                );
              })}
            </div>

            <button onClick={addIng}
              style={{ width: "100%", marginTop: "8px", padding: "8px", background: "transparent", border: `1.5px dashed ${C.copper}66`, borderRadius: "8px", color: C.copper, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700 }}>
              + Agregar ingrediente
            </button>

            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 12px", marginTop: "12px", background: `${C.copper}11`, border: `1.5px solid ${C.copper}33`, borderRadius: "8px", fontFamily: "'DM Sans',sans-serif", fontSize: "13px" }}>
              <span style={{ fontWeight: 600, color: C.dark }}>Total receta ({units} {units === 1 ? "porción" : "porciones"})</span>
              <span style={{ fontWeight: 700, color: C.copperDark, fontSize: "16px", fontFamily: "'Georgia',serif" }}>{fmt(recipeCost)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 12px", marginTop: "4px", fontFamily: "'DM Sans',sans-serif", fontSize: "12px" }}>
              <span style={{ color: C.muted }}>Costo por porción</span>
              <span style={{ fontWeight: 700, color: C.copper, fontSize: "15px", fontFamily: "'Georgia',serif" }}>{fmt(costUnit)}</span>
            </div>
          </>
        )}
      </Card>

      {/* Visual */}
      <Card title="🧱 Composición del precio">
        {tab === "receta" ? (() => {
          // Horizontal LEGO: each ingredient is a colored brick, then margin brick
          const ingColors = ["#e74c3c","#e67e22","#f39c12","#2ecc71","#1abc9c","#3498db","#9b59b6","#e84393","#fd79a8","#6c5ce7"];
          // Costo por unidad (no total de receta) para que sea comparable con el margen por unidad
          const ingBlocks = ings.map((ing, i) => {
            const cost = ((ing.qty / ing.pkgSize) * ing.pkgPrice) / Math.max(1, units);
            return { l: ing.name, v: cost, c: ingColors[i % ingColors.length] };
          }).filter(b => b.v > 0);
          const marginVal = pv - costUnit;
          const allBlocks = [...ingBlocks, { l: "Margen", v: Math.max(0, marginVal), c: C.green, isMargin: true }];
          // Total = precio de venta. Así cada bloque ocupa su % real sobre el precio.
          const totalBar = pv > 0 ? pv : allBlocks.reduce((s, b) => s + b.v, 0);

          // Horizontal LEGO studs
          const drawStudsH = (h, color) => {
            const studW = 6, studH = 10, gap = 3;
            const count = Math.max(1, Math.floor((h - gap) / (studW + gap)));
            const totalH = count * studW + (count - 1) * gap;
            const startY = (h - totalH) / 2;
            return Array.from({ length: count }, (_, i) => (
              <div key={i} style={{
                position: "absolute", right: `-${studH - 1}px`,
                top: `${startY + i * (studW + gap)}px`,
                width: `${studH}px`, height: `${studW}px`,
                background: color, borderRadius: "0 2px 2px 0",
                boxShadow: "inset 0 1px 0 rgba(255,255,255,0.25), 1px 0 2px rgba(0,0,0,0.1)",
              }} />
            ));
          };

          return (
            <div>
              {/* Price label on top */}
              <div style={{
                textAlign: "center", marginBottom: "8px", fontFamily: "'DM Sans',sans-serif",
                fontSize: "12px", color: C.muted
              }}>
                Precio de venta: <strong style={{ color: C.dark, fontSize: "14px" }}>{fmt(pv)}</strong> = 100%
              </div>

              {/* Horizontal LEGO bar */}
              <div style={{ display: "flex", alignItems: "stretch", height: "auto", borderRadius: "8px", overflow: "visible", marginBottom: "6px", paddingRight: "10px" }}>
                {allBlocks.map((b, i) => {
                  const wPct = totalBar > 0 ? (b.v / totalBar) * 100 : 0;
                  const pctOfPrice = pv > 0 ? (b.v / pv) * 100 : 0;
                  const isWide = wPct > 8;
                  const isMed = wPct > 4;
                  return (
                    <div key={i} style={{
                      width: `${wPct}%`, minWidth: wPct > 1 ? "4px" : "0",
                      position: "relative",
                      background: `linear-gradient(90deg, ${b.c}dd, ${b.c})`,
                      borderRadius: i === 0 ? "8px 0 0 8px" : i === allBlocks.length - 1 ? "0 8px 8px 0" : "0",
                      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                      padding: isWide ? "8px 4px" : "8px 1px",
                      minHeight: "56px",
                      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.2), inset 0 -1px 0 rgba(0,0,0,0.1)",
                      transition: "width 0.4s",
                      borderRight: i < allBlocks.length - 1 ? "1.5px solid rgba(255,255,255,0.4)" : "none",
                    }}>
                      {/* Studs on right side */}
                      {i < allBlocks.length - 1 && isMed && drawStudsH(56, `${b.c}bb`)}
                      {isWide && (
                        <>
                          <span style={{ color: "#fff", fontWeight: 700, fontSize: "10px", fontFamily: "'DM Sans',sans-serif", textShadow: "0 1px 2px rgba(0,0,0,0.4)", textAlign: "center", lineHeight: 1.2, zIndex: 1 }}>
                            {b.l}
                          </span>
                          <span style={{ color: "#fff", fontWeight: 600, fontSize: "8px", fontFamily: "'DM Sans',sans-serif", opacity: 0.9, zIndex: 1 }}>
                            {pctOfPrice.toFixed(1)}%
                          </span>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Legend below */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: "4px 10px", marginTop: "8px", justifyContent: "center" }}>
                {allBlocks.map((b, i) => {
                  const pctOfPrice = pv > 0 ? (b.v / pv) * 100 : 0;
                  return (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                      <div style={{ width: "10px", height: "10px", borderRadius: "2px", background: b.c, boxShadow: "inset 0 1px 0 rgba(255,255,255,0.3)" }} />
                      <span style={{ fontSize: "10px", fontFamily: "'DM Sans',sans-serif", color: C.dark, fontWeight: b.isMargin ? 700 : 500 }}>
                        {b.l} {fmt(b.v)} ({pctOfPrice.toFixed(1)}%)
                      </span>
                    </div>
                  );
                })}
              </div>

              {marginVal < 0 && (
                <div style={{ marginTop: "8px", padding: "6px 10px", borderRadius: "6px", background: C.redBg, border: `1.5px solid ${C.red}22`, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.red, fontWeight: 600, textAlign: "center" }}>
                  ⚠️ ¡Tu food cost supera el precio de venta! No hay margen.
                </div>
              )}
            </div>
          );
        })() : (
          /* Simple mode: two-block bar */
          <div style={{ display: "flex", gap: "3px", marginBottom: "16px" }}>
            {[{ r: costUnit / pv, c: C.copperDark, l: "Food Cost", a: Math.round(costUnit) },
              { r: margin / pv, c: C.copper, l: "Margen Bruto", a: Math.round(margin) }
            ].map((seg, i) => {
              const w = Math.max(0, Math.min(100, seg.r * 100));
              return (
                <div key={i} style={{ width: `${w}%`, minWidth: w > 5 ? "50px" : 0, transition: "width 0.5s", textAlign: "center" }}>
                  <div style={{ height: "52px", background: seg.c, borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: "13px", textShadow: "0 1px 2px rgba(0,0,0,0.3)" }}>
                    {w > 8 && `${w.toFixed(1)}%`}
                  </div>
                  <div style={{ fontSize: "11px", fontWeight: 600, color: C.dark, marginTop: "4px", fontFamily: "'DM Sans',sans-serif" }}>{seg.l}<br /><span style={{ fontWeight: 400, opacity: 0.6 }}>{fmt(seg.a)}</span></div>
                </div>
              );
            })}
          </div>
        )}
        {/* Thermometer */}
        <div style={{ height: "22px", background: "#e8e2dc", borderRadius: "11px", overflow: "hidden", position: "relative", marginBottom: "4px" }}>
          <div style={{ width: `${Math.min(100, fcPct)}%`, height: "100%", background: `linear-gradient(90deg, ${statusColor}cc, ${statusColor})`, borderRadius: "11px", transition: "all 0.5s", display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "8px", minWidth: "35px" }}>
            <span style={{ color: "#fff", fontWeight: 700, fontSize: "12px" }}>{fcPct.toFixed(1)}%</span>
          </div>
          <div style={{ position: "absolute", left: "25%", top: 0, bottom: 0, width: "1px", background: "rgba(0,0,0,0.12)" }} />
          <div style={{ position: "absolute", left: "35%", top: 0, bottom: 0, width: "1px", background: "rgba(0,0,0,0.12)" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "10px", color: "#bbb", fontFamily: "'DM Sans',sans-serif" }}>
          <span>0%</span><span style={{ marginLeft: "15%" }}>25% ideal</span><span style={{ marginLeft: "2%" }}>35%</span><span>100%</span>
        </div>

        {/* Status */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "12px", borderRadius: "10px", background: `${statusColor}11`, border: `2px solid ${statusColor}33`, marginTop: "12px" }}>
          <span style={{ fontSize: "28px" }}>{statusEmoji}</span>
          <div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "15px", color: statusColor }}>{statusText}</div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark }}>
              {fcPct < 25 ? "Buen margen para cubrir gastos fijos y ganar." : fcPct < 35 ? "Aceptable, queda menos para gastos fijos." : "Revisá ingredientes o subí el precio."}
            </div>
          </div>
        </div>

        {/* Numbers */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px", marginTop: "12px" }}>
          {[{ l: "Precio", v: fmt(pv), s: "100%", c: C.dark },
            { l: "Food Cost", v: fmt(costUnit), s: `${fcPct.toFixed(1)}%`, c: C.copperDark },
            { l: "Margen", v: fmt(margin), s: `${mPct.toFixed(1)}%`, c: C.copper }
          ].map((x, i) => (
            <div key={i} style={{ textAlign: "center", padding: "10px 6px", borderRadius: "10px", background: C.bg, fontFamily: "'DM Sans',sans-serif" }}>
              <div style={{ fontSize: "10px", fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: "0.06em" }}>{x.l}</div>
              <div style={{ fontSize: "17px", fontWeight: 700, color: x.c }}>{x.v}</div>
              <div style={{ fontSize: "11px", color: x.c, fontWeight: 600, opacity: 0.7 }}>{x.s}</div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: "12px", padding: "10px", borderRadius: "8px", background: C.bg, textAlign: "center", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark }}>
          <strong>Fórmula:</strong> MC = Precio − Food Cost &nbsp;|&nbsp; PVenta = FC ÷ (1 − Margen%)
        </div>
      </Card>
    </div>
  );
}


/* ═══════════════════════════════════════════
   TOOL 2: ESTADO DE RESULTADOS
   ═══════════════════════════════════════════ */
const PALETTE_GASTOS = ["#e67e22", "#f39c12", "#3498db", "#9b59b6", "#1abc9c", "#7f8c8d", "#e84393"];
const newId = () => "id" + Math.random().toString(36).slice(2, 8);

function ToolEERR() {
  const [businessName, setBusinessName] = useState("Mi Negocio");
  const [pv, setPv] = useState(1990);
  const [uv, setUv] = useState(600);
  const [fcU, setFcU] = useState(453);
  const [tax, setTax] = useState(27);
  const [categorias, setCategorias] = useState([
    { id: newId(), name: "Operaciones", items: [
      { id: newId(), name: "Arriendo", monto: 350000 },
      { id: newId(), name: "Sueldos", monto: 450000 },
    ]},
    { id: newId(), name: "Marketing", items: [
      { id: newId(), name: "Publicidad", monto: 80000 },
    ]},
    { id: newId(), name: "Mantenimiento", items: [
      { id: newId(), name: "Reparaciones", monto: 40000 },
    ]},
  ]);

  // Helpers para editar categorías/items
  const updateCategoryName = (ci, name) => { const n = [...categorias]; n[ci] = { ...n[ci], name }; setCategorias(n); };
  const removeCategory = (ci) => { if (categorias.length > 1) setCategorias(categorias.filter((_, i) => i !== ci)); };
  const addCategory = () => setCategorias([...categorias, { id: newId(), name: "Nueva categoría", items: [{ id: newId(), name: "Nuevo gasto", monto: 0 }] }]);
  const updateItemName = (ci, ii, name) => { const n = [...categorias]; const items = [...n[ci].items]; items[ii] = { ...items[ii], name }; n[ci] = { ...n[ci], items }; setCategorias(n); };
  const updateItemMonto = (ci, ii, monto) => { const n = [...categorias]; const items = [...n[ci].items]; items[ii] = { ...items[ii], monto: Math.max(0, monto) }; n[ci] = { ...n[ci], items }; setCategorias(n); };
  const removeItem = (ci, ii) => { const n = [...categorias]; n[ci] = { ...n[ci], items: n[ci].items.filter((_, i) => i !== ii) }; setCategorias(n); };
  const addItem = (ci) => { const n = [...categorias]; n[ci] = { ...n[ci], items: [...n[ci].items, { id: newId(), name: "Nuevo gasto", monto: 0 }] }; setCategorias(n); };

  const d = useMemo(() => {
    const ing = pv * uv, cv = fcU * uv, mb = ing - cv;
    const catTotals = categorias.map(c => ({ id: c.id, name: c.name, total: c.items.reduce((s, i) => s + i.monto, 0) }));
    const gf = catTotals.reduce((s, c) => s + c.total, 0);
    const ro = mb - gf, imp = ro > 0 ? ro * tax / 100 : 0, re = ro - imp;
    const mcU = pv - fcU;
    const peU = mcU > 0 ? Math.ceil(gf / mcU) : Infinity;
    const peV = mcU > 0 ? gf / (1 - fcU / pv) : Infinity;
    // Prime Cost = Food Cost + items que parecen mano de obra (heurística por nombre)
    const sueldos = categorias.flatMap(c => c.items).filter(i => /sueldo|salario|mano de obra|personal/i.test(i.name)).reduce((s, i) => s + i.monto, 0);
    const primeCost = cv + sueldos;
    return { ing, cv, mb, gf, ro, imp, re, peU, peV, catTotals, primeCost };
  }, [pv, uv, fcU, categorias, tax]);

  const rc = d.re >= 0 ? C.green : C.red;

  const pcColor = d.ing > 0 && (d.primeCost / d.ing) < 0.60 ? C.green : d.ing > 0 && (d.primeCost / d.ing) < 0.70 ? C.amber : C.red;

  const rows = [
    { l: "Ingresos", v: d.ing, b: true, c: C.dark, bg: "transparent" },
    { l: "Food Cost", v: -d.cv, b: false, c: C.red },
    { l: "Margen Bruto", v: d.mb, b: true, c: C.dark, bg: `${C.copper}0d` },
    ...categorias.flatMap((cat, ci) => {
      const color = PALETTE_GASTOS[ci % PALETTE_GASTOS.length];
      const catTotal = cat.items.reduce((s, i) => s + i.monto, 0);
      return [
        ...cat.items.map(item => ({ l: `   ${item.name}`, v: -item.monto, c: C.muted })),
        { l: `Subtotal ${cat.name}`, v: -catTotal, c: color, bg: `${color}10` },
      ];
    }),
    { l: "Total Gastos Fijos", v: -d.gf, b: true, c: C.red, bg: `${C.red}08` },
    { l: "Resultado Operacional", v: d.ro, b: true, c: d.ro >= 0 ? C.green : C.red, bg: `${d.ro >= 0 ? C.green : C.red}0d` },
    { l: `Impuestos (${tax}%)`, v: -d.imp, c: C.muted },
    { l: "Resultado del Ejercicio", v: d.re, b: true, c: rc, bg: `${rc}12`, final: true },
  ];

  const handleExportExcel = async () => {
    const ExcelJS = (await import("exceljs")).default;
    const wb = new ExcelJS.Workbook();
    wb.creator = "Finanzas Tools";
    wb.created = new Date();
    const ws = wb.addWorksheet("EERR");
    ws.columns = [{ width: 38 }, { width: 18 }, { width: 14 }];
    ws.views = [{ state: "frozen", ySplit: 3 }];

    const argb = (hex) => "FF" + hex.replace("#", "").toUpperCase();
    const COPPER = argb(C.copper), DARK = argb(C.dark), GREEN = argb(C.green), RED = argb(C.red), MUTED = argb(C.muted);
    const fmtCurrency = `"${CURRENT_SYMBOL}"#,##0;[Red]("${CURRENT_SYMBOL}"#,##0)`;
    const fmtPct = '0.0%';
    const setStyle = (row, opts = {}) => {
      const r = ws.getRow(row);
      ["A", "B", "C"].forEach(col => {
        const cell = r.getCell(col);
        if (opts.font) cell.font = opts.font;
        if (opts.fill) cell.fill = opts.fill;
        if (opts.border) cell.border = opts.border;
        if (col !== "A" && opts.numFmt) cell.numFmt = opts.numFmt;
        if (col === "A" && opts.alignment) cell.alignment = opts.alignment;
      });
    };

    // Title
    ws.mergeCells("A1:C1");
    const t = ws.getCell("A1");
    t.value = `Estado de Resultados — ${businessName || "Mi Negocio"}`;
    t.font = { name: "Calibri", bold: true, size: 16, color: { argb: "FFFFFFFF" } };
    t.fill = { type: "pattern", pattern: "solid", fgColor: { argb: COPPER } };
    t.alignment = { horizontal: "center", vertical: "middle" };
    ws.getRow(1).height = 28;

    // Header row
    ws.getCell("A3").value = "Concepto";
    ws.getCell("B3").value = "Monto";
    ws.getCell("C3").value = "% Ingresos";
    setStyle(3, { font: { bold: true, size: 11, color: { argb: "FFFFFFFF" } }, fill: { type: "pattern", pattern: "solid", fgColor: { argb: argb(C.copperDark) } } });
    ["A", "B", "C"].forEach(col => { ws.getCell(`${col}3`).alignment = { horizontal: col === "A" ? "left" : "right" }; });

    let row = 5;
    // INGRESOS
    ws.getCell(`A${row}`).value = "INGRESOS";
    setStyle(row, { font: { bold: true, size: 11, color: { argb: COPPER } }, fill: { type: "pattern", pattern: "solid", fgColor: { argb: argb("#f3eeea") } } });
    row++;
    ws.getCell(`A${row}`).value = "Precio unitario";
    ws.getCell(`B${row}`).value = pv;
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    const pvRow = row; row++;
    ws.getCell(`A${row}`).value = "Unidades vendidas";
    ws.getCell(`B${row}`).value = uv;
    ws.getCell(`B${row}`).numFmt = '#,##0';
    const uvRow = row; row++;
    ws.getCell(`A${row}`).value = "Total Ingresos";
    ws.getCell(`B${row}`).value = { formula: `B${pvRow}*B${uvRow}` };
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    ws.getCell(`C${row}`).value = 1;
    ws.getCell(`C${row}`).numFmt = fmtPct;
    setStyle(row, { font: { bold: true }, border: { top: { style: "thin" } } });
    const ingRow = row; row += 2;

    // COSTO DE VENTAS
    ws.getCell(`A${row}`).value = "COSTO DE VENTAS";
    setStyle(row, { font: { bold: true, size: 11, color: { argb: RED } }, fill: { type: "pattern", pattern: "solid", fgColor: { argb: argb("#fdf0ee") } } });
    row++;
    ws.getCell(`A${row}`).value = "Food Cost / unidad";
    ws.getCell(`B${row}`).value = fcU;
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    const fcRow = row; row++;
    ws.getCell(`A${row}`).value = "Total Food Cost";
    ws.getCell(`B${row}`).value = { formula: `B${fcRow}*B${uvRow}` };
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    ws.getCell(`C${row}`).value = { formula: `B${row}/B${ingRow}` };
    ws.getCell(`C${row}`).numFmt = fmtPct;
    ws.getCell(`B${row}`).font = { color: { argb: RED } };
    const fcTotRow = row; row++;
    ws.getCell(`A${row}`).value = "Margen Bruto";
    ws.getCell(`B${row}`).value = { formula: `B${ingRow}-B${fcTotRow}` };
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    ws.getCell(`C${row}`).value = { formula: `B${row}/B${ingRow}` };
    ws.getCell(`C${row}`).numFmt = fmtPct;
    setStyle(row, { font: { bold: true, size: 12, color: { argb: COPPER } }, fill: { type: "pattern", pattern: "solid", fgColor: { argb: argb("#f9f5f1") } }, border: { top: { style: "thin" }, bottom: { style: "thin" } } });
    const mbRow = row; row += 2;

    // GASTOS FIJOS por categoría
    ws.getCell(`A${row}`).value = "GASTOS FIJOS";
    setStyle(row, { font: { bold: true, size: 11, color: { argb: argb(C.amber) } }, fill: { type: "pattern", pattern: "solid", fgColor: { argb: argb("#fef9ed") } } });
    row++;
    const subtotalRows = [];
    categorias.forEach((cat, ci) => {
      const color = argb(PALETTE_GASTOS[ci % PALETTE_GASTOS.length]);
      ws.getCell(`A${row}`).value = cat.name;
      ws.getCell(`A${row}`).font = { bold: true, italic: true, color: { argb: color } };
      row++;
      const firstItemRow = row;
      cat.items.forEach(item => {
        ws.getCell(`A${row}`).value = `   ${item.name}`;
        ws.getCell(`B${row}`).value = item.monto;
        ws.getCell(`B${row}`).numFmt = fmtCurrency;
        ws.getCell(`A${row}`).font = { color: { argb: MUTED } };
        ws.getCell(`C${row}`).value = { formula: `B${row}/B${ingRow}` };
        ws.getCell(`C${row}`).numFmt = fmtPct;
        row++;
      });
      const lastItemRow = row - 1;
      ws.getCell(`A${row}`).value = `Subtotal ${cat.name}`;
      ws.getCell(`B${row}`).value = lastItemRow >= firstItemRow ? { formula: `SUM(B${firstItemRow}:B${lastItemRow})` } : 0;
      ws.getCell(`B${row}`).numFmt = fmtCurrency;
      ws.getCell(`C${row}`).value = { formula: `B${row}/B${ingRow}` };
      ws.getCell(`C${row}`).numFmt = fmtPct;
      setStyle(row, { font: { bold: true, color: { argb: color } }, border: { top: { style: "thin", color: { argb: color } } } });
      subtotalRows.push(row);
      row += 2;
    });

    // Total Gastos Fijos
    ws.getCell(`A${row}`).value = "Total Gastos Fijos";
    ws.getCell(`B${row}`).value = { formula: subtotalRows.map(r => `B${r}`).join("+") };
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    ws.getCell(`C${row}`).value = { formula: `B${row}/B${ingRow}` };
    ws.getCell(`C${row}`).numFmt = fmtPct;
    setStyle(row, { font: { bold: true, size: 12, color: { argb: RED } }, fill: { type: "pattern", pattern: "solid", fgColor: { argb: argb("#fdf0ee") } }, border: { top: { style: "double" } } });
    const totalGfRow = row; row += 2;

    // Resultado Operacional
    ws.getCell(`A${row}`).value = "Resultado Operacional";
    ws.getCell(`B${row}`).value = { formula: `B${mbRow}-B${totalGfRow}` };
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    ws.getCell(`C${row}`).value = { formula: `B${row}/B${ingRow}` };
    ws.getCell(`C${row}`).numFmt = fmtPct;
    setStyle(row, { font: { bold: true, size: 12 }, fill: { type: "pattern", pattern: "solid", fgColor: { argb: argb("#f9f5f1") } }, border: { top: { style: "thin" }, bottom: { style: "thin" } } });
    const roRow = row; row++;

    // Impuestos
    ws.getCell(`A${row}`).value = `Impuestos (${tax}%)`;
    ws.getCell(`B${row}`).value = { formula: `IF(B${roRow}>0,B${roRow}*${tax}/100,0)` };
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    ws.getCell(`B${row}`).font = { color: { argb: MUTED } };
    ws.getCell(`C${row}`).value = { formula: `B${row}/B${ingRow}` };
    ws.getCell(`C${row}`).numFmt = fmtPct;
    const impRow = row; row++;

    // Resultado del Ejercicio
    ws.getCell(`A${row}`).value = "RESULTADO DEL EJERCICIO";
    ws.getCell(`B${row}`).value = { formula: `B${roRow}-B${impRow}` };
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    ws.getCell(`C${row}`).value = { formula: `B${row}/B${ingRow}` };
    ws.getCell(`C${row}`).numFmt = fmtPct;
    setStyle(row, { font: { bold: true, size: 14, color: { argb: "FFFFFFFF" } }, fill: { type: "pattern", pattern: "solid", fgColor: { argb: GREEN } }, border: { top: { style: "double" }, bottom: { style: "double" } } });
    ws.getRow(row).height = 24;
    // Conditional fill: if negative, use red. ExcelJS doesn't easily do conditional fills via API at runtime,
    // so the actual fill stays green; the [Red] in numFmt makes negative numbers red. Leave it.

    // Hoja 2: Glosario
    const ws2 = wb.addWorksheet("Glosario");
    ws2.columns = [{ width: 28 }, { width: 70 }];
    const glosario = [
      ["Concepto", "Definición"],
      ["Ingresos", "Total facturado en el período (precio × unidades)"],
      ["Food Cost", "Costo de los insumos del producto vendido"],
      ["Margen Bruto", "Ingresos − Food Cost. Lo que queda para cubrir gastos fijos y dejar utilidad"],
      ["Gastos Fijos", "Costos que se pagan independiente del volumen de ventas"],
      ["Resultado Operacional", "Margen Bruto − Gastos Fijos. Antes de impuestos"],
      ["Impuestos", "Solo se calculan si hay resultado positivo"],
      ["Resultado del Ejercicio", "Utilidad final después de impuestos"],
      ["Punto de Equilibrio", "Unidades a vender para cubrir todos los costos: Gastos Fijos ÷ (Precio − FC unitario)"],
    ];
    glosario.forEach((r, i) => {
      ws2.getCell(`A${i + 1}`).value = r[0];
      ws2.getCell(`B${i + 1}`).value = r[1];
      if (i === 0) {
        ws2.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
        ws2.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: COPPER } };
      } else {
        ws2.getCell(`A${i + 1}`).font = { bold: true };
        ws2.getCell(`B${i + 1}`).alignment = { wrapText: true, vertical: "top" };
      }
    });

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `EERR_${(businessName || "negocio").replace(/[^a-z0-9]/gi, "_")}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <button onClick={handleExportExcel}
          style={{ padding: "8px 14px", background: C.green, color: "#fff", border: "none", borderRadius: "8px",
            fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "12px", cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)", display: "flex", alignItems: "center", gap: "6px" }}>
          📥 Exportar a Excel (con fórmulas)
        </button>
      </div>

      <Card title="Datos del negocio">
        <div style={{ marginBottom: "10px" }}>
          <label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif" }}>Nombre del negocio (para el Excel)</label>
          <input value={businessName} onChange={e => setBusinessName(e.target.value)}
            style={{ width: "100%", padding: "7px 8px", border: `1.5px solid ${C.line}`, borderRadius: "6px", fontSize: "13px", fontWeight: 600, color: C.dark, background: "#fdfcfb", fontFamily: "'DM Sans',sans-serif", outline: "none" }} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
          <div><label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif" }}>Precio unitario</label><NumInput value={pv} onChange={setPv} step={10} /></div>
          <div><label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif" }}>Unidades vendidas</label><NumInput value={uv} onChange={setUv} prefix="" step={10} /></div>
          <div style={{ gridColumn: "1/-1" }}><label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif" }}>Food Cost / unidad</label><NumInput value={fcU} onChange={setFcU} step={10} /></div>
        </div>

        <div style={{ borderTop: `1px solid ${C.line}`, margin: "14px 0 10px" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
          <div style={{ fontSize: "11px", fontWeight: 700, color: C.copper, textTransform: "uppercase", letterSpacing: "0.08em", fontFamily: "'DM Sans',sans-serif" }}>
            Gastos Fijos Mensuales — por categoría
          </div>
          <span style={{ fontFamily: "'Georgia',serif", fontSize: "16px", fontWeight: 700, color: C.copper }}>
            Total: {fmt(d.gf)}
          </span>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {categorias.map((cat, ci) => {
            const catTotal = cat.items.reduce((s, i) => s + i.monto, 0);
            const color = PALETTE_GASTOS[ci % PALETTE_GASTOS.length];
            return (
              <div key={cat.id} style={{ border: `1.5px solid ${color}33`, borderRadius: "10px", padding: "10px", background: `${color}06` }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 130px 28px", gap: "6px", alignItems: "center", marginBottom: "8px" }}>
                  <input value={cat.name} onChange={e => updateCategoryName(ci, e.target.value)}
                    style={{ padding: "5px 8px", border: "none", borderRadius: "6px", background: "transparent", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color, outline: "none", borderBottom: `1px dashed ${color}55` }} />
                  <span style={{ textAlign: "right", fontFamily: "'Georgia',serif", fontSize: "14px", fontWeight: 700, color }}>
                    {fmt(catTotal)}
                  </span>
                  <button onClick={() => removeCategory(ci)} disabled={categorias.length <= 1} title={categorias.length <= 1 ? "Necesitás al menos 1 categoría" : "Eliminar categoría"}
                    style={{ background: "transparent", border: "none", cursor: categorias.length > 1 ? "pointer" : "not-allowed", color: C.muted, fontSize: "18px", padding: 0, opacity: categorias.length > 1 ? 1 : 0.3 }}>×</button>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                  {cat.items.map((item, ii) => (
                    <div key={item.id} style={{ display: "grid", gridTemplateColumns: "1fr 130px 28px", gap: "6px", alignItems: "center" }}>
                      <input value={item.name} onChange={e => updateItemName(ci, ii, e.target.value)}
                        style={{ padding: "4px 8px", border: `1px solid ${C.line}`, borderRadius: "5px", background: "#fff", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, outline: "none" }} />
                      <NumInput value={item.monto} onChange={v => updateItemMonto(ci, ii, v)} step={5000} small />
                      <button onClick={() => removeItem(ci, ii)} disabled={cat.items.length <= 1} title={cat.items.length <= 1 ? "Necesitás al menos 1 ítem" : "Eliminar ítem"}
                        style={{ background: "transparent", border: "none", cursor: cat.items.length > 1 ? "pointer" : "not-allowed", color: C.muted, fontSize: "14px", padding: 0, opacity: cat.items.length > 1 ? 1 : 0.3 }}>×</button>
                    </div>
                  ))}
                </div>
                <button onClick={() => addItem(ci)}
                  style={{ marginTop: "8px", padding: "4px 10px", background: "transparent", border: `1px dashed ${color}66`, borderRadius: "6px", color, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontSize: "11px", fontWeight: 600 }}>
                  + agregar gasto
                </button>
              </div>
            );
          })}
          <button onClick={addCategory}
            style={{ padding: "8px", background: "transparent", border: `1.5px dashed ${C.copper}66`, borderRadius: "8px", color: C.copper, cursor: "pointer", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700 }}>
            + Agregar categoría
          </button>
        </div>

        <div style={{ borderTop: `1px solid ${C.line}`, margin: "14px 0 10px" }} />
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif" }}>Impuesto</label>
          <NumInput value={tax} onChange={setTax} prefix="" min={0} max={100} step={1} small /><span style={{ fontSize: "13px", color: C.muted }}>%</span>
        </div>
      </Card>

      <Card title="Estado de Resultados">
        {rows.map((r, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 90px 50px", padding: `${r.b ? "8px" : "5px"} 10px`, background: r.bg || "transparent", borderRadius: "6px", marginBottom: "1px", borderBottom: r.final ? `2.5px solid ${r.c}` : "none" }}>
            <span style={{ fontSize: r.b ? "12px" : "11px", fontWeight: r.b ? 700 : 500, color: r.b ? C.dark : C.muted, fontFamily: "'DM Sans',sans-serif" }}>{r.l}</span>
            <span style={{ fontSize: r.b ? "13px" : "12px", fontWeight: 700, color: r.c, textAlign: "right", fontFamily: "'DM Sans',sans-serif" }}>{fmt(r.v)}</span>
            <span style={{ fontSize: "11px", fontWeight: 600, color: C.muted, textAlign: "right", fontFamily: "'DM Sans',sans-serif" }}>{pct(Math.abs(r.v), d.ing)}</span>
          </div>
        ))}
      </Card>

      {/* LEGO Tower */}
      <Card title="🧱 Torre de costos — ¿A dónde va cada peso?">
        {(() => {
          // Build blocks from top (ingresos) to bottom (resultado): Food Cost + 1 bloque por categoría
          const blocks = [
            { l: "Food Cost", v: d.cv, c: "#e74c3c", light: "#fdedec" },
            ...d.catTotals.filter(c => c.total > 0).map((c, i) => ({
              l: c.name,
              v: c.total,
              c: PALETTE_GASTOS[i % PALETTE_GASTOS.length],
              light: PALETTE_GASTOS[i % PALETTE_GASTOS.length] + "22",
            })),
            { l: `Impuestos (${tax}%)`, v: d.imp, c: "#bdc3c7", light: "#f7f8f8" },
          ].filter(b => b.v > 0);

          const resultado = Math.max(0, d.re);
          const perdida = d.re < 0 ? Math.abs(d.re) : 0;
          if (resultado > 0) blocks.push({ l: "Tu ganancia", v: resultado, c: C.green, light: C.greenBg, isResult: true });

          const total = blocks.reduce((s, b) => s + b.v, 0) + perdida;
          const maxW = 320;
          const studsH = 8;

          // Draw LEGO studs
          const drawStuds = (w, color, y) => {
            const studW = 14, studH = studsH, gap = 4;
            const count = Math.max(1, Math.floor((w - gap) / (studW + gap)));
            const totalStudsW = count * studW + (count - 1) * gap;
            const startX = (w - totalStudsW) / 2;
            const studs = [];
            for (let i = 0; i < count; i++) {
              studs.push(
                <div key={i} style={{
                  position: "absolute",
                  left: `${startX + i * (studW + gap)}px`,
                  top: `-${studH - 1}px`,
                  width: `${studW}px`, height: `${studH}px`,
                  background: color,
                  borderRadius: "3px 3px 0 0",
                  boxShadow: `inset 0 1px 0 rgba(255,255,255,0.25), 0 -1px 2px rgba(0,0,0,0.1)`,
                }} />
              );
            }
            return studs;
          };

          return (
            <div style={{ display: "flex", gap: "20px", alignItems: "flex-end" }}>
              {/* Tower */}
              <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                {/* Top label: INGRESOS */}
                <div style={{
                  width: `${maxW}px`, padding: "8px 12px", marginBottom: "0",
                  background: `linear-gradient(135deg, ${C.copper}, ${C.copperDark})`,
                  borderRadius: "8px 8px 0 0", textAlign: "center",
                  color: "#fff", fontWeight: 700, fontSize: "13px", fontFamily: "'DM Sans',sans-serif",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  position: "relative",
                }}>
                  INGRESOS {fmt(d.ing)}
                  <div style={{ fontSize: "11px", fontWeight: 500, opacity: 0.85 }}>100% — Todo lo que entra</div>
                </div>

                {/* Blocks — todos del mismo ancho, la altura representa el valor */}
                {blocks.map((b, i) => {
                  const pctVal = d.ing > 0 ? (b.v / d.ing) * 100 : 0;
                  const h = Math.max(32, pctVal * 1.8);
                  const w = maxW;

                  return (
                    <div key={i} style={{
                      width: `${w}px`, height: `${h}px`,
                      background: `linear-gradient(180deg, ${b.c}ee, ${b.c})`,
                      position: "relative",
                      display: "flex", alignItems: "center", justifyContent: "space-between",
                      padding: "0 12px",
                      boxShadow: `inset 0 1px 0 rgba(255,255,255,0.2), inset 0 -1px 0 rgba(0,0,0,0.1), 0 1px 3px rgba(0,0,0,0.08)`,
                      borderRadius: b.isResult ? "0 0 8px 8px" : "0",
                      marginTop: "0",
                      transition: "all 0.4s",
                    }}>
                      {/* Studs on top */}
                      {drawStuds(w, `${b.c}cc`, 0)}
                      <span style={{ color: "#fff", fontWeight: 600, fontSize: h > 36 ? "12px" : "10px", fontFamily: "'DM Sans',sans-serif", textShadow: "0 1px 2px rgba(0,0,0,0.3)", zIndex: 1 }}>
                        {b.isResult ? "🎉 " : ""}{b.l}
                      </span>
                      <span style={{ color: "#fff", fontWeight: 700, fontSize: h > 36 ? "13px" : "10px", fontFamily: "'DM Sans',sans-serif", textShadow: "0 1px 2px rgba(0,0,0,0.3)", zIndex: 1 }}>
                        {fmt(b.v)} <span style={{ fontWeight: 500, fontSize: "10px", opacity: 0.85 }}>{pctVal.toFixed(1)}%</span>
                      </span>
                    </div>
                  );
                })}

                {/* Pérdida */}
                {perdida > 0 && (
                  <div style={{
                    width: `${maxW}px`, padding: "10px 12px", marginTop: "4px",
                    background: `repeating-linear-gradient(45deg, ${C.red}22, ${C.red}22 10px, ${C.red}11 10px, ${C.red}11 20px)`,
                    border: `2px dashed ${C.red}`,
                    borderRadius: "0 0 8px 8px", textAlign: "center",
                    fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.red,
                  }}>
                    ⚠️ PÉRDIDA: {fmt(-d.re)} ({pct(perdida, d.ing)})
                    <div style={{ fontSize: "11px", fontWeight: 500, marginTop: "2px" }}>Los costos superan los ingresos</div>
                  </div>
                )}
              </div>

              {/* Legend */}
              <div style={{ minWidth: "100px", paddingBottom: "10px" }}>
                <div style={{ fontSize: "10px", fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.06em", fontFamily: "'DM Sans',sans-serif", marginBottom: "8px" }}>Leyenda</div>
                {[
                  { l: "Food Cost", c: "#e74c3c" },
                  ...d.catTotals.filter(c => c.total > 0).map((c, i) => ({ l: c.name, c: PALETTE_GASTOS[i % PALETTE_GASTOS.length] })),
                  { l: "Impuestos", c: "#bdc3c7" },
                  { l: "Ganancia", c: C.green },
                ].map((item, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "4px" }}>
                    <div style={{ width: "12px", height: "12px", borderRadius: "2px", background: item.c, boxShadow: "inset 0 1px 0 rgba(255,255,255,0.3)" }} />
                    <span style={{ fontSize: "11px", color: C.dark, fontFamily: "'DM Sans',sans-serif" }}>{item.l}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })()}

        <div style={{ marginTop: "14px", padding: "10px", borderRadius: "8px", background: C.bg, fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, textAlign: "center" }}>
          Cada bloque LEGO representa un costo. Tu ganancia es lo que queda abajo después de apilar todos los costos. Si los bloques superan los ingresos, estás en pérdida.
        </div>
      </Card>

      {/* PE + Stats */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "14px" }}>
        <StatCard label="Resultado" value={fmt(d.re)} sub={pct(Math.abs(d.re), d.ing)} color={rc} bgColor={d.re >= 0 ? C.greenBg : C.redBg} icon={d.re >= 0 ? "📈" : "📉"} />
        <StatCard label="Punto Equilibrio" value={d.peU === Infinity ? "N/A" : `${d.peU.toLocaleString(CURRENT_LOCALE)} un.`} sub={d.peV === Infinity ? "" : fmt(d.peV)} color={C.copper} bgColor={`${C.copper}11`} icon="⚖️" />
        <StatCard label="Food Cost %" value={pct(d.cv, d.ing)} color={d.cv / d.ing < 0.30 ? C.green : d.cv / d.ing < 0.40 ? C.amber : C.red} bgColor={d.cv / d.ing < 0.30 ? C.greenBg : d.cv / d.ing < 0.40 ? C.amberBg : C.redBg} icon="🥄" />
        <StatCard label="Prime Cost %" value={pct(d.primeCost, d.ing)} sub="FC + Sueldos (ideal < 60%)" color={pcColor} bgColor={`${pcColor}11`} icon="👨‍🍳" />
      </div>

      {d.peU !== Infinity && (
        <Card title="Punto de Equilibrio — ¿Cuánto necesitás vender?">
          <div style={{ height: "28px", background: "#f3eeea", borderRadius: "8px", overflow: "hidden", position: "relative", marginBottom: "6px" }}>
            <div style={{ position: "absolute", left: 0, top: 0, height: "100%", width: `${Math.min(100, (uv / (d.peU * 1.5)) * 100)}%`, background: uv >= d.peU ? `linear-gradient(90deg,${C.green}aa,${C.green})` : `linear-gradient(90deg,${C.red}aa,${C.red})`, borderRadius: "8px", transition: "all 0.5s" }} />
            <div style={{ position: "absolute", left: `${Math.min(95, (d.peU / (d.peU * 1.5)) * 100)}%`, top: 0, height: "100%", width: "3px", background: C.dark, zIndex: 2 }}>
              <div style={{ position: "absolute", top: "-20px", left: "50%", transform: "translateX(-50%)", fontSize: "10px", fontWeight: 700, color: C.dark, fontFamily: "'DM Sans',sans-serif", whiteSpace: "nowrap", background: "#fff", padding: "1px 5px", borderRadius: "3px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>PE: {d.peU}</div>
            </div>
          </div>
          <div style={{ fontSize: "11px", fontFamily: "'DM Sans',sans-serif", color: C.muted, textAlign: "center" }}>
            Vendés <strong>{uv}</strong> un. → <span style={{ fontWeight: 700, color: uv >= d.peU ? C.green : C.red }}>{uv >= d.peU ? "¡Superaste el PE!" : `Faltan ${d.peU - uv} un.`}</span>
          </div>
          <div style={{ marginTop: "10px", padding: "8px", borderRadius: "6px", background: C.bg, textAlign: "center", fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.dark }}>
            <strong>PE</strong> = Costos Fijos ÷ (PVenta − FC) = {fmt(d.gf)} ÷ ({fmt(pv)} − {fmt(fcU)}) = <strong>{d.peU} un.</strong>
          </div>
        </Card>
      )}
    </div>
  );
}


/* ═══════════════════════════════════════════
   TOOL 3: FLUJO DE CAJA
   ═══════════════════════════════════════════ */
function ToolFlujoCaja() {
  const initRows = [
    { concepto: "Venta efectivo", tipo: "ingreso", cat: "operativo", d1: 150000, d2: 120000, d3: 80000, d4: 200000, d5: 180000, d6: 90000, d7: 160000 },
    { concepto: "Venta transferencia", tipo: "ingreso", cat: "operativo", d1: 50000, d2: 80000, d3: 40000, d4: 60000, d5: 70000, d6: 30000, d7: 55000 },
    { concepto: "Ingredientes", tipo: "egreso", cat: "operativo", d1: 80000, d2: 0, d3: 45000, d4: 0, d5: 60000, d6: 0, d7: 0 },
    { concepto: "Packaging", tipo: "egreso", cat: "operativo", d1: 0, d2: 15000, d3: 0, d4: 0, d5: 0, d6: 0, d7: 12000 },
    { concepto: "Sueldo ayudante", tipo: "egreso", cat: "operativo", d1: 0, d2: 0, d3: 0, d4: 0, d5: 0, d6: 0, d7: 150000 },
    { concepto: "Arriendo", tipo: "egreso", cat: "operativo", d1: 350000, d2: 0, d3: 0, d4: 0, d5: 0, d6: 0, d7: 0 },
    { concepto: "Marketing", tipo: "egreso", cat: "operativo", d1: 0, d2: 0, d3: 25000, d4: 0, d5: 0, d6: 0, d7: 0 },
    { concepto: "Crédito banco", tipo: "ingreso", cat: "financiero", d1: 0, d2: 0, d3: 0, d4: 500000, d5: 0, d6: 0, d7: 0 },
    { concepto: "Cuota crédito", tipo: "egreso", cat: "financiero", d1: 0, d2: 0, d3: 0, d4: 0, d5: 0, d6: 0, d7: 45000 },
    { concepto: "Horno nuevo", tipo: "egreso", cat: "inversion", d1: 0, d2: 0, d3: 0, d4: 0, d5: 800000, d6: 0, d7: 0 },
  ];
  const [rows, setRows] = useState(initRows);
  const [saldoInicial, setSaldoInicial] = useState(200000);
  const [businessName, setBusinessName] = useState("Mi Negocio");
  const days = ["d1", "d2", "d3", "d4", "d5", "d6", "d7"];
  const dayLabels = ["Día 1", "Día 2", "Día 3", "Día 4", "Día 5", "Día 6", "Día 7"];

  const updateCell = (ri, day, val) => {
    const n = [...rows]; n[ri] = { ...n[ri], [day]: Math.max(0, val) }; setRows(n);
  };

  const catLabel = { operativo: "Operativos", financiero: "Financieros", inversion: "Inversión" };
  const catColor = { operativo: C.copper, financiero: C.blue, inversion: C.amber };

  // Compute daily totals
  const dailyData = days.map((day) => {
    let ingreso = 0, egreso = 0;
    rows.forEach(r => { if (r.tipo === "ingreso") ingreso += r[day]; else egreso += r[day]; });
    return { ingreso, egreso, neto: ingreso - egreso };
  });
  // Ingresos / Egresos / Neto diario por categoría
  const subtotalByCat = (cat) => days.map(day => {
    let ing = 0, egr = 0;
    rows.filter(r => r.cat === cat).forEach(r => {
      if (r.tipo === "ingreso") ing += r[day]; else egr += r[day];
    });
    return { ing, egr, neto: ing - egr };
  });
  const saldos = dailyData.reduce((acc, dd, i) => {
    const prev = i === 0 ? saldoInicial : acc[i - 1];
    acc.push(prev + dd.neto);
    return acc;
  }, []);
  const minSaldo = Math.min(saldoInicial, ...saldos);
  const maxSaldo = Math.max(saldoInicial, ...saldos);
  const range = maxSaldo - minSaldo || 1;

  // Chart points
  const chartW = 100; // percentage
  const chartH = 120;
  const points = [saldoInicial, ...saldos].map((s, i) => ({
    x: (i / (days.length)) * chartW,
    y: chartH - ((s - minSaldo) / range) * (chartH - 20) - 10,
    val: s,
  }));
  const pathD = points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");

  const cats = ["operativo", "financiero", "inversion"];

  const handleReset = () => {
    const emptyRows = rows.map(r => {
      const nr = { ...r };
      days.forEach(d => { nr[d] = 0; });
      return nr;
    });
    setRows(emptyRows);
    setSaldoInicial(0);
  };

  const hasAnyNegativeSaldo = saldos.some(s => s < 0);

  const handleExportExcel = async () => {
    const ExcelJS = (await import("exceljs")).default;
    const wb = new ExcelJS.Workbook();
    wb.creator = "Finanzas Tools";
    wb.created = new Date();
    const ws = wb.addWorksheet("Flujo de Caja");
    ws.columns = [{ width: 32 }, ...days.map(() => ({ width: 14 })), { width: 16 }];
    ws.views = [{ state: "frozen", xSplit: 1, ySplit: 3 }];

    const argb = (hex) => "FF" + hex.replace("#", "").toUpperCase();
    const COPPER = argb(C.copper), GREEN = argb(C.green), RED = argb(C.red), MUTED = argb(C.muted);
    const fmtCurrency = `"${CURRENT_SYMBOL}"#,##0;[Red]("${CURRENT_SYMBOL}"#,##0)`;
    const dayCols = ["B", "C", "D", "E", "F", "G", "H"];
    const totalCol = "I";

    // Title
    ws.mergeCells(`A1:${totalCol}1`);
    const t = ws.getCell("A1");
    t.value = `Flujo de Caja Semanal — ${businessName || "Mi Negocio"}`;
    t.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
    t.fill = { type: "pattern", pattern: "solid", fgColor: { argb: COPPER } };
    t.alignment = { horizontal: "center", vertical: "middle" };
    ws.getRow(1).height = 28;

    // Header
    ws.getCell("A3").value = "Concepto";
    dayCols.forEach((col, i) => { ws.getCell(`${col}3`).value = dayLabels[i]; });
    ws.getCell(`${totalCol}3`).value = "Total Semana";
    ["A", ...dayCols, totalCol].forEach(col => {
      const cell = ws.getCell(`${col}3`);
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: argb(C.copperDark) } };
      cell.alignment = { horizontal: col === "A" ? "left" : "center" };
    });

    // Saldo Inicial
    let row = 5;
    ws.getCell(`A${row}`).value = "Saldo Inicial";
    ws.getCell(`B${row}`).value = saldoInicial;
    ws.getCell(`B${row}`).numFmt = fmtCurrency;
    ws.getCell(`A${row}`).font = { bold: true };
    ws.getCell(`B${row}`).font = { bold: true };
    const saldoIniRow = row;
    row += 2;

    const tipos = ["ingreso", "egreso"];
    const tipoLabels = { ingreso: "INGRESOS", egreso: "EGRESOS" };
    const tipoArrow = { ingreso: "↑", egreso: "↓" };
    const tipoArgbColor = { ingreso: GREEN, egreso: RED };
    const catList = ["operativo", "financiero", "inversion"];
    const catLabels = { operativo: "Operativos", financiero: "Financieros", inversion: "Inversión" };
    const catArgbColors = { operativo: COPPER, financiero: argb(C.blue), inversion: argb(C.amber) };

    const totalsByTipo = {};

    tipos.forEach(tipo => {
      const tcolor = tipoArgbColor[tipo];
      // Section header
      ws.mergeCells(`A${row}:${totalCol}${row}`);
      const hcell = ws.getCell(`A${row}`);
      hcell.value = `${tipoArrow[tipo]} ${tipoLabels[tipo]}`;
      hcell.font = { bold: true, size: 12, color: { argb: "FFFFFFFF" } };
      hcell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: tcolor } };
      hcell.alignment = { horizontal: "left", vertical: "middle" };
      ws.getRow(row).height = 20;
      row++;

      const subtotalRows = [];

      catList.forEach(cat => {
        const catTipoRows = rows.filter(r => r.tipo === tipo && r.cat === cat);
        if (catTipoRows.length === 0) return;
        const ccolor = catArgbColors[cat];
        // Cat header
        ws.getCell(`A${row}`).value = catLabels[cat];
        ws.getCell(`A${row}`).font = { bold: true, italic: true, color: { argb: ccolor } };
        row++;
        const firstItemRow = row;
        catTipoRows.forEach(r => {
          ws.getCell(`A${row}`).value = `   ${r.concepto}`;
          ws.getCell(`A${row}`).font = { color: { argb: MUTED } };
          dayCols.forEach((col, di) => {
            ws.getCell(`${col}${row}`).value = r[days[di]] || 0;
            ws.getCell(`${col}${row}`).numFmt = fmtCurrency;
          });
          ws.getCell(`${totalCol}${row}`).value = { formula: `SUM(B${row}:H${row})` };
          ws.getCell(`${totalCol}${row}`).numFmt = fmtCurrency;
          ws.getCell(`${totalCol}${row}`).font = { bold: true, color: { argb: MUTED } };
          row++;
        });
        const lastItemRow = row - 1;
        // Subtotal row
        ws.getCell(`A${row}`).value = `Subtotal ${catLabels[cat]}`;
        ws.getCell(`A${row}`).font = { bold: true, color: { argb: ccolor } };
        dayCols.forEach(col => {
          const cell = ws.getCell(`${col}${row}`);
          cell.value = { formula: `SUM(${col}${firstItemRow}:${col}${lastItemRow})` };
          cell.numFmt = fmtCurrency;
          cell.font = { bold: true, color: { argb: ccolor } };
        });
        const tcell = ws.getCell(`${totalCol}${row}`);
        tcell.value = { formula: `SUM(B${row}:H${row})` };
        tcell.numFmt = fmtCurrency;
        tcell.font = { bold: true, color: { argb: ccolor } };
        ["A", ...dayCols, totalCol].forEach(col => {
          ws.getCell(`${col}${row}`).border = { top: { style: "thin", color: { argb: ccolor } } };
        });
        subtotalRows.push(row);
        row++;
      });

      // Total tipo
      const totalRow = row;
      ws.getCell(`A${row}`).value = `${tipoArrow[tipo]} TOTAL ${tipoLabels[tipo]}`;
      ["A", ...dayCols, totalCol].forEach(col => {
        const cell = ws.getCell(`${col}${row}`);
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: tcolor } };
        cell.numFmt = fmtCurrency;
      });
      dayCols.forEach(col => {
        const cell = ws.getCell(`${col}${row}`);
        cell.value = subtotalRows.length > 0
          ? { formula: subtotalRows.map(sr => `${col}${sr}`).join("+") }
          : 0;
      });
      ws.getCell(`${totalCol}${row}`).value = { formula: `SUM(B${row}:H${row})` };
      ws.getRow(row).height = 20;
      totalsByTipo[tipo] = totalRow;
      row += 2;
    });

    // Saldo Diario = Total Ingresos - Total Egresos
    const saldoDiarioRow = row;
    ws.getCell(`A${row}`).value = "Saldo Diario (neto)";
    ws.getCell(`A${row}`).font = { bold: true };
    dayCols.forEach(col => {
      const cell = ws.getCell(`${col}${row}`);
      cell.value = { formula: `${col}${totalsByTipo.ingreso}-${col}${totalsByTipo.egreso}` };
      cell.numFmt = fmtCurrency;
      cell.font = { bold: true };
    });
    ws.getCell(`${totalCol}${row}`).value = { formula: `SUM(B${row}:H${row})` };
    ws.getCell(`${totalCol}${row}`).numFmt = fmtCurrency;
    ws.getCell(`${totalCol}${row}`).font = { bold: true };
    ["A", ...dayCols, totalCol].forEach(col => {
      ws.getCell(`${col}${row}`).border = { top: { style: "thin" }, bottom: { style: "thin" } };
    });
    row++;

    // Saldo Acumulado
    ws.getCell(`A${row}`).value = "Saldo Acumulado";
    const lightCopper = argb("#f3eeea");
    ["A", ...dayCols, totalCol].forEach(col => {
      const cell = ws.getCell(`${col}${row}`);
      cell.font = { bold: true, color: { argb: COPPER } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: lightCopper } };
      cell.numFmt = fmtCurrency;
      cell.border = { top: { style: "double", color: { argb: COPPER } } };
    });
    // Día 1: SaldoInicial + Saldo Diario(B)
    ws.getCell(`B${row}`).value = { formula: `B${saldoIniRow}+B${saldoDiarioRow}` };
    // Día 2..7: prev + saldo diario
    for (let i = 1; i < 7; i++) {
      ws.getCell(`${dayCols[i]}${row}`).value = { formula: `${dayCols[i - 1]}${row}+${dayCols[i]}${saldoDiarioRow}` };
    }
    ws.getCell(`${totalCol}${row}`).value = { formula: `${dayCols[6]}${row}` };
    ws.getRow(row).height = 22;

    // Hoja Glosario
    const ws2 = wb.addWorksheet("Glosario");
    ws2.columns = [{ width: 28 }, { width: 70 }];
    const glosario = [
      ["Concepto", "Definición"],
      ["Saldo Inicial", "Plata disponible al comenzar la semana"],
      ["Ingresos", "Plata que entra al negocio (ventas, créditos, etc.)"],
      ["Egresos", "Plata que sale (compras, sueldos, cuotas, inversiones)"],
      ["Operativos", "Movimientos del día a día del negocio"],
      ["Financieros", "Préstamos, cuotas de crédito, intereses"],
      ["Inversión", "Compra de equipos o activos de mayor valor"],
      ["Saldo Diario", "Ingresos − Egresos del día. Cuánto sumó (o restó) ese día."],
      ["Saldo Acumulado", "Saldo Inicial + suma de Saldos Diarios. Lo que tenés en caja al cierre."],
      ["Saldo negativo", "Si aparece en rojo, en algún momento de la semana te quedaste sin caja."],
    ];
    glosario.forEach((r, i) => {
      ws2.getCell(`A${i + 1}`).value = r[0];
      ws2.getCell(`B${i + 1}`).value = r[1];
      if (i === 0) {
        ws2.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
        ws2.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: COPPER } };
      } else {
        ws2.getCell(`A${i + 1}`).font = { bold: true };
        ws2.getCell(`B${i + 1}`).alignment = { wrapText: true, vertical: "top" };
      }
    });

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `FlujoCaja_${(businessName || "negocio").replace(/[^a-z0-9]/gi, "_")}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <button onClick={handleExportExcel}
          style={{ padding: "8px 14px", background: C.green, color: "#fff", border: "none", borderRadius: "8px",
            fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "12px", cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)", display: "flex", alignItems: "center", gap: "6px" }}>
          📥 Exportar a Excel (con fórmulas)
        </button>
      </div>

      <Card title="Saldo inicial">
        <div style={{ marginBottom: "10px" }}>
          <label style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif" }}>Nombre del negocio (para el Excel)</label>
          <input value={businessName} onChange={e => setBusinessName(e.target.value)}
            style={{ width: "100%", padding: "7px 8px", border: `1.5px solid ${C.line}`, borderRadius: "6px", fontSize: "13px", fontWeight: 600, color: C.dark, background: "#fdfcfb", fontFamily: "'DM Sans',sans-serif", outline: "none" }} />
        </div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <div style={{ flex: 1 }}><NumInput value={saldoInicial} onChange={setSaldoInicial} step={10000} /></div>
          <button onClick={handleReset} style={{
            padding: "8px 14px", border: `1.5px solid ${C.red}44`, borderRadius: "8px", cursor: "pointer",
            fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700,
            background: C.redBg, color: C.red, whiteSpace: "nowrap", transition: "all 0.2s",
          }}
          onMouseEnter={e => { e.target.style.background = C.red; e.target.style.color = "#fff"; }}
          onMouseLeave={e => { e.target.style.background = C.redBg; e.target.style.color = C.red; }}
          >🗑️ Borrar todo</button>
        </div>
      </Card>

      {/* Grid table */}
      <Card title="Movimientos diarios">
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "'DM Sans',sans-serif", fontSize: "12px" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "6px 4px", color: C.muted, fontWeight: 700, fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.06em", position: "sticky", left: 0, background: C.card, zIndex: 1, minWidth: "100px" }}>Concepto</th>
                {dayLabels.map((dl, i) => <th key={i} style={{ padding: "6px 2px", color: C.muted, fontWeight: 700, fontSize: "10px", textTransform: "uppercase", textAlign: "center", minWidth: "70px" }}>{dl}</th>)}
              </tr>
            </thead>
            <tbody>
              {["ingreso", "egreso"].map(tipo => {
                const tipoRows = rows.filter(r => r.tipo === tipo);
                if (tipoRows.length === 0) return null;
                const tipoColor = tipo === "ingreso" ? C.green : C.red;
                const tipoLabel = tipo === "ingreso" ? "INGRESOS" : "EGRESOS";
                const tipoArrow = tipo === "ingreso" ? "↑" : "↓";
                const totalBg = `${tipoColor}1a`;

                return (
                  <React.Fragment key={tipo}>
                    {/* Section header */}
                    <tr>
                      <td colSpan={8} style={{
                        padding: "8px 4px 3px", fontWeight: 700, color: tipoColor,
                        fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.08em",
                        borderTop: `2px solid ${tipoColor}44`,
                      }}>
                        {tipoArrow} {tipoLabel}
                      </td>
                    </tr>

                    {/* Por categoría */}
                    {cats.map(cat => {
                      const catTipoRows = tipoRows.filter(r => r.cat === cat);
                      if (catTipoRows.length === 0) return null;
                      const catBg = `${catColor[cat]}0d`;
                      const catSubtotal = subtotalByCat(cat).map(s => tipo === "ingreso" ? s.ing : s.egr);

                      return (
                        <React.Fragment key={`${tipo}-${cat}`}>
                          <tr>
                            <td colSpan={8} style={{
                              padding: "5px 4px 2px", fontWeight: 700, color: catColor[cat],
                              fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.06em",
                              borderTop: `1px solid ${C.line}`,
                            }}>
                              {catLabel[cat]}
                            </td>
                          </tr>
                          {catTipoRows.map((r, ri) => {
                            const idx = rows.indexOf(r);
                            const rowBg = ri % 2 === 0 ? "#fdfcfb" : "#fff";
                            return (
                              <tr key={idx} style={{ background: rowBg }}>
                                <td style={{ padding: "4px", fontWeight: 600, color: C.dark, position: "sticky", left: 0, background: rowBg, zIndex: 1 }}>
                                  <span style={{ color: tipoColor, marginRight: "4px" }}>{tipoArrow}</span>{r.concepto}
                                </td>
                                {days.map(day => (
                                  <td key={day} style={{ padding: "2px" }}>
                                    <input type="text" inputMode="numeric"
                                      value={r[day] > 0 ? r[day].toLocaleString(CURRENT_LOCALE) : ""}
                                      placeholder="0"
                                      onChange={e => updateCell(idx, day, Number(e.target.value.replace(/\D/g, "") || 0))}
                                      style={{
                                        width: "100%", padding: "3px 2px", border: `1px solid ${C.line}`, borderRadius: "4px",
                                        fontSize: "12px", textAlign: "right", fontFamily: "'DM Sans',sans-serif",
                                        color: r[day] === 0 ? "#ccc" : tipoColor,
                                        fontWeight: r[day] === 0 ? 400 : 600, background: "transparent",
                                      }} />
                                  </td>
                                ))}
                              </tr>
                            );
                          })}
                          <tr style={{ background: catBg }}>
                            <td style={{ padding: "4px", fontWeight: 600, color: catColor[cat], fontSize: "11px", position: "sticky", left: 0, background: catBg, zIndex: 1, paddingLeft: "16px" }}>
                              Subtotal {catLabel[cat]}
                            </td>
                            {catSubtotal.map((v, i) => (
                              <td key={i} style={{ padding: "4px 2px", fontWeight: 600, textAlign: "center", color: catColor[cat], fontSize: "12px", fontFamily: "'DM Sans',sans-serif" }}>
                                {v === 0 ? "—" : fmt(tipo === "ingreso" ? v : -v)}
                              </td>
                            ))}
                          </tr>
                        </React.Fragment>
                      );
                    })}

                    {/* Total del tipo */}
                    <tr style={{ background: totalBg, borderTop: `1.5px solid ${tipoColor}` }}>
                      <td style={{ padding: "6px 4px", fontWeight: 700, color: tipoColor, position: "sticky", left: 0, background: totalBg, zIndex: 1, fontSize: "12px" }}>
                        {tipoArrow} TOTAL {tipoLabel}
                      </td>
                      {dailyData.map((dd, i) => {
                        const v = tipo === "ingreso" ? dd.ingreso : dd.egreso;
                        return (
                          <td key={i} style={{ padding: "6px 2px", fontWeight: 700, textAlign: "center", color: tipoColor, fontSize: "12px", fontFamily: "'DM Sans',sans-serif" }}>
                            {v === 0 ? "—" : fmt(tipo === "ingreso" ? v : -v)}
                          </td>
                        );
                      })}
                    </tr>
                  </React.Fragment>
                );
              })}
              <tr style={{ borderTop: `2px solid ${C.copper}` }}>
                <td style={{ padding: "6px 4px", fontWeight: 700, color: C.dark, position: "sticky", left: 0, background: C.card, zIndex: 1 }}>Saldo Diario</td>
                {dailyData.map((dd, i) => (
                  <td key={i} style={{ padding: "6px 2px", fontWeight: 700, textAlign: "center", color: dd.neto >= 0 ? C.green : C.red, fontSize: "12px" }}>
                    {fmt(dd.neto)}
                  </td>
                ))}
              </tr>
              <tr style={{ background: `${C.copper}0d` }}>
                <td style={{ padding: "6px 4px", fontWeight: 700, color: C.copperDark, position: "sticky", left: 0, background: `${C.copper}0d`, zIndex: 1 }}>Saldo Acumulado</td>
                {saldos.map((s, i) => (
                  <td key={i} style={{ padding: "6px 2px", fontWeight: 700, textAlign: "center", color: s >= 0 ? C.copperDark : C.red, fontSize: "12px" }}>
                    {fmt(s)}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </Card>

      {/* Chart */}
      <Card title="Evolución del saldo">
        <svg viewBox={`-5 -25 ${chartW + 10} ${chartH + 15}`} style={{ width: "100%", height: "160px" }}>
          {/* Zero line */}
          {minSaldo < 0 && (
            <line x1={0} y1={chartH - ((0 - minSaldo) / range) * (chartH - 20) - 10} x2={chartW} y2={chartH - ((0 - minSaldo) / range) * (chartH - 20) - 10}
              stroke={C.red} strokeWidth="0.3" strokeDasharray="2,2" />
          )}
          {/* Area */}
          <path d={`${pathD} L ${points[points.length - 1].x} ${chartH} L ${points[0].x} ${chartH} Z`} fill={`${C.copper}15`} />
          {/* Line */}
          <path d={pathD} fill="none" stroke={C.copper} strokeWidth="1.5" strokeLinejoin="round" />
          {/* Dots + labels */}
          {points.map((p, i) => (
            <g key={i}>
              <circle cx={p.x} cy={p.y} r="3" fill={p.val >= 0 ? C.copper : C.red} stroke="#fff" strokeWidth="1.5" />
              <text x={p.x} y={p.y - 8} textAnchor="middle" fill={p.val >= 0 ? C.dark : C.red} fontSize="5" fontWeight="700" fontFamily="DM Sans,sans-serif">
                {p.val >= 0 ? "" : "-"}${Math.abs(Math.round(p.val / 1000))}k
              </text>
            </g>
          ))}
          {/* X labels */}
          {["Inicio", ...dayLabels].map((l, i) => (
            <text key={i} x={points[i]?.x || 0} y={chartH + 10} textAnchor="middle" fill={C.muted} fontSize="4" fontFamily="DM Sans,sans-serif">{l}</text>
          ))}
        </svg>
        {hasAnyNegativeSaldo && (
          <div style={{ padding: "8px 12px", borderRadius: "8px", background: C.redBg, border: `1.5px solid ${C.red}22`, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.red, fontWeight: 600, marginTop: "8px" }}>
            ⚠️ ¡Ojo! Tu saldo queda negativo en algún día. Revisá los tiempos de cobros y pagos.
          </div>
        )}
        {!hasAnyNegativeSaldo && saldos.some(s => s > 0) && (
          <div style={{ padding: "8px 12px", borderRadius: "8px", background: C.greenBg, border: `1.5px solid ${C.green}22`, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.green, fontWeight: 600, marginTop: "8px" }}>
            ✅ Tu saldo se mantiene positivo toda la semana. ¡Buena liquidez!
          </div>
        )}
        <div style={{ marginTop: "10px", padding: "8px", borderRadius: "6px", background: C.bg, textAlign: "center", fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.dark }}>
          <strong>Clave:</strong> El Flujo de Caja muestra <em>cuándo</em> entra y sale la plata. Podés ser rentable en el EERR y quedarte sin liquidez si los tiempos no calzan.
        </div>
      </Card>
    </div>
  );
}


/* ═══════════════════════════════════════════
   TOOL 4: BALANCE (transaction-based)
   ═══════════════════════════════════════════ */
const INITIAL_BALANCE = {
  efectivo: 1000000, cxc: 0, inventario: 0, maquinaria: 0,
  cxp: 0, prestamo: 0,
  capital: 1000000, utilidades: 0,
};

const TRANSACTIONS = [
  // COMPRAS
  { id: "compra_ing_contado", label: "Comprar ingredientes (contado)", emoji: "🛒", cat: "compras",
    desc: "Pagás efectivo, te llegan ingredientes.", efecto: "↓ Efectivo  ↑ Inventario",
    validate: (b, m) => b.efectivo >= m ? null : "No tenés suficiente efectivo.",
    apply: (b, m) => ({ ...b, efectivo: b.efectivo - m, inventario: b.inventario + m }) },
  { id: "compra_ing_credito", label: "Comprar ingredientes (crédito)", emoji: "📝", cat: "compras",
    desc: "Te llegan ingredientes, quedás debiendo al proveedor.", efecto: "↑ Inventario  ↑ Cuentas por Pagar",
    apply: (b, m) => ({ ...b, inventario: b.inventario + m, cxp: b.cxp + m }) },
  { id: "compra_maq_contado", label: "Comprar maquinaria (contado)", emoji: "🔧", cat: "compras",
    desc: "Pagás efectivo por una máquina nueva.", efecto: "↓ Efectivo  ↑ Maquinaria",
    validate: (b, m) => b.efectivo >= m ? null : "No tenés suficiente efectivo.",
    apply: (b, m) => ({ ...b, efectivo: b.efectivo - m, maquinaria: b.maquinaria + m }) },
  { id: "compra_maq_credito", label: "Comprar maquinaria (crédito)", emoji: "🔧", cat: "compras",
    desc: "Comprás la máquina, quedás debiendo.", efecto: "↑ Maquinaria  ↑ Cuentas por Pagar",
    apply: (b, m) => ({ ...b, maquinaria: b.maquinaria + m, cxp: b.cxp + m }) },
  // PAGOS
  { id: "pagar_proveedor", label: "Pagar deuda a proveedor", emoji: "💳", cat: "pagos",
    desc: "Cancelás lo que le debías a un proveedor.", efecto: "↓ Efectivo  ↓ Cuentas por Pagar",
    validate: (b, m) => {
      if (b.cxp <= 0) return "No tenés deudas con proveedores. Primero comprá a crédito.";
      if (m > b.cxp) return `Solo debés ${fmt(b.cxp)} a proveedores.`;
      if (b.efectivo < m) return "No tenés suficiente efectivo.";
      return null;
    },
    apply: (b, m) => ({ ...b, efectivo: b.efectivo - m, cxp: b.cxp - m }) },
  // VENTAS
  { id: "venta_contado", label: "Venta al contado", emoji: "💰", cat: "ventas", isVenta: true,
    desc: "Vendés y cobrás al toque. Sale inventario (costo), entra efectivo, la diferencia es ganancia.",
    efecto: "↑ Efectivo  ↓ Inventario  ↑ Utilidades",
    note: "Ajustá el Food Cost % para ver cómo cambia la ganancia.",
    validate: (b, m, fcPct = 35) => {
      const costo = Math.round(m * fcPct / 100);
      if (b.inventario < costo) return `No tenés suficiente inventario. Necesitás ${fmt(costo)} (${fcPct}% de la venta).`;
      return null;
    },
    apply: (b, m, fcPct = 35) => { const c = Math.round(m * fcPct / 100); return { ...b, efectivo: b.efectivo + m, inventario: b.inventario - c, utilidades: b.utilidades + (m - c) }; } },
  { id: "venta_credito", label: "Venta a crédito (fiado)", emoji: "📋", cat: "ventas", isVenta: true,
    desc: "Vendés pero el cliente paga después. No entra efectivo todavía.",
    efecto: "↑ Cuentas por Cobrar  ↓ Inventario  ↑ Utilidades",
    note: "El cliente te debe. Hasta que no cobre, la plata no está en tu bolsillo.",
    validate: (b, m, fcPct = 35) => {
      const costo = Math.round(m * fcPct / 100);
      if (b.inventario < costo) return `No tenés suficiente inventario. Necesitás ${fmt(costo)} (${fcPct}% de la venta).`;
      return null;
    },
    apply: (b, m, fcPct = 35) => { const c = Math.round(m * fcPct / 100); return { ...b, cxc: b.cxc + m, inventario: b.inventario - c, utilidades: b.utilidades + (m - c) }; } },
  { id: "cobrar_cliente", label: "Cobrar cuenta de cliente", emoji: "🤝", cat: "ventas",
    desc: "El cliente te paga lo que te debía.", efecto: "↑ Efectivo  ↓ Cuentas por Cobrar",
    validate: (b, m) => {
      if (b.cxc <= 0) return "No tenés cuentas por cobrar. Primero vendé a crédito.";
      if (m > b.cxc) return `Solo te deben ${fmt(b.cxc)}.`;
      return null;
    },
    apply: (b, m) => ({ ...b, efectivo: b.efectivo + m, cxc: b.cxc - m }) },
  // FINANCIAMIENTO
  { id: "tomar_prestamo", label: "Tomar préstamo bancario", emoji: "🏦", cat: "financiamiento",
    desc: "El banco te presta plata. Más efectivo pero más deuda.", efecto: "↑ Efectivo  ↑ Préstamo",
    apply: (b, m) => ({ ...b, efectivo: b.efectivo + m, prestamo: b.prestamo + m }) },
  { id: "pagar_prestamo", label: "Pagar cuota préstamo", emoji: "📤", cat: "financiamiento",
    desc: "Devolvés plata al banco.", efecto: "↓ Efectivo  ↓ Préstamo",
    validate: (b, m) => {
      if (b.prestamo <= 0) return "No tenés préstamo pendiente.";
      if (m > b.prestamo) return `Solo debés ${fmt(b.prestamo)} de préstamo.`;
      if (b.efectivo < m) return "No tenés suficiente efectivo.";
      return null;
    },
    apply: (b, m) => ({ ...b, efectivo: b.efectivo - m, prestamo: b.prestamo - m }) },
  { id: "aporte_capital", label: "Aporte de capital (socio)", emoji: "🙋", cat: "financiamiento",
    desc: "Un socio mete plata al negocio.", efecto: "↑ Efectivo  ↑ Capital",
    apply: (b, m) => ({ ...b, efectivo: b.efectivo + m, capital: b.capital + m }) },
];

const TX_CATS = [
  { key: "compras", label: "── Compras ──" },
  { key: "pagos", label: "── Pagos ──" },
  { key: "ventas", label: "── Ventas ──" },
  { key: "financiamiento", label: "── Financiamiento ──" },
];

function ToolBalance() {
  const [bal, setBal] = useState(INITIAL_BALANCE);
  const [selectedTx, setSelectedTx] = useState(TRANSACTIONS[0].id);
  const [monto, setMonto] = useState(100000);
  const [fcPctVenta, setFcPctVenta] = useState(35);
  const [history, setHistory] = useState([]);
  const [flash, setFlash] = useState({});
  const [error, setError] = useState(null);

  const tx = TRANSACTIONS.find(t => t.id === selectedTx);

  const applyTx = () => {
    setError(null);
    if (monto <= 0) { setError("Ingresá un monto mayor a 0."); return; }
    if (tx.validate) {
      const err = tx.validate(bal, monto, fcPctVenta);
      if (err) { setError(err); return; }
    }
    const prev = { ...bal };
    const next = tx.apply(bal, monto, fcPctVenta);
    setBal(next);
    setHistory(h => [...h, { tx: tx.label, emoji: tx.emoji, monto, efecto: tx.efecto }]);
    const changed = {};
    Object.keys(next).forEach(k => { if (next[k] !== prev[k]) changed[k] = next[k] > prev[k] ? "up" : "down"; });
    setFlash(changed);
    setTimeout(() => setFlash({}), 800);
  };

  const reset = () => { setBal(INITIAL_BALANCE); setHistory([]); setFlash({}); setError(null); };

  const accounts = {
    activos: [
      { key: "efectivo", label: "Efectivo", icon: "💵" },
      { key: "cxc", label: "Cuentas por Cobrar", icon: "📋" },
      { key: "inventario", label: "Inventario", icon: "📦" },
      { key: "maquinaria", label: "Maquinaria", icon: "🔧" },
    ],
    pasivos: [
      { key: "cxp", label: "Cuentas por Pagar", icon: "🧾" },
      { key: "prestamo", label: "Préstamo", icon: "🏦" },
    ],
    patrimonio: [
      { key: "capital", label: "Capital", icon: "🙋" },
      { key: "utilidades", label: "Utilidades", icon: "📈" },
    ],
  };

  const totalA = accounts.activos.reduce((s, a) => s + bal[a.key], 0);
  const totalP = accounts.pasivos.reduce((s, p) => s + bal[p.key], 0);
  const totalPat = accounts.patrimonio.reduce((s, p) => s + bal[p.key], 0);
  const totalPyP = totalP + totalPat;
  const balanced = Math.abs(totalA - totalPyP) < 1;
  const maxBar = Math.max(totalA, totalPyP, 1);

  const flashStyle = (key) => {
    if (!flash[key]) return {};
    return {
      animation: "none",
      background: flash[key] === "up" ? `${C.green}22` : `${C.red}22`,
      borderColor: flash[key] === "up" ? C.green : C.red,
      transition: "background 0.3s",
    };
  };

  const AcctRow = ({ acct }) => (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "6px 8px", borderRadius: "6px", marginBottom: "3px",
      border: `1.5px solid ${flash[acct.key] ? (flash[acct.key] === "up" ? C.green : C.red) : "transparent"}`,
      ...flashStyle(acct.key), transition: "all 0.4s",
    }}>
      <span style={{ fontSize: "12px", fontFamily: "'DM Sans',sans-serif", color: C.dark }}>
        <span style={{ marginRight: "4px" }}>{acct.icon}</span>{acct.label}
      </span>
      <span style={{ fontSize: "14px", fontWeight: 700, fontFamily: "'DM Sans',sans-serif",
        color: bal[acct.key] < 0 ? C.red : C.dark }}>
        {fmt(bal[acct.key])}
        {flash[acct.key] && <span style={{ fontSize: "11px", marginLeft: "4px", color: flash[acct.key] === "up" ? C.green : C.red }}>{flash[acct.key] === "up" ? "▲" : "▼"}</span>}
      </span>
    </div>
  );

  return (
    <div>
      {/* Balanza visual */}
      <Card title="La balanza">
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "center", gap: "16px", padding: "8px 0 20px", position: "relative" }}>
          <div style={{ position: "absolute", bottom: 0, left: "50%", transform: "translateX(-50%)", width: 0, height: 0, borderLeft: "18px solid transparent", borderRight: "18px solid transparent", borderBottom: `18px solid ${C.copper}`, zIndex: 2 }} />
          <div style={{ position: "absolute", bottom: 0, left: "10%", right: "10%", height: "3px", background: C.copper, borderRadius: "2px",
            transform: `rotate(${Math.max(-4, Math.min(4, (totalA - totalPyP) / (maxBar * 0.12)))}deg)`,
            transformOrigin: "center", transition: "transform 0.5s" }} />
          {[
            { label: "Activos", total: totalA, color: C.copper },
            { label: "Pasivos + Patrimonio", total: totalPyP, color: C.blue },
          ].map((side, si) => (
            <div key={si} style={{ flex: 1, textAlign: "center" }}>
              <div style={{ fontSize: "10px", fontWeight: 700, color: side.color, textTransform: "uppercase", letterSpacing: "0.06em", fontFamily: "'DM Sans',sans-serif", marginBottom: "4px" }}>{side.label}</div>
              <div style={{ height: `${Math.max(28, (side.total / maxBar) * 90)}px`, background: `linear-gradient(180deg, ${side.color}cc, ${side.color})`, borderRadius: "6px 6px 0 0", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: "13px", fontFamily: "'DM Sans',sans-serif", transition: "height 0.5s", margin: "0 16px" }}>
                {fmt(side.total)}
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", padding: "6px", borderRadius: "6px", background: balanced ? C.greenBg : C.redBg, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: balanced ? C.green : C.red }}>
          {balanced ? "✅ Balanceado: A = P + Pat" : `⚠️ Descuadre ${fmt(totalA - totalPyP)}`}
        </div>
      </Card>

      {/* Transaction panel */}
      <Card title="Registrar movimiento">
        <select value={selectedTx} onChange={e => { setSelectedTx(e.target.value); setError(null); }}
          style={{ width: "100%", padding: "10px", border: `1.5px solid ${C.line}`, borderRadius: "8px", fontSize: "13px", fontFamily: "'DM Sans',sans-serif", fontWeight: 600, color: C.dark, background: "#fdfcfb", marginBottom: "8px", cursor: "pointer" }}>
          {TX_CATS.map(cat => (
            <optgroup key={cat.key} label={cat.label}>
              {TRANSACTIONS.filter(t => t.cat === cat.key).map(t => (
                <option key={t.id} value={t.id}>{t.emoji} {t.label}</option>
              ))}
            </optgroup>
          ))}
        </select>

        <div style={{ padding: "8px 10px", borderRadius: "8px", background: `${C.copper}08`, marginBottom: "6px", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.muted }}>
          <div style={{ marginBottom: "3px" }}><strong style={{ color: C.dark }}>¿Qué pasa?</strong> {tx.desc}</div>
          <div style={{ fontSize: "12px", fontWeight: 700, color: C.copperDark, letterSpacing: "0.02em" }}>{tx.efecto}</div>
          {tx.note && <div style={{ fontSize: "11px", fontStyle: "italic", marginTop: "2px" }}>{tx.note}</div>}
        </div>

        {/* Food Cost % slider + desglose (solo para ventas) */}
        {tx.isVenta && (() => {
          const costo = Math.round(monto * fcPctVenta / 100);
          const ganancia = monto - costo;
          const cuentaEntra = tx.id === "venta_contado" ? "Efectivo" : "Cuentas por Cobrar";
          return (
            <div style={{ padding: "10px 12px", borderRadius: "8px", background: "#fdfcfb", border: `1.5px solid ${C.copper}33`, marginBottom: "6px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "6px" }}>
                <label style={{ fontSize: "11px", fontWeight: 700, color: C.dark, letterSpacing: "0.04em", textTransform: "uppercase", fontFamily: "'DM Sans',sans-serif" }}>Food Cost % de la venta</label>
                <span style={{ fontSize: "15px", fontWeight: 700, color: C.red, fontFamily: "'DM Sans',sans-serif" }}>{fcPctVenta}%</span>
              </div>
              <input type="range" min={10} max={80} step={1} value={fcPctVenta} onChange={e => setFcPctVenta(Number(e.target.value))}
                style={{ width: "100%", height: "5px", borderRadius: "3px", appearance: "none", outline: "none", cursor: "pointer",
                  background: `linear-gradient(90deg, ${C.red} ${((fcPctVenta - 10) / (80 - 10)) * 100}%, #e0d6cf ${((fcPctVenta - 10) / (80 - 10)) * 100}%)` }} />
              <div style={{ fontSize: "10px", color: "#999", fontFamily: "'DM Sans',sans-serif", marginTop: "2px", display: "flex", justifyContent: "space-between" }}>
                <span>10%</span><span>Cuánto cuesta producir lo que vendés</span><span>80%</span>
              </div>

              {/* Desglose en vivo */}
              <div style={{ marginTop: "10px", padding: "10px", borderRadius: "6px", background: "#fff", border: `1px solid ${C.line}`, fontFamily: "'DM Sans',sans-serif" }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", fontWeight: 700, color: C.dark, marginBottom: "6px", paddingBottom: "4px", borderBottom: `1px dashed ${C.line}` }}>
                  <span>Monto de venta</span><span>{fmt(monto)}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", fontSize: "12px", marginBottom: "3px" }}>
                  <span style={{ color: C.muted, marginRight: "4px" }}>├─</span>
                  <span style={{ flex: 1, color: C.red }}>Sale de inventario ({fcPctVenta}%)</span>
                  <span style={{ fontWeight: 700, color: C.red }}>{fmt(costo)}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", fontSize: "12px" }}>
                  <span style={{ color: C.muted, marginRight: "4px" }}>└─</span>
                  <span style={{ flex: 1, color: C.green }}>Va a utilidades ({100 - fcPctVenta}%)</span>
                  <span style={{ fontWeight: 700, color: C.green }}>{fmt(ganancia)}</span>
                </div>
                <div style={{ marginTop: "8px", paddingTop: "6px", borderTop: `1px dashed ${C.line}`, fontSize: "11px", color: C.muted, lineHeight: 1.4 }}>
                  Cobrás {fmt(monto)} en <strong style={{ color: C.dark }}>{cuentaEntra}</strong>, pero solo {fmt(ganancia)} es ganancia real. El resto es el costo de lo que ya tenías en inventario.
                </div>
              </div>
            </div>
          );
        })()}

        {error && (
          <div style={{ padding: "7px 10px", borderRadius: "6px", background: C.redBg, border: `1.5px solid ${C.red}22`, marginBottom: "8px", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.red, fontWeight: 600 }}>
            ⚠️ {error}
          </div>
        )}

        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <div style={{ flex: 1 }}><NumInput value={monto} onChange={setMonto} step={10000} /></div>
          <button onClick={applyTx} style={{
            padding: "10px 20px", border: "none", borderRadius: "8px", cursor: "pointer",
            fontFamily: "'DM Sans',sans-serif", fontSize: "13px", fontWeight: 700,
            background: `linear-gradient(135deg, ${C.copper}, ${C.copperDark})`, color: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)", whiteSpace: "nowrap",
          }}>Aplicar</button>
          <button onClick={reset} style={{
            padding: "10px 12px", border: `1.5px solid ${C.line}`, borderRadius: "8px", cursor: "pointer",
            fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600, background: "#fff", color: C.muted,
          }}>Reset</button>
        </div>
      </Card>

      {/* Balance accounts */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
        <Card title="Activos" style={{ marginBottom: 0 }}>
          {accounts.activos.map(a => <AcctRow key={a.key} acct={a} />)}
          <div style={{ borderTop: `2px solid ${C.copper}`, marginTop: "6px", paddingTop: "6px", display: "flex", justifyContent: "space-between", fontFamily: "'DM Sans',sans-serif", fontSize: "14px", fontWeight: 700, color: C.copperDark }}>
            <span>Total</span><span>{fmt(totalA)}</span>
          </div>
        </Card>

        <div>
          <Card title="Pasivos" style={{ marginBottom: "10px" }}>
            {accounts.pasivos.map(a => <AcctRow key={a.key} acct={a} />)}
            <div style={{ borderTop: `1.5px solid ${C.blue}`, marginTop: "4px", paddingTop: "4px", display: "flex", justifyContent: "space-between", fontFamily: "'DM Sans',sans-serif", fontSize: "13px", fontWeight: 700, color: C.blue }}>
              <span>Total</span><span>{fmt(totalP)}</span>
            </div>
          </Card>
          <Card title="Patrimonio" style={{ marginBottom: 0 }}>
            {accounts.patrimonio.map(a => <AcctRow key={a.key} acct={a} />)}
            <div style={{ borderTop: `1.5px solid ${C.green}`, marginTop: "4px", paddingTop: "4px", display: "flex", justifyContent: "space-between", fontFamily: "'DM Sans',sans-serif", fontSize: "13px", fontWeight: 700, color: C.green }}>
              <span>Total</span><span>{fmt(totalPat)}</span>
            </div>
          </Card>
        </div>
      </div>
      <div style={{ height: "10px" }} />

      {/* Transaction history */}
      {history.length > 0 && (
        <Card title={`Historial (${history.length} movimientos)`}>
          <div style={{ maxHeight: "200px", overflowY: "auto" }}>
            {history.slice().reverse().map((h, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "5px 6px", borderRadius: "6px", background: i % 2 === 0 ? "#fdfcfb" : "#fff", fontSize: "12px", fontFamily: "'DM Sans',sans-serif" }}>
                <span style={{ fontSize: "16px" }}>{h.emoji}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, color: C.dark }}>{h.tx}</div>
                  <div style={{ fontSize: "10px", color: C.muted }}>{h.efecto}</div>
                </div>
                <span style={{ fontWeight: 700, color: C.copperDark }}>{fmt(h.monto)}</span>
              </div>
            ))}
          </div>
        </Card>
      )}

      <Card>
        <div style={{ textAlign: "center", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark }}>
          <strong>Ecuación fundamental:</strong> Activos = Pasivos + Patrimonio
          <br /><span style={{ color: C.muted, fontSize: "11px" }}>Cada movimiento toca al menos 2 cuentas. La balanza siempre queda equilibrada — esa es la magia de la partida doble.</span>
        </div>
      </Card>
    </div>
  );
}


/* ═══════════════════════════════════════════
   TOOL 5: CURVA DE OFERTA Y DEMANDA
   ═══════════════════════════════════════════ */
function ToolCurvaPrecios() {
  // Fixed curves, movable price line
  const [precio, setPrecio] = useState(2500);

  // Curve parameters (fixed)
  const demPMax = 5000;  // precio donde Q demanda = 0
  const demQMax = 1000;  // Q demanda cuando P = 0
  const ofPMin = 500;    // precio donde Q oferta = 0
  const ofPMax = 5500;   // precio donde oferta alcanza max
  const ofQMax = 1000;   // Q oferta max

  // Equilibrium (analytical)
  // Demand: Q = demQMax * (1 - P/demPMax)
  // Supply: Q = ofQMax * ((P - ofPMin) / (ofPMax - ofPMin))  (clamp >=0)
  // Set equal → solve for P
  const eqP = (demPMax * ofQMax * ofPMin / (ofPMax - ofPMin) + demQMax * demPMax) / (demQMax + demPMax * ofQMax / (ofPMax - ofPMin));
  const eqQ = demQMax * (1 - eqP / demPMax);

  // At current price
  const qDemanda = Math.max(0, demQMax * (1 - precio / demPMax));
  const qOferta = Math.max(0, ofQMax * ((precio - ofPMin) / (ofPMax - ofPMin)));
  const exceso = qOferta - qDemanda;
  const isExcesoOferta = exceso > 0;
  const isExcesoDemanda = exceso < 0;
  const isEquilibrio = Math.abs(exceso) < 5;

  // Chart
  const W = 340, H = 260, pad = 48;
  const innerW = W - pad * 2, innerH = H - pad * 2;
  const maxP = demPMax * 1.15;
  const maxQ = Math.max(demQMax, ofQMax) * 1.15;
  const toX = q => pad + (q / maxQ) * innerW;
  const toY = p => pad + innerH - (p / maxP) * innerH;

  // Generate curve points
  const demPts = [], supPts = [];
  for (let i = 0; i <= 60; i++) {
    const q = (i / 60) * maxQ;
    const pd = demPMax * (1 - q / demQMax);
    if (pd >= 0 && q <= demQMax) demPts.push({ q, p: pd });
    const ps = ofPMin + (ofPMax - ofPMin) * (q / ofQMax);
    if (q <= ofQMax && ps <= maxP) supPts.push({ q, p: ps });
  }
  const demPath = demPts.map((pt, i) => `${i === 0 ? "M" : "L"} ${toX(pt.q).toFixed(1)} ${toY(pt.p).toFixed(1)}`).join(" ");
  const supPath = supPts.map((pt, i) => `${i === 0 ? "M" : "L"} ${toX(pt.q).toFixed(1)} ${toY(pt.p).toFixed(1)}`).join(" ");

  // Excess area (between qDemanda and qOferta at current price)
  const excessColor = isExcesoOferta ? C.blue : C.red;

  // Grid
  const gridPs = [1000, 2000, 3000, 4000, 5000].filter(p => p < maxP);
  const gridQs = [200, 400, 600, 800, 1000].filter(q => q < maxQ);

  return (
    <div>
      {/* Pedagogical example: cookies and people */}
      <Card title="🍪 Pensemos con un ejemplo">
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "13px", color: C.dark, marginBottom: "14px", lineHeight: 1.55 }}>
          Imaginá un grupo de personas. La mitad estaría dispuesta a <strong>comprar</strong> cookies, la otra mitad podría <strong>fabricarlas</strong> y venderlas. Lo que cada grupo hace depende del precio.
        </div>

        {/* DEMANDA */}
        <div style={{ padding: "12px", borderRadius: "10px", background: `${C.red}08`, border: `1.5px solid ${C.red}33`, marginBottom: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
            <span style={{ fontSize: "20px" }}>🛒</span>
            <span style={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "13px", color: C.red, textTransform: "uppercase", letterSpacing: "0.04em" }}>
              Demanda: ¿cuánta gente compraría?
            </span>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, lineHeight: 1.5 }}>
            <div><strong>Si la cookie cuesta poco (ej: $200)</strong> → casi todos compran. Hasta los que no la querían se tientan porque está barata.</div>
            <div><strong>Si cuesta un precio medio (ej: $2.000)</strong> → algunos compran, los que más la quieren o tienen más plata.</div>
            <div><strong>Si cuesta caro (ej: $5.000)</strong> → casi nadie compra. Solo los muy fanáticos o con mucho dinero.</div>
          </div>
          <div style={{ marginTop: "10px", padding: "8px 10px", borderRadius: "6px", background: "#fff", fontSize: "11px", color: C.muted, lineHeight: 1.4 }}>
            👉 <strong>A más precio, menos gente quiere comprar.</strong> Por eso la curva de demanda <strong>baja</strong>.
          </div>
        </div>

        {/* OFERTA */}
        <div style={{ padding: "12px", borderRadius: "10px", background: `${C.blue}08`, border: `1.5px solid ${C.blue}33`, marginBottom: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
            <span style={{ fontSize: "20px" }}>🏭</span>
            <span style={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "13px", color: C.blue, textTransform: "uppercase", letterSpacing: "0.04em" }}>
              Oferta: ¿cuánta gente las fabricaría?
            </span>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, lineHeight: 1.5 }}>
            <div><strong>Si se vende a $200</strong> → casi nadie quiere producirlas. No vale la pena meterse a la cocina por tan poco.</div>
            <div><strong>Si se vende a $2.000</strong> → algunos se animan. El precio empieza a compensar el trabajo e ingredientes.</div>
            <div><strong>Si se vende a $5.000</strong> → muchos quieren fabricarlas. Es un negocio rentable y se suman productores.</div>
          </div>
          <div style={{ marginTop: "10px", padding: "8px 10px", borderRadius: "6px", background: "#fff", fontSize: "11px", color: C.muted, lineHeight: 1.4 }}>
            👉 <strong>A más precio, más gente quiere vender.</strong> Por eso la curva de oferta <strong>sube</strong>.
          </div>
        </div>

        {/* Equilibrio */}
        <div style={{ padding: "10px 12px", borderRadius: "8px", background: `${C.copper}11`, border: `1.5px solid ${C.copper}44` }}>
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, lineHeight: 1.5 }}>
            ⚖️ <strong>El precio de equilibrio</strong> es ese punto mágico donde <strong>la cantidad que la gente quiere comprar = la cantidad que la gente quiere vender</strong>. Ni sobra ni falta producto. Ese es el precio que pone el mercado.
          </div>
        </div>
      </Card>

      {/* Price slider — pegado arriba del gráfico */}
      <Card title="Elegí un precio de venta">
        <Slider label="Precio" value={precio} onChange={setPrecio} min={0} max={Math.round(demPMax)} step={50} color={C.copper} unscaled />
        <div style={{ textAlign: "center", fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.muted, marginTop: "-6px" }}>
          Movelo para ver qué pasa con la oferta y la demanda
        </div>
        <div style={{ marginTop: "10px", padding: "8px 10px", borderRadius: "6px", background: C.bg, fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, lineHeight: 1.4, textAlign: "center" }}>
          💡 Esta sección usa <strong>valores ilustrativos</strong> para enseñar el concepto de oferta y demanda. La conversión de moneda no se aplica acá — pensalo como números abstractos, no como precios reales de tu negocio.
        </div>
      </Card>

      {/* Chart */}
      <Card>
        {/* Leyenda explicativa — cómo leer el gráfico */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "12px" }}>
          <div style={{ padding: "8px 10px", borderRadius: "8px", background: `${C.red}08`, border: `1px solid ${C.red}33`, display: "flex", gap: "10px", alignItems: "flex-start" }}>
            <div style={{ width: "20px", height: "3px", background: C.red, marginTop: "8px", borderRadius: "2px", flexShrink: 0 }} />
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, lineHeight: 1.5 }}>
              <strong style={{ color: C.red }}>Línea roja = Demanda.</strong> Cada punto te dice: <em>"a este precio, esta cantidad de gente quiere COMPRAR la cookie"</em>. La línea cae a la derecha → cuanto más cara la cookie, menos gente la compra.
            </div>
          </div>
          <div style={{ padding: "8px 10px", borderRadius: "8px", background: `${C.blue}08`, border: `1px solid ${C.blue}33`, display: "flex", gap: "10px", alignItems: "flex-start" }}>
            <div style={{ width: "20px", height: "3px", background: C.blue, marginTop: "8px", borderRadius: "2px", flexShrink: 0 }} />
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, lineHeight: 1.5 }}>
              <strong style={{ color: C.blue }}>Línea azul = Oferta.</strong> Cada punto te dice: <em>"si la cookie se vende a este precio, esta cantidad de gente quiere FABRICARLA"</em>. La línea sube a la derecha → cuanto más cara se vende, más gente quiere producirla.
            </div>
          </div>
          <div style={{ padding: "8px 10px", borderRadius: "8px", background: `${C.copper}11`, border: `1px solid ${C.copper}44`, display: "flex", gap: "10px", alignItems: "flex-start" }}>
            <span style={{ fontSize: "16px", marginTop: "1px" }}>⚖️</span>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, lineHeight: 1.5 }}>
              <strong style={{ color: C.copper }}>Cruce = Equilibrio.</strong> Donde se cortan las dos líneas, la cantidad que se quiere comprar es la misma que la que se quiere vender. Ese es el precio "natural" del mercado.
            </div>
          </div>
          <div style={{ padding: "6px 10px", fontFamily: "'DM Sans',sans-serif", fontSize: "10px", color: C.muted, lineHeight: 1.4, textAlign: "center" }}>
            Eje vertical = precio · Eje horizontal = cantidad de cookies
          </div>
        </div>

        <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", maxHeight: "400px" }}>
          {/* Grid */}
          {gridPs.map(p => (
            <g key={`gp${p}`}>
              <line x1={pad} y1={toY(p)} x2={pad + innerW} y2={toY(p)} stroke="#ebe5df" strokeWidth="0.4" />
              <text x={pad - 3} y={toY(p) + 2} textAnchor="end" fill={C.muted} fontSize="4.5" fontFamily="DM Sans,sans-serif">{fmt(p)}</text>
            </g>
          ))}
          {gridQs.map(q => (
            <g key={`gq${q}`}>
              <line x1={toX(q)} y1={pad} x2={toX(q)} y2={pad + innerH} stroke="#ebe5df" strokeWidth="0.4" />
              <text x={toX(q)} y={pad + innerH + 8} textAnchor="middle" fill={C.muted} fontSize="4.5" fontFamily="DM Sans,sans-serif">{q}</text>
            </g>
          ))}

          {/* Excess zone highlight */}
          {!isEquilibrio && qDemanda >= 0 && qOferta >= 0 && (
            <rect
              x={toX(Math.min(qDemanda, qOferta))}
              y={toY(precio) - 12}
              width={Math.abs(toX(qOferta) - toX(qDemanda))}
              height={24}
              rx="4"
              fill={`${excessColor}18`}
              stroke={`${excessColor}44`}
              strokeWidth="0.8"
              strokeDasharray="3,2"
            />
          )}

          {/* Axes */}
          <line x1={pad} y1={pad - 5} x2={pad} y2={pad + innerH} stroke={C.dark} strokeWidth="1.2" />
          <line x1={pad} y1={pad + innerH} x2={pad + innerW + 5} y2={pad + innerH} stroke={C.dark} strokeWidth="1.2" />
          <polygon points={`${pad - 3},${pad} ${pad},${pad - 7} ${pad + 3},${pad}`} fill={C.dark} />
          <polygon points={`${pad + innerW + 2},${pad + innerH - 3} ${pad + innerW + 9},${pad + innerH} ${pad + innerW + 2},${pad + innerH + 3}`} fill={C.dark} />

          {/* Demand curve */}
          <path d={demPath} fill="none" stroke={C.red} strokeWidth="2.5" strokeLinecap="round" />
          {/* Supply curve */}
          <path d={supPath} fill="none" stroke={C.blue} strokeWidth="2.5" strokeLinecap="round" />

          {/* Current price line */}
          <line x1={pad} y1={toY(precio)} x2={pad + innerW} y2={toY(precio)} stroke={C.copper} strokeWidth="1.5" strokeDasharray="6,3" />
          <rect x={pad + innerW + 2} y={toY(precio) - 7} width="32" height="14" rx="3" fill={C.copper} />
          <text x={pad + innerW + 18} y={toY(precio) + 1} textAnchor="middle" fill="#fff" fontSize="4.5" fontWeight="700" fontFamily="DM Sans,sans-serif">
            ${(precio / 1000).toFixed(1)}k
          </text>

          {/* Demand point on price line */}
          {qDemanda > 0 && (
            <g>
              <line x1={toX(qDemanda)} y1={toY(precio)} x2={toX(qDemanda)} y2={pad + innerH} stroke={C.red} strokeWidth="0.6" strokeDasharray="2,2" />
              <circle cx={toX(qDemanda)} cy={toY(precio)} r="5" fill={C.red} stroke="#fff" strokeWidth="2" />
              <text x={toX(qDemanda)} y={pad + innerH + 15} textAnchor="middle" fill={C.red} fontSize="4.5" fontWeight="700" fontFamily="DM Sans,sans-serif">
                D: {Math.round(qDemanda)}
              </text>
            </g>
          )}

          {/* Supply point on price line */}
          {qOferta > 0 && (
            <g>
              <line x1={toX(qOferta)} y1={toY(precio)} x2={toX(qOferta)} y2={pad + innerH} stroke={C.blue} strokeWidth="0.6" strokeDasharray="2,2" />
              <circle cx={toX(qOferta)} cy={toY(precio)} r="5" fill={C.blue} stroke="#fff" strokeWidth="2" />
              <text x={toX(qOferta)} y={pad + innerH + 15} textAnchor="middle" fill={C.blue} fontSize="4.5" fontWeight="700" fontFamily="DM Sans,sans-serif">
                O: {Math.round(qOferta)}
              </text>
            </g>
          )}

          {/* Equilibrium point */}
          <circle cx={toX(eqQ)} cy={toY(eqP)} r="4.5" fill={C.copper} stroke="#fff" strokeWidth="2" />
          <rect x={toX(eqQ) + 6} y={toY(eqP) - 14} width="58" height="18" rx="4" fill="#fff" stroke={C.copper} strokeWidth="0.8" opacity="0.95" />
          <text x={toX(eqQ) + 9} y={toY(eqP) - 5} fill={C.copperDark} fontSize="4.5" fontWeight="700" fontFamily="DM Sans,sans-serif">Equilibrio</text>
          <text x={toX(eqQ) + 9} y={toY(eqP) + 1} fill={C.muted} fontSize="3.8" fontFamily="DM Sans,sans-serif">
            P={fmt(eqP)} Q={Math.round(eqQ)}
          </text>

          {/* Excess label in chart */}
          {!isEquilibrio && Math.abs(qOferta - qDemanda) > 20 && (
            <text
              x={toX((Math.min(qDemanda, qOferta) + Math.max(qDemanda, qOferta)) / 2)}
              y={toY(precio) - 16}
              textAnchor="middle" fill={excessColor} fontSize="4.5" fontWeight="700" fontFamily="DM Sans,sans-serif">
              {isExcesoOferta ? `Exceso oferta: ${Math.round(exceso)} un.` : `Exceso demanda: ${Math.round(Math.abs(exceso))} un.`}
            </text>
          )}

          {/* Curve labels */}
          <text x={toX(demPts[Math.max(0, demPts.length - 5)]?.q || 0)} y={toY(demPts[Math.max(0, demPts.length - 5)]?.p || 0) - 6} fill={C.red} fontSize="6" fontWeight="700" fontFamily="DM Sans,sans-serif">Demanda</text>
          <text x={toX(supPts[Math.max(0, supPts.length - 5)]?.q || 0)} y={toY(supPts[Math.max(0, supPts.length - 5)]?.p || 0) + 12} fill={C.blue} fontSize="6" fontWeight="700" fontFamily="DM Sans,sans-serif">Oferta</text>

          {/* Axis labels */}
          <text x={pad + innerW / 2} y={pad + innerH + 24} textAnchor="middle" fill={C.dark} fontSize="6" fontWeight="700" fontFamily="DM Sans,sans-serif">Cantidad</text>
          <text x={14} y={pad + innerH / 2} textAnchor="middle" fill={C.dark} fontSize="6" fontWeight="700" fontFamily="DM Sans,sans-serif" transform={`rotate(-90, 14, ${pad + innerH / 2})`}>Precio</text>
        </svg>
      </Card>

      {/* Result cards */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "14px" }}>
        <StatCard label="Demanda" value={`${Math.round(qDemanda)} un.`} sub="Quieren comprar" color={C.red} bgColor={C.redBg} icon="🛒" />
        <StatCard label="Oferta" value={`${Math.round(qOferta)} un.`} sub="Quieren vender" color={C.blue} bgColor={C.blueBg} icon="🏭" />
        <StatCard label="Equilibrio" value={fmt(eqP)} sub={`${Math.round(eqQ)} un.`} color={C.copper} bgColor={`${C.copper}11`} icon="⚖️" />
      </div>

      {/* Situation explanation */}
      <Card>
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px" }}>
          {isEquilibrio ? (
            <div style={{ padding: "12px", borderRadius: "8px", background: C.greenBg, border: `1.5px solid ${C.green}22`, color: C.green, fontWeight: 700, textAlign: "center" }}>
              ⚖️ ¡Estás en equilibrio! La cantidad que se quiere comprar es igual a la que se quiere vender. No sobra ni falta producto.
            </div>
          ) : isExcesoOferta ? (
            <div style={{ padding: "12px", borderRadius: "8px", background: C.blueBg, border: `1.5px solid ${C.blue}22`, color: C.dark }}>
              <div style={{ fontWeight: 700, color: C.blue, marginBottom: "4px" }}>📦 Exceso de oferta: sobran {Math.round(exceso)} unidades</div>
              <div style={{ fontSize: "12px", color: C.muted }}>
                Tu precio ({fmt(precio)}) está <strong>por encima</strong> del equilibrio ({fmt(eqP)}).
                Los productores quieren vender {Math.round(qOferta)} un. pero los consumidores solo quieren comprar {Math.round(qDemanda)} un.
                <strong> Resultado:</strong> te van a sobrar productos. Vas a tener que bajar el precio o vas a acumular inventario.
              </div>
            </div>
          ) : (
            <div style={{ padding: "12px", borderRadius: "8px", background: C.redBg, border: `1.5px solid ${C.red}22`, color: C.dark }}>
              <div style={{ fontWeight: 700, color: C.red, marginBottom: "4px" }}>🔥 Exceso de demanda: faltan {Math.round(Math.abs(exceso))} unidades</div>
              <div style={{ fontSize: "12px", color: C.muted }}>
                Tu precio ({fmt(precio)}) está <strong>por debajo</strong> del equilibrio ({fmt(eqP)}).
                Los consumidores quieren comprar {Math.round(qDemanda)} un. pero los productores solo ofrecen {Math.round(qOferta)} un. 
                <strong> Resultado:</strong> hay más demanda que producto. Podrías subir el precio y seguirías vendiendo.
              </div>
            </div>
          )}
        </div>
      </Card>

      <Card>
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, textAlign: "center" }}>
          <strong>¿Quién pone los precios?</strong> El mercado. Si ponés un precio muy alto, te sobra producto. Si lo ponés muy bajo, no das abasto. El equilibrio es donde oferta y demanda se encuentran.
        </div>
      </Card>
    </div>
  );
}


/* ═══════════════════════════════════════════
   TOOL 6: FÓRMULAS DE MARGEN & MARKUP
   ═══════════════════════════════════════════ */
function ToolFormulas() {
  const [foodCost, setFoodCost] = useState(453);
  const [margenDeseado, setMargenDeseado] = useState(60);

  // Validación de viabilidad — dado margen + food cost, ¿el precio y el volumen son alcanzables?
  const [gastosFijosCalc, setGastosFijosCalc] = useState([
    { name: "Arriendo", monto: 600000 },
    { name: "Sueldos (incluido el dueño)", monto: 600000 },
    { name: "Servicios + otros", monto: 200000 },
  ]);
  const [ebitdaPct, setEbitdaPct] = useState(15);
  const totalFijosCalc = gastosFijosCalc.reduce((s, g) => s + g.monto, 0);
  const margenDecimalCalc = margenDeseado / 100;
  const ebitdaDecimalCalc = Math.min(0.99, Math.max(0, ebitdaPct / 100));
  // Precio derivado del margen + food cost
  const precioCalc = margenDecimalCalc < 1 ? foodCost / (1 - margenDecimalCalc) : 0;
  const aportePorUnidadCalc = precioCalc > 0 ? precioCalc - foodCost : 0;
  // Unidades necesarias para alcanzar fijos + EBITDA% sobre ventas
  // Fórmula: units = fijos / (precio × (margenDecimal − ebitdaDecimal))
  // Solo viable si margenDecimal > ebitdaDecimal
  const margenSuficiente = margenDecimalCalc > ebitdaDecimalCalc;
  const unidadesPE = aportePorUnidadCalc > 0 ? Math.ceil(totalFijosCalc / aportePorUnidadCalc) : Infinity;
  const unidadesViables = (margenSuficiente && aportePorUnidadCalc > 0)
    ? Math.ceil(totalFijosCalc / (precioCalc * (margenDecimalCalc - ebitdaDecimalCalc)))
    : Infinity;
  const ebitdaMensualCalc = unidadesViables !== Infinity ? unidadesViables * precioCalc * ebitdaDecimalCalc : 0;
  const ebitdaCalcColor = ebitdaPct < 10 ? C.red : ebitdaPct <= 20 ? C.green : C.amber;
  const updateGastoCalc = (i, monto) => {
    const n = [...gastosFijosCalc]; n[i] = { ...n[i], monto: Math.max(0, monto) }; setGastosFijosCalc(n);
  };

  // Cálculos
  const margenDecimal = margenDeseado / 100;
  const precioMargen = margenDecimal < 1 ? foodCost / (1 - margenDecimal) : Infinity;
  const precioMarkup = foodCost * (1 + margenDecimal);

  // Verificación: ¿qué % real queda con cada método?
  const realMargenPctMargen = precioMargen !== Infinity && precioMargen > 0 ? ((precioMargen - foodCost) / precioMargen) * 100 : 0;
  const realMargenPctMarkup = precioMarkup > 0 ? ((precioMarkup - foodCost) / precioMarkup) * 100 : 0;

  const gananciaMargen = precioMargen !== Infinity ? precioMargen - foodCost : 0;
  const gananciaMarkup = precioMarkup - foodCost;

  // Step by step for Margen formula
  const steps = [
    { label: "Food Cost (tu costo)", value: fmt(foodCost), color: C.red },
    { label: `Margen deseado`, value: `${margenDeseado}%`, color: C.copper },
    { label: `1 − ${margenDeseado}%`, value: `1 − ${(margenDecimal).toFixed(2)} = ${(1 - margenDecimal).toFixed(2)}`, color: C.dark },
    { label: `Food Cost ÷ ${(1 - margenDecimal).toFixed(2)}`, value: precioMargen !== Infinity ? `${fmt(foodCost)} ÷ ${(1 - margenDecimal).toFixed(2)} = ${fmt(precioMargen)}` : "No se puede (margen = 100%)", color: C.green },
  ];

  return (
    <div>
      {/* Inputs */}
      <Card title="Ingresá tus datos">
        <Slider label="Food Cost (costo por unidad)" value={foodCost} onChange={setFoodCost} min={50} max={10000} step={10} color={C.red} />
        <Slider label="Margen deseado" value={margenDeseado} onChange={setMargenDeseado} min={5} max={95} step={1} prefix="" suffix="%" color={C.copper} />
      </Card>

      {/* Validación de viabilidad del margen */}
      <Card title="🧮 ¿Tu margen es viable?">
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "16px", lineHeight: 1.5 }}>
          Con tu <strong>margen ({margenDeseado}%)</strong> y <strong>food cost ({fmt(foodCost)})</strong>, la fórmula te dice el precio. Pero "lograble en el papel" no es lo mismo que "lograble en la realidad". Hay <strong>2 preguntas honestas</strong> que el alumno se tiene que hacer:
        </div>

        {/* PREGUNTA 1: PRECIO */}
        <div style={{ padding: "14px", borderRadius: "10px", background: `${C.copper}0d`, border: `1.5px solid ${C.copper}44`, marginBottom: "12px" }}>
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.copper, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "8px" }}>
            Pregunta 1 · ¿Tu cliente paga este precio?
          </div>
          <div style={{ fontFamily: "'Georgia',serif", fontSize: "12px", color: C.muted, textAlign: "center", marginBottom: "2px" }}>
            <span style={{ color: C.red }}>{fmt(foodCost)}</span> ÷ (1 − <span style={{ color: C.copper }}>{margenDeseado}%</span>) =
          </div>
          <div style={{ fontFamily: "'Georgia',serif", fontSize: "44px", fontWeight: 700, color: C.copper, lineHeight: 1, textAlign: "center", marginBottom: "8px" }}>
            {fmt(precioCalc)}
          </div>
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, textAlign: "center", lineHeight: 1.4 }}>
            ¿Tu cliente está dispuesto a pagar <strong>{fmt(precioCalc)}</strong> por este producto?
            <br /><span style={{ color: C.muted, fontSize: "11px" }}>Si es muy caro → bajá margen, o bajá food cost. Si es razonable → seguí abajo.</span>
          </div>
        </div>

        {/* PREGUNTA 2: VOLUMEN */}
        <div style={{ padding: "14px", borderRadius: "10px", background: `${C.copper}0d`, border: `1.5px solid ${C.copper}44` }}>
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.copper, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "10px" }}>
            Pregunta 2 · ¿Podés vender esta cantidad?
          </div>

          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "10px", lineHeight: 1.5 }}>
            Cada unidad vendida aporta <strong style={{ color: C.green }}>{fmt(aportePorUnidadCalc)}</strong> (precio − food cost). Eso es lo que cubre tus gastos fijos y deja la ganancia.
          </div>

          {/* Inputs */}
          <div style={{ padding: "10px 12px", borderRadius: "8px", background: `${C.amber}08`, border: `1px solid ${C.amber}33`, marginBottom: "8px" }}>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.amber, marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.04em" }}>
              Gastos fijos del mes
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              {gastosFijosCalc.map((g, i) => (
                <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 130px", gap: "8px", alignItems: "center" }}>
                  <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark }}>{g.name}</span>
                  <NumInput value={g.monto} onChange={v => updateGastoCalc(i, v)} step={50000} small />
                </div>
              ))}
            </div>
            <div style={{ marginTop: "6px", paddingTop: "5px", borderTop: `1px dashed ${C.amber}55`, display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
              <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.amber }}>Total fijos</span>
              <span style={{ fontFamily: "'Georgia',serif", fontSize: "15px", fontWeight: 700, color: C.amber }}>{fmt(totalFijosCalc)}</span>
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "10px", color: C.muted, marginTop: "4px", lineHeight: 1.3 }}>
              💡 Tu sueldo va acá. Si no lo contás, confundís sueldo con ganancia.
            </div>
          </div>

          <div style={{ padding: "10px 12px", borderRadius: "8px", background: `${C.green}08`, border: `1px solid ${C.green}33`, marginBottom: "12px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "4px" }}>
              <div>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.green, textTransform: "uppercase", letterSpacing: "0.04em" }}>EBITDA objetivo (ganancia limpia)</div>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted }}>% del precio que querés llevarte después de pagar todo</div>
              </div>
              <span style={{ fontFamily: "'Georgia',serif", fontSize: "20px", fontWeight: 700, color: ebitdaCalcColor }}>{ebitdaPct}%</span>
            </div>
            <input type="range" min={0} max={30} step={1} value={ebitdaPct} onChange={e => setEbitdaPct(Number(e.target.value))}
              style={{ width: "100%", height: "6px", borderRadius: "3px", appearance: "none", outline: "none", cursor: "pointer",
                background: `linear-gradient(90deg, ${C.red} 0%, ${C.red} 30%, ${C.green} 33.3%, ${C.green} 66.6%, ${C.amber} 70%, ${C.amber} 100%)` }} />
            <div style={{ display: "flex", marginTop: "3px", fontSize: "10px", fontFamily: "'DM Sans',sans-serif", fontWeight: 600 }}>
              <div style={{ width: "33.3%", color: C.red }}>0–9% autoempleo</div>
              <div style={{ width: "33.3%", color: C.green, textAlign: "center" }}>10–20% IDEAL</div>
              <div style={{ width: "33.3%", color: C.amber, textAlign: "right" }}>21–30% premium</div>
            </div>
          </div>

          {/* Resultado: unidades necesarias */}
          {margenSuficiente && aportePorUnidadCalc > 0 ? (
            <div style={{ padding: "12px", borderRadius: "10px", background: "#fff", border: `2px solid ${C.copper}66`, textAlign: "center" }}>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "4px" }}>
                Unidades a vender por mes para ser viable
              </div>
              <div style={{ fontFamily: "'Georgia',serif", fontSize: "48px", fontWeight: 700, color: C.copper, lineHeight: 1, marginBottom: "6px" }}>
                {unidadesViables.toLocaleString(CURRENT_LOCALE)} <span style={{ fontSize: "13px", color: C.muted, fontWeight: 400 }}>un.</span>
              </div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, lineHeight: 1.5 }}>
                Vendiendo eso a <strong>{fmt(precioCalc)}/u</strong> cubrís los <strong style={{ color: C.amber }}>{fmt(totalFijosCalc)}</strong> de fijos y te queda <strong style={{ color: ebitdaCalcColor }}>{fmt(ebitdaMensualCalc)}</strong> de EBITDA al mes.
              </div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, marginTop: "8px", lineHeight: 1.4 }}>
                Solo cubrir gastos fijos (PE, sin ganancia): <strong>{unidadesPE.toLocaleString(CURRENT_LOCALE)}</strong> un./mes.
              </div>
              <div style={{ marginTop: "10px", padding: "8px 10px", borderRadius: "6px", background: C.bg, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, lineHeight: 1.5 }}>
                ¿Podés vender <strong>{unidadesViables.toLocaleString(CURRENT_LOCALE)} unidades al mes</strong>?
                <br /><span style={{ color: C.muted, fontSize: "11px" }}>Si sí → margen viable ✓. Si no → subí margen (precio más alto, menos unidades) o bajá gastos fijos.</span>
              </div>
            </div>
          ) : (
            <div style={{ padding: "12px", borderRadius: "10px", background: C.redBg, border: `1.5px solid ${C.red}55`, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.red, fontWeight: 600, textAlign: "center" }}>
              ⚠️ {!margenSuficiente
                ? `Tu margen (${margenDeseado}%) no puede ser ≤ EBITDA objetivo (${ebitdaPct}%). Subí margen o bajá EBITDA.`
                : "El margen + food cost no dejan aporte por unidad. Revisá los datos."}
            </div>
          )}
        </div>
      </Card>

      {/* Concepto: ¿qué mide cada una? */}
      <Card title="🎓 Concepto — ¿Qué mide cada una?">
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "14px", lineHeight: 1.5 }}>
          Las dos fórmulas miden <strong>la misma ganancia</strong>, pero desde perspectivas distintas. La única diferencia está en el <strong>denominador</strong>: markup divide por el costo, margen divide por el precio.
        </div>

        {/* Dos lentes */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "14px" }}>
          <div style={{ padding: "12px", borderRadius: "10px", border: `1.5px solid ${C.red}33`, background: `${C.red}08` }}>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "12px", color: C.red, marginBottom: "6px" }}>
              🔙 MARKUP mira al COSTO
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "6px", lineHeight: 1.4 }}>
              <em>"¿Cuánto le sumo a lo que me costó?"</em>
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, lineHeight: 1.4 }}>
              Lente del que <strong>compra o produce</strong>. Partís del costo y decidís cuánto agregarle.
            </div>
          </div>
          <div style={{ padding: "12px", borderRadius: "10px", border: `1.5px solid ${C.green}33`, background: `${C.green}08` }}>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "12px", color: C.green, marginBottom: "6px" }}>
              🔜 MARGEN mira al PRECIO
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "6px", lineHeight: 1.4 }}>
              <em>"¿Qué parte de lo que cobro es ganancia?"</em>
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, lineHeight: 1.4 }}>
              Lente del que <strong>vende o analiza rentabilidad</strong>. Partís del precio y ves qué porción te queda.
            </div>
          </div>
        </div>

        {/* Ejemplo fijo didáctico */}
        <div style={{ padding: "12px", borderRadius: "10px", background: C.bg, border: `1px solid ${C.line}`, marginBottom: "12px" }}>
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.copper, marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.06em" }}>
            📘 Ejemplo para fijar la idea
          </div>
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "10px", lineHeight: 1.5 }}>
            Compro a <strong>$100</strong>, vendo a <strong>$150</strong> → Gano <strong>$50</strong>.
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
            <div style={{ padding: "10px", background: "#fff", borderRadius: "8px", borderLeft: `3px solid ${C.red}`, textAlign: "center" }}>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, fontWeight: 600 }}>Markup</div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, margin: "3px 0" }}>50 / <strong>100</strong></div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "20px", fontWeight: 700, color: C.red }}>50%</div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted }}>le sumé medio costo</div>
            </div>
            <div style={{ padding: "10px", background: "#fff", borderRadius: "8px", borderLeft: `3px solid ${C.green}`, textAlign: "center" }}>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, fontWeight: 600 }}>Margen</div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, margin: "3px 0" }}>50 / <strong>150</strong></div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "20px", fontWeight: 700, color: C.green }}>33%</div>
              <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted }}>un tercio del precio</div>
            </div>
          </div>
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, textAlign: "center", marginTop: "10px", fontStyle: "italic" }}>
            Misma operación, dos números distintos. Ninguno miente: miden cosas diferentes.
          </div>
        </div>

        {/* 3 claves */}
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.copper, marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.06em" }}>
          🔑 3 claves para no confundirlas
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {[
            { n: "1", title: "El markup siempre es mayor que el margen", body: "Para la misma operación. Porque el costo (denominador del markup) es menor que el precio (denominador del margen)." },
            { n: "2", title: "Markup 100% = Margen 50%", body: "Duplicar el costo significa que la mitad del precio de venta es ganancia. Un markup del 50% equivale a un margen del ~33%." },
            { n: "3", title: "El error típico del emprendedor", body: "Dice «le pongo 30% arriba al costo» (markup) y cree que gana 30% del precio (margen). En realidad gana ~23%. Perdés plata sin darte cuenta." },
          ].map(k => (
            <div key={k.n} style={{ display: "flex", gap: "10px", padding: "10px", background: "#fdfcfb", borderRadius: "8px", border: `1px solid ${C.line}` }}>
              <div style={{
                width: "24px", height: "24px", borderRadius: "50%", background: C.copper,
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                color: "#fff", fontWeight: 700, fontSize: "12px", fontFamily: "'DM Sans',sans-serif",
              }}>{k.n}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 700, color: C.dark, marginBottom: "2px" }}>{k.title}</div>
                <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.muted, lineHeight: 1.4 }}>{k.body}</div>
              </div>
            </div>
          ))}
        </div>
      </Card>

      {/* La diferencia clave */}
      <Card title="⚠️ Markup vs Margen — ¡No son lo mismo!">
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "14px" }}>
          Muchos emprendedores confunden estas dos fórmulas. Parecen iguales pero dan resultados muy distintos. Veamos con tu Food Cost de <strong>{fmt(foodCost)}</strong> y un <strong>{margenDeseado}%</strong>:
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
          {/* MARKUP - MAL */}
          <div style={{ padding: "14px", borderRadius: "12px", border: `2px solid ${C.red}33`, background: `${C.red}06` }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "8px" }}>
              <span style={{ fontSize: "20px" }}>❌</span>
              <span style={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "13px", color: C.red }}>Markup (INCORRECTO)</span>
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "8px", padding: "8px", background: "#fff", borderRadius: "6px" }}>
              <div style={{ fontWeight: 700, marginBottom: "4px" }}>Fórmula:</div>
              <div style={{ fontSize: "14px", fontWeight: 700, color: C.red, textAlign: "center", margin: "4px 0" }}>
                PVenta = Costo × (1 + {margenDeseado}%)
              </div>
              <div style={{ fontSize: "12px", textAlign: "center", color: C.muted }}>
                {fmt(foodCost)} × {(1 + margenDecimal).toFixed(2)} = <strong style={{ color: C.red }}>{fmt(precioMarkup)}</strong>
              </div>
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted }}>
              Ganancia: <strong>{fmt(gananciaMarkup)}</strong>
              <br />Margen real sobre venta: <strong style={{ color: C.red }}>{realMargenPctMarkup.toFixed(1)}%</strong>
              <br /><span style={{ color: C.red, fontWeight: 600 }}>⚠️ ¡Pediste {margenDeseado}% pero te queda {realMargenPctMarkup.toFixed(1)}%!</span>
            </div>
          </div>

          {/* MARGEN - BIEN */}
          <div style={{ padding: "14px", borderRadius: "12px", border: `2px solid ${C.green}33`, background: `${C.green}06` }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "8px" }}>
              <span style={{ fontSize: "20px" }}>✅</span>
              <span style={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: "13px", color: C.green }}>Margen (CORRECTO)</span>
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "8px", padding: "8px", background: "#fff", borderRadius: "6px" }}>
              <div style={{ fontWeight: 700, marginBottom: "4px" }}>Fórmula:</div>
              <div style={{ fontSize: "14px", fontWeight: 700, color: C.green, textAlign: "center", margin: "4px 0" }}>
                PVenta = Costo ÷ (1 − {margenDeseado}%)
              </div>
              <div style={{ fontSize: "12px", textAlign: "center", color: C.muted }}>
                {fmt(foodCost)} ÷ {(1 - margenDecimal).toFixed(2)} = <strong style={{ color: C.green }}>{precioMargen !== Infinity ? fmt(precioMargen) : "∞"}</strong>
              </div>
            </div>
            <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted }}>
              Ganancia: <strong>{precioMargen !== Infinity ? fmt(gananciaMargen) : "—"}</strong>
              <br />Margen real sobre venta: <strong style={{ color: C.green }}>{realMargenPctMargen.toFixed(1)}%</strong>
              <br /><span style={{ color: C.green, fontWeight: 600 }}>✅ Pediste {margenDeseado}% y te queda {realMargenPctMargen.toFixed(1)}%</span>
            </div>
          </div>
        </div>
      </Card>

      {/* Step by step */}
      <Card title="📐 Paso a paso — Fórmula de Margen">
        <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
          {steps.map((s, i) => (
            <div key={i}>
              <div style={{
                display: "flex", alignItems: "center", gap: "10px", padding: "10px 12px",
                background: i === steps.length - 1 ? `${C.green}11` : i % 2 === 0 ? "#fdfcfb" : "#fff",
                borderRadius: i === 0 ? "8px 8px 0 0" : i === steps.length - 1 ? "0 0 8px 8px" : "0",
                borderLeft: `3px solid ${s.color}`,
              }}>
                <div style={{
                  width: "24px", height: "24px", borderRadius: "50%", background: s.color,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#fff", fontWeight: 700, fontSize: "12px", fontFamily: "'DM Sans',sans-serif",
                  flexShrink: 0,
                }}>{i + 1}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "11px", fontWeight: 600, color: C.muted, fontFamily: "'DM Sans',sans-serif", textTransform: "uppercase", letterSpacing: "0.04em" }}>{s.label}</div>
                  <div style={{ fontSize: i === steps.length - 1 ? "15px" : "13px", fontWeight: 700, color: s.color, fontFamily: "'DM Sans',sans-serif" }}>{s.value}</div>
                </div>
              </div>
              {i < steps.length - 1 && (
                <div style={{ textAlign: "center", color: C.muted, fontSize: "14px", lineHeight: "16px" }}>↓</div>
              )}
            </div>
          ))}
        </div>
      </Card>

      {/* Visual comparison bar */}
      <Card title="🧱 Comparación visual">
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted, marginBottom: "10px" }}>
          Con el mismo Food Cost, mirá la diferencia de precio y ganancia entre los dos métodos:
        </div>

        {/* Markup bar */}
        <div style={{ marginBottom: "12px" }}>
          <div style={{ fontSize: "11px", fontWeight: 700, color: C.red, fontFamily: "'DM Sans',sans-serif", marginBottom: "3px" }}>
            ❌ Markup → {fmt(precioMarkup)}
          </div>
          <div style={{ display: "flex", height: "32px", borderRadius: "6px", overflow: "hidden" }}>
            <div style={{
              width: `${precioMarkup > 0 ? (foodCost / precioMarkup) * 100 : 50}%`,
              background: `linear-gradient(90deg, ${C.red}cc, ${C.red})`,
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#fff", fontWeight: 700, fontSize: "11px", fontFamily: "'DM Sans',sans-serif",
            }}>FC {fmt(foodCost)}</div>
            <div style={{
              flex: 1,
              background: `linear-gradient(90deg, ${C.red}44, ${C.red}33)`,
              display: "flex", alignItems: "center", justifyContent: "center",
              color: C.red, fontWeight: 700, fontSize: "11px", fontFamily: "'DM Sans',sans-serif",
            }}>Ganancia {fmt(gananciaMarkup)} ({realMargenPctMarkup.toFixed(1)}%)</div>
          </div>
        </div>

        {/* Margen bar */}
        <div>
          <div style={{ fontSize: "11px", fontWeight: 700, color: C.green, fontFamily: "'DM Sans',sans-serif", marginBottom: "3px" }}>
            ✅ Margen → {precioMargen !== Infinity ? fmt(precioMargen) : "∞"}
          </div>
          {precioMargen !== Infinity && (
            <div style={{ display: "flex", height: "32px", borderRadius: "6px", overflow: "hidden" }}>
              <div style={{
                width: `${(foodCost / precioMargen) * 100}%`,
                background: `linear-gradient(90deg, ${C.green}cc, ${C.green})`,
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "#fff", fontWeight: 700, fontSize: "11px", fontFamily: "'DM Sans',sans-serif",
              }}>FC {fmt(foodCost)}</div>
              <div style={{
                flex: 1,
                background: `linear-gradient(90deg, ${C.green}44, ${C.green}33)`,
                display: "flex", alignItems: "center", justifyContent: "center",
                color: C.green, fontWeight: 700, fontSize: "11px", fontFamily: "'DM Sans',sans-serif",
              }}>Ganancia {fmt(gananciaMargen)} ({realMargenPctMargen.toFixed(1)}%)</div>
            </div>
          )}
        </div>

        <div style={{ marginTop: "12px", padding: "8px", borderRadius: "6px", background: C.bg, fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.dark, textAlign: "center" }}>
          La diferencia entre Markup y Margen es de <strong>{fmt(Math.abs(Math.round(precioMargen !== Infinity ? precioMargen - precioMarkup : 0)))}</strong> por unidad.
          {precioMargen !== Infinity && precioMargen > precioMarkup && <> Con Markup estás vendiendo <strong>más barato</strong> de lo que pensás.</>}
        </div>
      </Card>

      <Card>
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, textAlign: "center" }}>
          <strong>Regla de oro:</strong> Siempre usá la fórmula de <strong style={{ color: C.green }}>Margen</strong> para calcular tus precios.
          <br /><span style={{ color: C.muted, fontSize: "11px" }}>PVenta = Costo ÷ (1 − Margen%). Así te asegurás que el % que querés ganar sea real sobre el precio de venta, no sobre el costo.</span>
        </div>
      </Card>
    </div>
  );
}


/* ═══════════════════════════════════════════
   TOOL 7: PUNTO DE EQUILIBRIO
   ═══════════════════════════════════════════ */
function ToolPuntoEquilibrio() {
  const [precioVenta, setPrecioVenta] = useState(4500);
  const [foodCostUnit, setFoodCostUnit] = useState(1400);
  const [gastosFijos, setGastosFijos] = useState(1200000);

  const margenContrib = precioVenta - foodCostUnit;
  const peUnidades = margenContrib > 0 ? Math.ceil(gastosFijos / margenContrib) : Infinity;
  const peVentas = peUnidades !== Infinity ? peUnidades * precioVenta : Infinity;
  const margenPct = precioVenta > 0 ? ((margenContrib / precioVenta) * 100) : 0;

  // Chart: lines of ingresos and costos totales vs unidades
  const chartW = 320, chartH = 200, pad = 45;
  const innerW = chartW - pad * 2, innerH = chartH - pad * 2;

  // Ejes fijos: no dependen del cálculo, así al mover sliders solo se mueven las líneas.
  // Cubren rangos máximos de los sliders (precio 20k × 2000 un. = 40M).
  const maxUnits = 2000;
  const maxPesos = 40000000;

  const toX = u => pad + (u / maxUnits) * innerW;
  const toY = p => pad + innerH - (p / maxPesos) * innerH;

  // Ingresos line: from (0,0) to (maxUnits, maxUnits * precio)
  const ingX1 = toX(0), ingY1 = toY(0);
  const ingX2 = toX(maxUnits), ingY2 = toY(maxUnits * precioVenta);

  // Costos totales line: from (0, gastosFijos) to (maxUnits, gastosFijos + maxUnits * foodCostUnit)
  const costX1 = toX(0), costY1 = toY(gastosFijos);
  const costX2 = toX(maxUnits), costY2 = toY(gastosFijos + maxUnits * foodCostUnit);

  // Gastos fijos line (horizontal)
  const gfY = toY(gastosFijos);

  // PE point
  const peX = peUnidades !== Infinity ? toX(peUnidades) : 0;
  const peY = peUnidades !== Infinity ? toY(peUnidades * precioVenta) : 0;

  // Loss area (between cost and ingreso lines, left of PE)
  const lossPath = peUnidades !== Infinity ? `M ${ingX1} ${ingY1} L ${peX} ${peY} L ${toX(0)} ${costY1} Z` : "";
  // Profit area (between ingreso and cost lines, right of PE)  
  const profitPath = peUnidades !== Infinity ? `M ${peX} ${peY} L ${ingX2} ${ingY2} L ${costX2} ${costY2} Z` : "";

  // Grid
  const gridUnits = [];
  const step = Math.max(1, Math.round(maxUnits / 5));
  for (let u = step; u <= maxUnits; u += step) gridUnits.push(u);
  const gridPesos = [];
  const stepP = Math.max(100000, Math.round(maxPesos / 4 / 100000) * 100000);
  for (let p = stepP; p <= maxPesos; p += stepP) gridPesos.push(p);

  const fmtShort = (n) => {
    if (n >= 1000000) return `${CURRENT_SYMBOL}${(n / 1000000).toFixed(1)}M`;
    if (n >= 1000) return `${CURRENT_SYMBOL}${Math.round(n / 1000)}k`;
    return `${CURRENT_SYMBOL}${n}`;
  };

  // Steps
  const steps = [
    { label: "Precio de Venta", value: fmt(precioVenta), color: C.copper },
    { label: "Food Cost por unidad", value: fmt(foodCostUnit), color: C.red },
    { label: "Margen de Contribución", value: `${fmt(precioVenta)} − ${fmt(foodCostUnit)} = ${fmt(margenContrib)}`, color: C.green },
    { label: "Gastos Fijos totales", value: fmt(gastosFijos), color: C.amber },
    { label: "Punto de Equilibrio", value: margenContrib > 0 ? `${fmt(gastosFijos)} ÷ ${fmt(margenContrib)} = ${peUnidades.toLocaleString(CURRENT_LOCALE)} unidades` : "No existe (margen ≤ 0)", color: margenContrib > 0 ? C.copper : C.red },
  ];

  return (
    <div>
      {/* Sliders */}
      <Card title="Configurá tu negocio">
        <Slider label="Precio de Venta" value={precioVenta} onChange={setPrecioVenta} min={500} max={20000} step={50} color={C.copper} />
        <Slider label="Food Cost por unidad" value={foodCostUnit} onChange={setFoodCostUnit} min={100} max={15000} step={50} color={C.red} />
        <div style={{ marginBottom: "14px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "4px" }}>
            <label style={{ fontSize: "12px", fontWeight: 600, color: C.dark, letterSpacing: "0.03em", textTransform: "uppercase", fontFamily: "'DM Sans',sans-serif" }}>Gastos Fijos mensuales</label>
            <span style={{ fontSize: "18px", fontWeight: 700, color: C.amber, fontFamily: "'Georgia',serif" }}>{fmt(gastosFijos)}</span>
          </div>
          <input type="range" min={100000} max={8000000} step={50000} value={gastosFijos} onChange={e => setGastosFijos(Number(e.target.value))}
            style={{ width: "100%", height: "6px", borderRadius: "3px", appearance: "none", outline: "none", cursor: "pointer",
              background: `linear-gradient(90deg, ${C.amber} ${((gastosFijos - 100000) / (8000000 - 100000)) * 100}%, #e0d6cf ${((gastosFijos - 100000) / (8000000 - 100000)) * 100}%)` }} />
          <div style={{ fontSize: "10px", color: "#999", fontFamily: "'DM Sans',sans-serif", marginTop: "2px", display: "flex", justifyContent: "space-between" }}>
            <span>$100.000</span><span>Arriendo + sueldos + marketing + otros</span><span>$8.000.000</span>
          </div>
        </div>
      </Card>

      {/* Chart */}
      <Card title="📊 Gráfico de Punto de Equilibrio">
        <svg viewBox={`0 0 ${chartW} ${chartH}`} style={{ width: "100%", maxHeight: "320px" }}>
          {/* Grid */}
          {gridPesos.map(p => (
            <g key={`gp${p}`}>
              <line x1={pad} y1={toY(p)} x2={pad + innerW} y2={toY(p)} stroke="#ebe5df" strokeWidth="0.4" />
              <text x={pad - 3} y={toY(p) + 2} textAnchor="end" fill={C.muted} fontSize="4" fontFamily="DM Sans,sans-serif">{fmtShort(p)}</text>
            </g>
          ))}
          {gridUnits.map(u => (
            <g key={`gu${u}`}>
              <line x1={toX(u)} y1={pad} x2={toX(u)} y2={pad + innerH} stroke="#ebe5df" strokeWidth="0.4" />
              <text x={toX(u)} y={pad + innerH + 8} textAnchor="middle" fill={C.muted} fontSize="4" fontFamily="DM Sans,sans-serif">{u}</text>
            </g>
          ))}

          {/* Loss area (red) */}
          {lossPath && <path d={lossPath} fill={`${C.red}12`} />}
          {/* Profit area (green) */}
          {profitPath && <path d={profitPath} fill={`${C.green}12`} />}

          {/* Axes */}
          <line x1={pad} y1={pad - 5} x2={pad} y2={pad + innerH} stroke={C.dark} strokeWidth="1.2" />
          <line x1={pad} y1={pad + innerH} x2={pad + innerW + 5} y2={pad + innerH} stroke={C.dark} strokeWidth="1.2" />
          <polygon points={`${pad - 3},${pad} ${pad},${pad - 7} ${pad + 3},${pad}`} fill={C.dark} />
          <polygon points={`${pad + innerW + 2},${pad + innerH - 3} ${pad + innerW + 9},${pad + innerH} ${pad + innerW + 2},${pad + innerH + 3}`} fill={C.dark} />

          {/* Gastos fijos line (horizontal dashed) */}
          <line x1={pad} y1={gfY} x2={pad + innerW} y2={gfY} stroke={C.amber} strokeWidth="1" strokeDasharray="4,3" />
          <text x={pad + innerW - 2} y={gfY - 4} textAnchor="end" fill={C.amber} fontSize="4.5" fontWeight="600" fontFamily="DM Sans,sans-serif">Gastos Fijos</text>

          {/* Costo total line */}
          <line x1={costX1} y1={costY1} x2={costX2} y2={costY2} stroke={C.red} strokeWidth="2.5" strokeLinecap="round" />

          {/* Ingresos line */}
          <line x1={ingX1} y1={ingY1} x2={ingX2} y2={ingY2} stroke={C.green} strokeWidth="2.5" strokeLinecap="round" />

          {/* PE point */}
          {peUnidades !== Infinity && (
            <g>
              <line x1={peX} y1={peY} x2={peX} y2={pad + innerH} stroke={C.copper} strokeWidth="0.8" strokeDasharray="3,2" />
              <circle cx={peX} cy={peY} r="5" fill={C.copper} stroke="#fff" strokeWidth="2" />
              <rect x={peX + 6} y={peY - 18} width="72" height="24" rx="4" fill="#fff" stroke={C.copper} strokeWidth="0.8" opacity="0.95" />
              <text x={peX + 10} y={peY - 8} fill={C.copperDark} fontSize="5" fontWeight="700" fontFamily="DM Sans,sans-serif">Punto de Equilibrio</text>
              <text x={peX + 10} y={peY} fill={C.muted} fontSize="4" fontFamily="DM Sans,sans-serif">
                {peUnidades.toLocaleString(CURRENT_LOCALE)} un. = {fmtShort(peVentas)}
              </text>
            </g>
          )}

          {/* Zone labels */}
          {peUnidades !== Infinity && peUnidades < maxUnits && (
            <>
              <text x={toX(peUnidades * 0.35)} y={toY(gastosFijos * 0.4)} textAnchor="middle" fill={`${C.red}88`} fontSize="5.5" fontWeight="700" fontFamily="DM Sans,sans-serif">PÉRDIDA</text>
              <text x={toX(peUnidades * 1.5)} y={toY((peUnidades * 1.5) * precioVenta * 0.85)} textAnchor="middle" fill={`${C.green}88`} fontSize="5.5" fontWeight="700" fontFamily="DM Sans,sans-serif">GANANCIA</text>
            </>
          )}

          {/* Line labels */}
          <text x={ingX2 - 2} y={ingY2 - 5} textAnchor="end" fill={C.green} fontSize="5" fontWeight="700" fontFamily="DM Sans,sans-serif">Ingresos</text>
          <text x={costX2 - 2} y={costY2 - 5} textAnchor="end" fill={C.red} fontSize="5" fontWeight="700" fontFamily="DM Sans,sans-serif">Costo Total</text>

          {/* Axis labels */}
          <text x={pad + innerW / 2} y={pad + innerH + 18} textAnchor="middle" fill={C.dark} fontSize="5.5" fontWeight="700" fontFamily="DM Sans,sans-serif">Unidades vendidas</text>
          <text x={12} y={pad + innerH / 2} textAnchor="middle" fill={C.dark} fontSize="5.5" fontWeight="700" fontFamily="DM Sans,sans-serif" transform={`rotate(-90, 12, ${pad + innerH / 2})`}>Pesos ($)</text>
        </svg>

        {/* Legend */}
        <div style={{ display: "flex", justifyContent: "center", gap: "16px", marginTop: "8px", fontFamily: "'DM Sans',sans-serif", fontSize: "11px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}><div style={{ width: "16px", height: "3px", background: C.green, borderRadius: "2px" }} /><span style={{ color: C.green, fontWeight: 600 }}>Ingresos</span></div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}><div style={{ width: "16px", height: "3px", background: C.red, borderRadius: "2px" }} /><span style={{ color: C.red, fontWeight: 600 }}>Costo Total</span></div>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}><div style={{ width: "16px", height: "3px", background: C.amber, borderRadius: "2px", borderTop: "1px dashed" }} /><span style={{ color: C.amber, fontWeight: 600 }}>Gastos Fijos</span></div>
        </div>
      </Card>

      {/* Live formulas */}
      <Card title="📐 Fórmula en vivo — PE en Unidades">
        <div style={{ fontFamily: "'DM Sans',sans-serif", padding: "12px", borderRadius: "10px", background: "#fdfcfb", border: `1.5px solid ${C.copper}22` }}>
          <div style={{ textAlign: "center", fontSize: "11px", fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "10px" }}>
            Punto de Equilibrio en Unidades
          </div>
          
          {/* Formula template */}
          <div style={{ textAlign: "center", fontSize: "13px", color: C.dark, marginBottom: "12px", fontWeight: 600 }}>
            PE (unidades) = <span style={{ borderBottom: `2px solid ${C.dark}`, paddingBottom: "2px" }}>
              Costos Fijos Totales
            </span>
            <br />
            <span style={{ fontSize: "12px", color: C.muted }}>Precio de Venta − Costo Variable Unitario</span>
          </div>

          {/* Formula with numbers */}
          <div style={{ textAlign: "center", padding: "14px", borderRadius: "8px", background: `${C.copper}08`, marginBottom: "8px" }}>
            <div style={{ fontSize: "12px", color: C.muted, marginBottom: "4px" }}>Reemplazando con tus datos:</div>
            <div style={{ fontSize: "18px", fontWeight: 700, color: C.dark }}>
              PE = <span style={{ borderBottom: `2px solid ${C.amber}`, paddingBottom: "2px" }}>
                <span style={{ color: C.amber }}>{fmt(gastosFijos)}</span>
              </span>
            </div>
            <div style={{ fontSize: "14px", fontWeight: 600, color: C.dark, marginTop: "4px" }}>
              <span style={{ color: C.copper }}>{fmt(precioVenta)}</span>
              <span style={{ color: C.muted }}> − </span>
              <span style={{ color: C.red }}>{fmt(foodCostUnit)}</span>
            </div>
          </div>

          {/* Step by step calc */}
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", padding: "10px", borderRadius: "8px", background: "#fff" }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
              <span style={{ color: C.muted }}>1. Margen Contribución:</span>
              <span style={{ fontWeight: 700 }}>
                <span style={{ color: C.copper }}>{fmt(precioVenta)}</span>
                <span style={{ color: C.muted }}> − </span>
                <span style={{ color: C.red }}>{fmt(foodCostUnit)}</span>
                <span style={{ color: C.dark }}> = </span>
                <span style={{ color: margenContrib > 0 ? C.green : C.red }}>{fmt(margenContrib)}</span>
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}>
              <span style={{ color: C.muted }}>2. PE (unidades):</span>
              <span style={{ fontWeight: 700 }}>
                <span style={{ color: C.amber }}>{fmt(gastosFijos)}</span>
                <span style={{ color: C.dark }}> ÷ </span>
                <span style={{ color: C.green }}>{fmt(margenContrib)}</span>
                <span style={{ color: C.dark }}> = </span>
                <span style={{ color: C.copper, fontSize: "13px" }}>{peUnidades !== Infinity ? `${peUnidades.toLocaleString(CURRENT_LOCALE)} un.` : "N/A"}</span>
              </span>
            </div>
          </div>

          {/* Result highlight */}
          <div style={{ textAlign: "center", marginTop: "10px", padding: "10px", borderRadius: "8px", background: margenContrib > 0 ? C.greenBg : C.redBg, border: `1.5px solid ${margenContrib > 0 ? C.green : C.red}22` }}>
            <span style={{ fontSize: "22px", fontWeight: 700, color: margenContrib > 0 ? C.copper : C.red, fontFamily: "'DM Sans',sans-serif" }}>
              {peUnidades !== Infinity ? `${peUnidades.toLocaleString(CURRENT_LOCALE)} unidades` : "No hay PE"}
            </span>
          </div>
        </div>
      </Card>

      <Card title="📐 Fórmula en vivo — PE en Ventas ($)">
        <div style={{ fontFamily: "'DM Sans',sans-serif", padding: "12px", borderRadius: "10px", background: "#fdfcfb", border: `1.5px solid ${C.blue}22` }}>
          <div style={{ textAlign: "center", fontSize: "11px", fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "10px" }}>
            Punto de Equilibrio en Ventas
          </div>

          {/* Formula template */}
          <div style={{ textAlign: "center", fontSize: "13px", color: C.dark, marginBottom: "12px", fontWeight: 600 }}>
            PE ($) = <span style={{ borderBottom: `2px solid ${C.dark}`, paddingBottom: "2px" }}>
              Costos Fijos Totales
            </span>
            <br />
            <span style={{ fontSize: "12px", color: C.muted }}>1 − (Costos Variables ÷ Ventas Totales)</span>
          </div>

          {/* Simplified as PE units × price */}
          <div style={{ textAlign: "center", padding: "14px", borderRadius: "8px", background: `${C.blue}08`, marginBottom: "8px" }}>
            <div style={{ fontSize: "12px", color: C.muted, marginBottom: "4px" }}>Forma simple:</div>
            <div style={{ fontSize: "14px", fontWeight: 600, color: C.dark }}>
              PE ($) = PE (unidades) × Precio de Venta
            </div>
            <div style={{ fontSize: "16px", fontWeight: 700, color: C.dark, marginTop: "6px" }}>
              <span style={{ color: C.copper }}>{peUnidades !== Infinity ? peUnidades.toLocaleString(CURRENT_LOCALE) : "—"}</span>
              <span style={{ color: C.muted }}> × </span>
              <span style={{ color: C.copper }}>{fmt(precioVenta)}</span>
              <span style={{ color: C.dark }}> = </span>
              <span style={{ color: C.blue, fontSize: "18px" }}>{peVentas !== Infinity ? fmt(peVentas) : "N/A"}</span>
            </div>
          </div>

          {/* Also show the ratio method */}
          <div style={{ padding: "10px", borderRadius: "8px", background: "#fff" }}>
            <div style={{ fontSize: "11px", color: C.muted, marginBottom: "6px", textAlign: "center" }}>O con la fórmula de ratio:</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "4px", fontSize: "12px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ color: C.muted }}>1. FC como % del precio:</span>
                <span style={{ fontWeight: 700 }}>
                  <span style={{ color: C.red }}>{fmt(foodCostUnit)}</span>
                  <span style={{ color: C.dark }}> ÷ </span>
                  <span style={{ color: C.copper }}>{fmt(precioVenta)}</span>
                  <span style={{ color: C.dark }}> = </span>
                  <span style={{ color: C.red }}>{precioVenta > 0 ? (foodCostUnit / precioVenta * 100).toFixed(1) : "—"}%</span>
                </span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ color: C.muted }}>2. 1 − {precioVenta > 0 ? (foodCostUnit / precioVenta * 100).toFixed(1) : "—"}%:</span>
                <span style={{ fontWeight: 700, color: C.green }}>
                  {precioVenta > 0 ? ((1 - foodCostUnit / precioVenta) * 100).toFixed(1) : "—"}%
                </span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ color: C.muted }}>3. PE ($):</span>
                <span style={{ fontWeight: 700 }}>
                  <span style={{ color: C.amber }}>{fmt(gastosFijos)}</span>
                  <span style={{ color: C.dark }}> ÷ </span>
                  <span style={{ color: C.green }}>{precioVenta > 0 ? ((1 - foodCostUnit / precioVenta) * 100).toFixed(1) : "—"}%</span>
                  <span style={{ color: C.dark }}> = </span>
                  <span style={{ color: C.blue, fontSize: "13px" }}>{peVentas !== Infinity ? fmt(gastosFijos / (1 - foodCostUnit / precioVenta)) : "N/A"}</span>
                </span>
              </div>
            </div>
          </div>

          {/* Result highlight */}
          <div style={{ textAlign: "center", marginTop: "10px", padding: "10px", borderRadius: "8px", background: `${C.blue}11`, border: `1.5px solid ${C.blue}22` }}>
            <span style={{ fontSize: "22px", fontWeight: 700, color: C.blue, fontFamily: "'DM Sans',sans-serif" }}>
              {peVentas !== Infinity ? fmt(peVentas) : "No hay PE"}
            </span>
            <div style={{ fontSize: "11px", color: C.muted, marginTop: "2px" }}>en ventas mensuales para no perder</div>
          </div>
        </div>
      </Card>

      {/* Cierre del círculo: margen bruto mínimo */}
      <Card title="🔗 El círculo completo — Margen bruto mínimo mensual">
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, marginBottom: "14px", lineHeight: 1.5 }}>
          En el Punto de Equilibrio pasa algo clave: <strong>tu margen bruto total del mes tiene que igualar tus gastos fijos</strong>. Ese margen bruto es la plata que te queda después de pagar el food cost de cada venta — y es la que va a cubrir arriendo, sueldos, servicios, etc.
        </div>

        {/* Ecuación visual */}
        <div style={{ padding: "14px", borderRadius: "10px", background: `${C.green}08`, border: `1.5px solid ${C.green}33`, marginBottom: "12px", textAlign: "center", fontFamily: "'DM Sans',sans-serif" }}>
          <div style={{ fontSize: "12px", fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "10px" }}>
            La ecuación del equilibrio
          </div>
          <div style={{ fontSize: "15px", color: C.dark, fontWeight: 600, lineHeight: 1.6 }}>
            <span style={{ color: C.green, fontWeight: 700 }}>Margen Bruto Total</span>
            <span style={{ color: C.muted }}> = </span>
            <span style={{ color: C.amber, fontWeight: 700 }}>Gastos Fijos</span>
          </div>
          <div style={{ fontSize: "12px", color: C.muted, marginTop: "4px" }}>
            (ni perdés ni ganás — estás en el equilibrio)
          </div>
        </div>

        {/* Desglose con los números */}
        <div style={{ padding: "12px", borderRadius: "10px", background: "#fff", border: `1px solid ${C.line}`, marginBottom: "10px" }}>
          <div style={{ fontSize: "12px", fontWeight: 700, color: C.copper, textTransform: "uppercase", letterSpacing: "0.06em", fontFamily: "'DM Sans',sans-serif", marginBottom: "10px" }}>
            Con tus datos
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px", fontSize: "12px", fontFamily: "'DM Sans',sans-serif" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: C.muted }}>Margen de contribución por unidad</span>
              <span style={{ fontWeight: 700, color: margenContrib > 0 ? C.green : C.red }}>{fmt(margenContrib)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: C.muted }}>× Unidades en el PE</span>
              <span style={{ fontWeight: 700, color: C.copper }}>{peUnidades !== Infinity ? `${peUnidades.toLocaleString(CURRENT_LOCALE)} un.` : "—"}</span>
            </div>
            <div style={{ borderTop: `1px dashed ${C.line}`, paddingTop: "6px", display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontWeight: 700, color: C.dark }}>= Margen bruto total necesario</span>
              <span style={{ fontWeight: 700, color: C.green }}>
                {peUnidades !== Infinity ? fmt(margenContrib * peUnidades) : "—"}
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginTop: "2px" }}>
              <span style={{ color: C.muted, fontStyle: "italic" }}>que iguala a tus gastos fijos</span>
              <span style={{ fontWeight: 600, color: C.amber }}>{fmt(gastosFijos)}</span>
            </div>
          </div>
        </div>

        {/* Result highlight */}
        <div style={{ padding: "14px", borderRadius: "10px", background: `${C.amber}10`, border: `1.5px solid ${C.amber}44`, textAlign: "center", marginBottom: "10px" }}>
          <div style={{ fontSize: "12px", fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.08em", fontFamily: "'DM Sans',sans-serif", marginBottom: "4px" }}>
            Margen bruto mínimo mensual
          </div>
          <div style={{ fontSize: "26px", fontWeight: 700, color: C.amber, fontFamily: "'DM Sans',sans-serif" }}>
            {fmt(gastosFijos)}
          </div>
          <div style={{ fontSize: "12px", color: C.dark, fontFamily: "'DM Sans',sans-serif", marginTop: "4px", lineHeight: 1.4 }}>
            Menos que esto → pérdida · Exactamente esto → equilibrio · Más → ganancia
          </div>
        </div>

        <div style={{ padding: "10px", borderRadius: "8px", background: C.bg, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, textAlign: "center", lineHeight: 1.5 }}>
          <strong>Regla práctica:</strong> cada peso de margen bruto arriba de <strong style={{ color: C.amber }}>{fmt(gastosFijos)}</strong> se convierte en <strong style={{ color: C.green }}>ganancia operacional</strong>. Ese es el incentivo real a vender más.
        </div>
      </Card>

      {/* Result cards */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "14px" }}>
        <StatCard label="PE Unidades" value={peUnidades !== Infinity ? `${peUnidades.toLocaleString(CURRENT_LOCALE)} un.` : "N/A"} sub="para cubrir costos" color={C.copper} bgColor={`${C.copper}11`} icon="📦" />
        <StatCard label="PE Ventas" value={peVentas !== Infinity ? fmt(peVentas) : "N/A"} sub="en pesos" color={C.blue} bgColor={`${C.blue}11`} icon="💰" />
        <StatCard label="Margen Contrib." value={fmt(margenContrib)} sub={`${margenPct.toFixed(1)}% del precio`} color={margenContrib > 0 ? C.green : C.red} bgColor={margenContrib > 0 ? C.greenBg : C.redBg} icon="📊" />
      </div>

      {/* Explanation */}
      <Card>
        <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: "12px", color: C.dark, textAlign: "center" }}>
          <strong>¿Qué significa?</strong> Necesitás vender al menos <strong style={{ color: C.copper }}>{peUnidades !== Infinity ? `${peUnidades.toLocaleString(CURRENT_LOCALE)} unidades` : "—"}</strong> (o <strong style={{ color: C.blue }}>{peVentas !== Infinity ? fmt(peVentas) : "—"}</strong> en ventas) para cubrir todos tus gastos fijos. Cada unidad por encima de eso es ganancia.
          <br /><span style={{ color: C.muted, fontSize: "11px" }}>Mové los sliders y mirá cómo cambian las fórmulas y el gráfico en tiempo real.</span>
        </div>
      </Card>
    </div>
  );
}


/* ═══════════════════════════════════════════
   MAIN APP WITH TAB NAVIGATION
   ═══════════════════════════════════════════ */
// Widget de preguntas al pie de cada sección: el alumno pregunta en contexto,
// el combo identifica desde qué herramienta pregunta (default: la sección actual).
const askQuestionFn = httpsCallable(functions, "finanzasQuestions");

function SectionQuestions({ tools, active }) {
  const [section, setSection] = useState(active);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(null);
  const [open, setOpen] = useState(false);

  // Al cambiar de sección, resetea el combo a la sección actual y limpia el form.
  useEffect(() => { setSection(active); setText(""); setDone(false); setErr(null); }, [active]);

  const opts = tools.filter(t => !String(t.label).startsWith("──"));

  const submit = async () => {
    if (!text.trim()) return;
    setBusy(true); setErr(null);
    try {
      const label = opts.find(t => t.key === section)?.label || section;
      await askQuestionFn({ action: "ask", subject: label, section, text: text.trim() });
      setText(""); setDone(true);
    } catch (e) { console.error(e); setErr(e?.message || "No se pudo enviar."); }
    finally { setBusy(false); }
  };

  const sans = "'DM Sans',sans-serif";
  return (
    <div style={{ marginTop: "14px", background: C.card, border: `1px solid ${C.line}`, borderRadius: "14px", overflow: "hidden" }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px",
        padding: "13px 16px", border: "none", background: open ? "#fbf7f4" : C.card, cursor: "pointer", textAlign: "left",
      }}>
        <span style={{ display: "flex", alignItems: "center", gap: "8px", fontFamily: sans, fontSize: "13px", fontWeight: 700, color: C.dark }}>
          <span style={{ fontSize: "16px" }}>💬</span> ¿Tenés una duda sobre esta sección?
        </span>
        <span style={{ fontSize: "18px", color: C.copper, lineHeight: 1, fontWeight: 700 }}>{open ? "−" : "+"}</span>
      </button>

      {open && (
        <div style={{ padding: "0 16px 16px" }}>
          <div style={{ fontFamily: sans, fontSize: "12px", color: C.muted, marginBottom: "12px" }}>
            Hacé tu pregunta al profesor. Te responde por mail y la ves en la sección <Link to="/preguntas" style={{ color: C.copperDark }}>Preguntas</Link>.
          </div>

          {done ? (
            <div style={{ background: C.greenBg, color: C.green, borderRadius: "8px", padding: "12px 14px", fontFamily: sans, fontSize: "13px", fontWeight: 600 }}>
              ✅ ¡Pregunta enviada! Te avisamos por mail cuando te respondan. <Link to="/preguntas" style={{ color: C.green, fontWeight: 700 }}>Ver mis preguntas →</Link>
              <button onClick={() => setDone(false)} style={{ marginLeft: "10px", background: "none", border: "none", color: C.muted, cursor: "pointer", fontFamily: sans, fontSize: "12px", fontWeight: 600, textDecoration: "underline" }}>Hacer otra</button>
            </div>
          ) : (
            <>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px", flexWrap: "wrap" }}>
                <label style={{ fontFamily: sans, fontSize: "12px", fontWeight: 600, color: C.muted }}>Sobre:</label>
                <select value={section} onChange={e => setSection(e.target.value)} style={{
                  padding: "7px 10px", border: `1.5px solid ${C.line}`, borderRadius: "8px", background: "#fdfcfb",
                  fontFamily: sans, fontSize: "13px", color: C.dark, outline: "none", cursor: "pointer",
                }}>
                  {opts.map(t => <option key={t.key} value={t.key}>{t.emoji} {t.label}</option>)}
                </select>
              </div>
              <textarea value={text} onChange={e => setText(e.target.value)} rows={3}
                placeholder="Escribí tu duda sobre esta herramienta…"
                style={{
                  width: "100%", padding: "10px 12px", border: `1.5px solid ${C.line}`, borderRadius: "8px",
                  fontFamily: sans, fontSize: "13px", color: C.dark, background: "#fdfcfb", outline: "none", resize: "vertical", boxSizing: "border-box",
                }} />
              {err && <div style={{ color: C.red, fontFamily: sans, fontSize: "12px", marginTop: "6px" }}>{err}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                <button onClick={submit} disabled={busy || !text.trim()} style={{
                  padding: "10px 20px", border: "none", borderRadius: "8px", cursor: busy || !text.trim() ? "not-allowed" : "pointer",
                  fontFamily: sans, fontSize: "13px", fontWeight: 700,
                  background: `linear-gradient(135deg, ${C.copper}, ${C.copperDark})`, color: "#fff", opacity: busy || !text.trim() ? 0.5 : 1,
                }}>{busy ? "Enviando…" : "Enviar pregunta"}</button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

const TOOLS = [
  { key: "curva", label: "Precios", emoji: "📈", component: ToolCurvaPrecios },
  { key: "formulas", label: "Fórmulas", emoji: "📐", component: ToolFormulas },
  { key: "fc", label: "Food Cost", emoji: "🥄", component: ToolFoodCost },
  { key: "pe", label: "Pto. Equil.", emoji: "⚖️", component: ToolPuntoEquilibrio },
  { key: "eerr", label: "EERR", emoji: "📊", component: ToolEERR },
  { key: "cf", label: "Flujo Caja", emoji: "💸", component: ToolFlujoCaja },
  { key: "bal", label: "Balance", emoji: "⚖️", component: ToolBalance },
];

export default function FinanzasApp({ user }) {
  const [active, setActive] = useState("curva");
  const [videos, setVideos] = useState({});
  const [texts, setTexts] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [currency, setCurrency] = useState(() => loadInitialCurrency());
  const changeCurrency = (cur) => {
    // Actualizar vars módulo ANTES de re-render para que fmt() use los nuevos valores
    CURRENT_LOCALE = cur.locale;
    CURRENT_SYMBOL = cur.symbol;
    CURRENT_SCALE = cur.scale || 1;
    CURRENT_DECIMALS = cur.decimals ?? 0;
    try { localStorage.setItem("finanzas_currency", cur.code); } catch (e) {}
    setCurrency(cur);
  };
  const activeTool = TOOLS.find(t => t.key === active);
  const ActiveTool = activeTool.component;
  // Texto activo: override de Firestore o fallback al default
  const activeText = (texts && texts[active]) || DEFAULT_TAB_TEXTS[active] || "";

  useEffect(() => {
    (async () => {
      try {
        const [vSnap, tSnap] = await Promise.all([
          getDoc(doc(db, VIDEOS_COLLECTION, VIDEOS_DOC_ID)),
          getDoc(doc(db, TEXTS_COLLECTION, TEXTS_DOC_ID)),
        ]);
        if (vSnap.exists()) setVideos(vSnap.data());
        if (tSnap.exists()) setTexts(tSnap.data());
      } catch (e) { console.error("Cargar videos/textos:", e); }
    })();
  }, []);

  return (
    <div style={{ fontFamily: "'Libre Baskerville','Georgia',serif", background: C.bg, minHeight: "100vh", display: "flex" }}>
      <MultiCurrencyNotice />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }
        input[type=range]::-webkit-slider-thumb { appearance:none; width:18px; height:18px; border-radius:50%; background:${C.copper}; cursor:pointer; border:2px solid #fff; box-shadow:0 1px 4px rgba(0,0,0,0.2); }
        input[type=range]::-moz-range-thumb { width:18px; height:18px; border-radius:50%; background:${C.copper}; cursor:pointer; border:2px solid #fff; }
        input[type=number]::-webkit-inner-spin-button { opacity:0.3; }
        ::-webkit-scrollbar { width:4px; height:4px; }
        ::-webkit-scrollbar-thumb { background:${C.copperLight}; border-radius:2px; }

        /* Layout grid: mobile = video arriba + main abajo. Desktop = main izquierda + video sticky derecha */
        .finanzas-content-grid {
          display: grid;
          grid-template-areas: "video" "main";
          grid-template-columns: 1fr;
          gap: 14px;
          max-width: 680px;
          margin: 0 auto;
        }
        .finanzas-main { grid-area: main; min-width: 0; }
        .finanzas-video-col { grid-area: video; min-width: 0; }
        @media (min-width: 1100px) {
          .finanzas-content-grid {
            grid-template-areas: "main video";
            grid-template-columns: minmax(0, 1fr) clamp(380px, 36vw, 560px);
            max-width: 1180px;
            gap: 24px;
          }
          /* En desktop, alineamos el video con la card "Sobre esta sección" (que queda
             debajo del título de la página) en vez de con el título. */
          .finanzas-video-col {
            padding-top: 56px;
          }
          .finanzas-video-sticky {
            position: sticky;
            top: 14px;
            max-height: calc(100vh - 28px);
            overflow-y: auto;
          }
        }
        @media (min-width: 1600px) {
          .finanzas-content-grid {
            grid-template-columns: minmax(0, 1fr) clamp(480px, 38vw, 640px);
            max-width: 1320px;
          }
        }

        /* Estilos para HTML dentro de TabDescription (renderizado con dangerouslySetInnerHTML) */
        .tab-description-html p { margin: 0 0 8px 0; }
        .tab-description-html p:last-child { margin-bottom: 0; }
        .tab-description-html ul, .tab-description-html ol { margin: 4px 0 8px 0; padding-left: 22px; }
        .tab-description-html li { margin-bottom: 3px; }
        .tab-description-html a { color: ${C.copper}; }
        .tab-description-html strong { color: ${C.dark}; }
      `}</style>

      {/* Sidebar inline (push content) */}
      <aside style={{
        width: sidebarOpen ? "260px" : "0",
        flexShrink: 0,
        overflow: "hidden",
        transition: "width 0.25s ease",
        position: "sticky", top: 0, alignSelf: "flex-start",
        height: "100vh",
      }}>
        <div style={{
          width: "260px", height: "100%", display: "flex", flexDirection: "column",
          background: C.card, borderRight: `1px solid ${C.line}`,
        }}>
          {/* Header del sidebar */}
          <div style={{
            background: `linear-gradient(135deg, ${C.copperDark}, ${C.copper})`,
            color: "#fff", padding: "16px",
            display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px",
          }}>
            <div style={{ minWidth: 0 }}>
              <h2 style={{ margin: 0, fontSize: "15px", fontWeight: 700 }}>Finanzas & Bonus Track</h2>
              <div style={{ fontSize: "11px", opacity: 0.85, fontFamily: "'DM Sans',sans-serif", marginTop: "2px" }}>
                Herramientas interactivas
              </div>
            </div>
            <button onClick={() => setSidebarOpen(false)} aria-label="Colapsar menú" title="Colapsar"
              style={{
                width: "30px", height: "30px", borderRadius: "8px", border: "none",
                background: "rgba(255,255,255,0.15)", color: "#fff", cursor: "pointer",
                fontSize: "16px", lineHeight: 1, padding: 0, flexShrink: 0,
              }}>‹</button>
          </div>

          <nav style={{ flex: 1, overflowY: "auto", padding: "8px" }}>
            {TOOLS.map(t => {
              const isActive = active === t.key;
              return (
                <button key={t.key} onClick={() => setActive(t.key)} style={{
                  width: "100%", display: "flex", alignItems: "center", gap: "12px",
                  padding: "11px 14px", margin: "2px 0",
                  border: "none", borderRadius: "10px", cursor: "pointer",
                  background: isActive ? `${C.copper}11` : "transparent",
                  color: isActive ? C.copper : C.dark,
                  fontFamily: "'DM Sans',sans-serif", fontSize: "13px", fontWeight: isActive ? 700 : 500,
                  textAlign: "left", transition: "all 0.15s",
                  borderLeft: isActive ? `3px solid ${C.copper}` : "3px solid transparent",
                }}>
                  <span style={{ fontSize: "18px" }}>{t.emoji}</span>
                  <span>{t.label}</span>
                </button>
              );
            })}
          </nav>

          {/* Footer del sidebar */}
          <div style={{ borderTop: `1px solid ${C.line}`, padding: "10px" }}>
            {/* Selector de moneda */}
            <div style={{ padding: "6px 14px 10px 14px" }}>
              <div style={{ fontSize: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: C.muted, fontFamily: "'DM Sans',sans-serif", marginBottom: "4px" }}>
                💱 Moneda
              </div>
              <select value={currency.code} onChange={e => changeCurrency(CURRENCIES[e.target.value])}
                style={{
                  width: "100%", padding: "6px 8px", border: `1.5px solid ${C.line}`, borderRadius: "6px",
                  background: "#fdfcfb", fontFamily: "'DM Sans',sans-serif", fontSize: "12px",
                  color: C.dark, outline: "none", cursor: "pointer",
                }}>
                {Object.values(CURRENCIES).map(c => (
                  <option key={c.code} value={c.code}>{c.flag} {c.symbol} {c.code} — {c.name}</option>
                ))}
              </select>
            </div>
            <Link to="/" style={{
              display: "flex", alignItems: "center", gap: "10px",
              padding: "9px 14px", borderRadius: "10px", textDecoration: "none",
              color: C.muted, fontFamily: "'DM Sans',sans-serif", fontSize: "12px", fontWeight: 600,
              transition: "all 0.15s",
            }}>
              <span style={{ fontSize: "14px" }}>←</span>
              <span>Volver al inicio</span>
            </Link>
            {user && (
              <div style={{ padding: "8px 14px", marginTop: "2px", fontFamily: "'DM Sans',sans-serif", fontSize: "11px", color: C.muted }}>
                <div style={{ fontSize: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "2px" }}>Sesión</div>
                <div style={{ color: C.dark, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.email}</div>
              </div>
            )}
          </div>
        </div>
      </aside>

      {/* Main area */}
      <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        {/* Content centrado en el espacio disponible */}
        <div style={{ flex: 1, padding: "20px 16px 40px" }}>
          <div key={`currency-${currency.code}`} className="finanzas-content-grid">
            <div className="finanzas-main">
              {/* Título de la sección inline */}
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "18px" }}>
                {!sidebarOpen && (
                  <button onClick={() => setSidebarOpen(true)} aria-label="Abrir menú" title="Abrir menú"
                    style={{
                      width: "38px", height: "38px", borderRadius: "10px",
                      border: `1.5px solid ${C.line}`, background: "#fff", color: C.copper, cursor: "pointer",
                      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                      fontSize: "18px", lineHeight: 1, padding: 0,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                    }}>☰</button>
                )}
                <div style={{ fontSize: "32px", flexShrink: 0 }}>{activeTool.emoji}</div>
                <h1 style={{
                  margin: 0, fontSize: "24px", fontWeight: 700, letterSpacing: "-0.02em",
                  color: C.dark, lineHeight: 1.2,
                  fontFamily: "'Libre Baskerville','Georgia',serif",
                }}>{activeTool.label}</h1>
              </div>
              <TabDescription text={activeText} />
              <ActiveTool user={user} />
            </div>
            <div className="finanzas-video-col">
              <div className="finanzas-video-sticky">
                <TutorialVideo videoIdOrUrl={videos[active]} label={activeTool.label} />
                <SectionQuestions tools={TOOLS} active={active} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
